import * as Gu from "vue";
import { defineAsyncComponent as oe, defineComponent as Q, computed as $, openBlock as T, createElementBlock as U, mergeProps as hn, createBlock as ce, resolveDynamicComponent as en, withCtx as ne, unref as v, createCommentVNode as ae, renderSlot as ue, normalizeClass as K, Fragment as Be, renderList as Ye, createElementVNode as F, ref as B, withKeys as Wb, createVNode as se, normalizeStyle as kn, toDisplayString as re, createTextVNode as Ke, onMounted as Ae, onBeforeUnmount as vi, useSlots as Cr, createSlots as ci, useCssVars as Hn, Transition as uc, shallowRef as cc, watch as vt, triggerRef as Vu, onScopeDispose as Hb, onUnmounted as yt, watchEffect as ut, cloneVNode as dc, h as Ge, inject as pt, provide as Ct, reactive as fc, nextTick as xt, toRaw as st, getCurrentInstance as qb, Teleport as Gb, withDirectives as Vb, vShow as Nb, onUpdated as jb, onBeforeMount as vc, withModifiers as Nu, pushScopeId as Kb, popScopeId as Yb } from "vue";
var ft = /* @__PURE__ */ ((n) => (n.xs = "xs", n.sm = "sm", n.md = "md", n.lg = "lg", n.xl = "xl", n.xxl = "xxl", n.xxxl = "xxxl", n["4xl"] = "4xl", n))(ft || {}), Z = /* @__PURE__ */ ((n) => (n.arrowDown = "arrow-down", n.arrowUp = "arrow-up", n.arrowLeft = "arrow-left", n.arrowRight = "arrow-right", n.caretDown = "caret-down", n.caretUp = "caret-up", n.caretLeft = "caret-left", n.caretRight = "caret-right", n.share = "share", n.close = "close", n.menu = "menu", n.cursor = "cursor", n.search = "search", n.clock = "clock", n.plus = "plus", n.minus = "minus", n.download = "download", n.upload = "upload", n.playOutline = "play-outline", n.pauseOutline = "pause-outline", n.settings = "settings", n.grabhandle = "grabhandle", n.bell = "bell", n.chatbubble = "chatbubble", n.document = "document", n.filter = "filter", n.check = "check", n.alert = "alert", n.import = "import", n.export = "export", n.undo = "undo", n.reload = "reload", n.openNew = "open-new", n.lockClose = "lock-close", n.lockOpen = "lock-open", n.print = "print", n.playFill = "play-fill", n.pauseFill = "pause-fill", n.circleCheck = "circle-check", n.dots = "dots", n.none = "none", n.playCircle = "play-circle", n.link = "link", n.x = "x", n.linkedin = "linkedin", n.facebook = "facebook", n))(Z || {});
const Zb = {
  [Z.arrowDown]: oe(() => import("./ArrowDown-Bo7uDWw5.mjs")),
  [Z.arrowUp]: oe(() => import("./ArrowUp-DTyqRNTd.mjs")),
  [Z.arrowLeft]: oe(() => import("./ArrowLeft-CzoOTh_A.mjs")),
  [Z.arrowRight]: oe(() => import("./ArrowRight-za5drsCJ.mjs")),
  [Z.caretDown]: oe(() => import("./CaretDown-DGCr5_YK.mjs")),
  [Z.caretUp]: oe(() => import("./CaretUp-DdnQmohH.mjs")),
  [Z.caretLeft]: oe(() => import("./CaretLeft-rUeUqh8o.mjs")),
  [Z.caretRight]: oe(() => import("./CaretRight-Czywfnw6.mjs")),
  [Z.share]: oe(() => import("./Share-z0dfXhQ4.mjs")),
  [Z.close]: oe(() => import("./Close-BI4PlB0P.mjs")),
  [Z.menu]: oe(() => import("./Menu-4JZbfWDW.mjs")),
  [Z.cursor]: oe(() => import("./Cursor-CL9vK3zP.mjs")),
  [Z.search]: oe(() => import("./Search-JIfK-nZo.mjs")),
  [Z.clock]: oe(() => import("./Clock-C51QCM27.mjs")),
  [Z.plus]: oe(() => import("./Plus-C6y3Gxgx.mjs")),
  [Z.minus]: oe(() => import("./Minus-BiOY0lF3.mjs")),
  [Z.download]: oe(() => import("./Download-BBtSjgor.mjs")),
  [Z.upload]: oe(() => import("./Upload-BrM-gF2M.mjs")),
  [Z.playOutline]: oe(() => import("./PlayOutline-CRCuHNMH.mjs")),
  [Z.pauseOutline]: oe(() => import("./PauseOutline-CujgRt79.mjs")),
  [Z.settings]: oe(() => import("./Settings-Zx62tYaf.mjs")),
  [Z.grabhandle]: oe(() => import("./Grabhandle-CzGLxkWc.mjs")),
  [Z.bell]: oe(() => import("./Bell-Byr4ELKQ.mjs")),
  [Z.chatbubble]: oe(() => import("./Chatbubble-DrhGYShv.mjs")),
  [Z.document]: oe(() => import("./Document-BplYgvsd.mjs")),
  [Z.filter]: oe(() => import("./Filter-rfAQca91.mjs")),
  [Z.check]: oe(() => import("./Check-B7ZSC_xv.mjs")),
  [Z.alert]: oe(() => import("./Alert-BXlekCrN.mjs")),
  [Z.import]: oe(() => import("./Import-D6ltgkyN.mjs")),
  [Z.export]: oe(() => import("./Export-DNIa0G42.mjs")),
  [Z.undo]: oe(() => import("./Undo-DnABSPcZ.mjs")),
  [Z.reload]: oe(() => import("./Reload-WN2ntrtO.mjs")),
  [Z.openNew]: oe(() => import("./OpenNew-BNqzBIls.mjs")),
  [Z.lockClose]: oe(() => import("./LockClose-B-BdZlXh.mjs")),
  [Z.lockOpen]: oe(() => import("./LockOpen-DrCSahLy.mjs")),
  [Z.print]: oe(() => import("./Print-B7SBlasr.mjs")),
  [Z.playFill]: oe(() => import("./PlayFill-C68_e_Fu.mjs")),
  [Z.pauseFill]: oe(() => import("./PauseFill-COGwY1Mt.mjs")),
  [Z.circleCheck]: oe(() => import("./CircleCheck-Bbx6jlZg.mjs")),
  [Z.dots]: oe(() => import("./Dots-Dgp6u5gJ.mjs")),
  [Z.playCircle]: oe(() => import("./PlayCircle-CxVvPown.mjs")),
  [Z.link]: oe(() => import("./Link-DKazNfnB.mjs")),
  [Z.x]: oe(() => import("./X-3t_QaK7b.mjs")),
  [Z.facebook]: oe(() => import("./Facebook-CGmbV7bi.mjs")),
  [Z.linkedin]: oe(() => import("./Linkedin-BtEhbSQz.mjs"))
}, Xb = ["aria-label", "data-test-id"], Jb = /* @__PURE__ */ Q({
  __name: "Icon",
  props: {
    iconName: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      required: !0
    }
  },
  setup(n) {
    const i = {
      xs: "8",
      sm: "14",
      md: "18",
      lg: "20",
      xl: "22",
      xxl: "40",
      xxxl: "48",
      "4xl": "64"
    }, r = n, u = $(() => Zb[r.iconName]), o = $(() => i[r.size]);
    return (c, s) => (T(), U("i", hn({
      role: "img",
      "aria-label": n.iconName,
      class: "nova-icon text-color-neutral-85"
    }, c.$attrs, {
      "data-test-id": `nova-icon-${r.iconName}`
    }), [
      (T(), ce(en(u.value), { size: o.value }, null, 8, ["size"]))
    ], 16, Xb));
  }
}), _e = (n, i) => {
  const r = n.__vccOpts || n;
  for (const [u, o] of i)
    r[u] = o;
  return r;
}, kt = /* @__PURE__ */ _e(Jb, [["__scopeId", "data-v-b2e931b9"]]), Qb = /* @__PURE__ */ Q({
  __name: "Button",
  props: {
    variant: {
      type: String,
      required: !0,
      default: "primary"
    },
    size: {
      type: String,
      required: !0,
      default: "md"
    },
    color: {
      type: String
    },
    spaceVariant: {
      type: String,
      default: "packed"
    },
    iconLeft: {
      type: Boolean
    },
    iconName: {
      type: String,
      default: Z.arrowRight
    },
    iconOnly: {
      type: Boolean
    },
    noIcon: {
      type: Boolean
    },
    href: {
      type: String
    },
    target: {
      type: String,
      validator(n) {
        return ["_self", "_blank"].includes(n);
      },
      default: "_self"
    },
    linkType: {
      type: String,
      default: "button"
    },
    disabled: {
      type: Boolean
    },
    animated: {
      type: Boolean,
      default: !1
    },
    rounded: {
      type: Boolean,
      default: !1
    }
  },
  setup(n) {
    const i = n, r = $(() => i.size), u = $(() => i.iconLeft && !i.noIcon), o = $(() => !i.iconLeft && !i.noIcon), c = $(() => i.animated && !i.iconOnly && !i.iconLeft), s = $(() => i.rounded);
    return (d, g) => (T(), ce(en(n.linkType), hn({
      type: "button",
      href: n.href,
      target: n.href ? n.target : null,
      disabled: n.disabled
    }, d.$attrs, {
      class: [
        "buttonComponent",
        "novaBorder",
        "gap-1",
        "items-center",
        "no-underline",
        i.variant,
        i.size,
        i.color,
        i.spaceVariant,
        c.value ? "animated" : "",
        s.value ? "rounded" : ""
      ]
    }), {
      default: ne(() => [
        u.value ? (T(), ce(v(kt), {
          key: 0,
          size: r.value,
          "icon-name": i.iconName
        }, null, 8, ["size", "icon-name"])) : ae("", !0),
        n.iconOnly ? ae("", !0) : ue(d.$slots, "default", { key: 1 }, void 0, !0),
        o.value ? (T(), ce(v(kt), {
          key: 2,
          size: r.value,
          "icon-name": i.iconName
        }, null, 8, ["size", "icon-name"])) : ae("", !0)
      ]),
      _: 3
    }, 16, ["href", "target", "disabled", "class"]));
  }
}), Xe = /* @__PURE__ */ _e(Qb, [["__scopeId", "data-v-21151e08"]]);
var je = /* @__PURE__ */ ((n) => (n.primary = "primary", n.secondary = "secondary", n.tertiary = "tertiary", n.link = "link", n))(je || {}), di = /* @__PURE__ */ ((n) => (n.packed = "packed", n.spaced = "spaced", n))(di || {}), Ue = /* @__PURE__ */ ((n) => (n.xxl = "xxl", n.xl = "xl", n.lg = "lg", n.md = "md", n.sm = "sm", n.xs = "xs", n))(Ue || {}), We = /* @__PURE__ */ ((n) => (n.red = "red", n.white = "white", n.neutral = "neutral", n))(We || {});
const e0 = {
  key: 2,
  class: "block-button"
}, t0 = /* @__PURE__ */ Q({
  __name: "TextBlock",
  props: {
    blockType: {
      type: String,
      default: "block-one",
      required: !1
    },
    hasColumns: {
      type: Boolean,
      default: !1,
      required: !1
    },
    textColor: {
      type: String,
      default: "text-neutral-80",
      required: !1
    }
  },
  setup(n) {
    return (i, r) => (T(), U("div", {
      class: K([n.blockType, "block-wrapper"])
    }, [
      i.$slots.header ? (T(), U("div", {
        key: 0,
        class: K(["block-header", n.textColor])
      }, [
        ue(i.$slots, "header")
      ], 2)) : ae("", !0),
      i.$slots.content ? (T(), U("div", {
        key: 1,
        class: K([n.hasColumns ? "columns-content" : "", "block-content", n.textColor])
      }, [
        ue(i.$slots, "content")
      ], 2)) : ae("", !0),
      i.$slots.button ? (T(), U("div", e0, [
        ue(i.$slots, "button")
      ])) : ae("", !0)
    ], 2));
  }
}), pc = /* @__PURE__ */ _e(t0, [["__scopeId", "data-v-1f0426c4"]]);
var eo = /* @__PURE__ */ ((n) => (n.blockFBHero = "block-fb-hero", n.blockHero = "block-hero", n.blockOne = "block-one", n.blockTwo = "block-two", n.blockThree = "block-three", n))(eo || {}), il = /* @__PURE__ */ ((n) => (n.aspect4_3 = "aspect-[4/3]", n.aspect16_9 = "aspect-[16/9]", n.aspect1_1 = "aspect-[1/1]", n.aspect3_4 = "aspect-[3/4]", n.aspect3_2 = "aspect-[3/2]", n.aspect2_3 = "aspect-[2/3]", n.auto = "aspect-auto", n))(il || {}), Ha = /* @__PURE__ */ ((n) => (n.eager = "eager", n.lazy = "lazy", n))(Ha || {}), ir = /* @__PURE__ */ ((n) => (n.high = "high", n.low = "low", n.auto = "auto", n))(ir || {}), Mt = /* @__PURE__ */ ((n) => (n.bottom = "object-bottom", n.center = "object-center", n.left = "object-left", n.leftBottom = "object-left-bottom", n.leftTop = "object-left-top", n.right = "object-right", n.rightBottom = "object-right-bottom", n.rightTop = "object-right-top", n.top = "object-top", n))(Mt || {}), Pt = /* @__PURE__ */ ((n) => (n.contain = "object-contain", n.cover = "object-cover", n.fill = "object-fill", n.none = "object-none", n.scaleDown = "object-scale-down", n))(Pt || {});
const n0 = ["src", "alt", "loading", "fetchpriority", "aria-label"], r0 = {
  key: 1,
  class: "image"
}, l0 = ["media", "srcset"], i0 = ["src", "alt", "loading", "fetchpriority", "aria-label"], a0 = /* @__PURE__ */ Q({
  __name: "Image",
  props: {
    noScale: {
      type: Boolean,
      default: !1
    },
    altText: {
      type: String,
      required: !0
    },
    proportion: {
      type: String,
      default: "aspect4_3"
    },
    src: {
      type: String,
      required: !0
    },
    objectPosition: {
      type: String,
      default: Mt.center
    },
    objectFit: {
      type: String,
      default: Pt.cover
    },
    srcSet: {
      type: String,
      default: ""
    },
    isLazy: {
      type: Boolean,
      default: !1
    },
    fetchPriority: {
      type: String,
      default: ir.auto
    },
    imageBorder: {
      type: Boolean
    }
  },
  setup(n) {
    const i = n, r = {
      600: "(max-width: 640px)",
      768: "(max-width: 768px)",
      1024: "(max-width: 1024px)",
      1440: "(max-width: 1440px)",
      2e3: "(min-width: 1441px)"
    }, u = $(() => i.isLazy ? Ha.lazy : Ha.eager), o = $(() => i.src.split("?")[0].toLowerCase().endsWith(".svg"));
    return (c, s) => n.noScale || o.value ? (T(), U("img", {
      key: 0,
      src: `${i.src}`,
      alt: i.altText,
      loading: u.value,
      fetchpriority: i.fetchPriority,
      "aria-label": i.altText,
      class: K(["image", i.objectPosition, i.objectFit, v(il)[i.proportion], i.imageBorder ? "boxShadow" : ""])
    }, null, 10, n0)) : (T(), U("picture", r0, [
      (T(), U(Be, null, Ye(r, (d, g) => F("source", {
        media: `(${d})`,
        srcset: `${i.src}&width=${g}`,
        key: g
      }, null, 8, l0)), 64)),
      F("img", {
        src: `${i.src}`,
        alt: i.altText,
        loading: u.value,
        fetchpriority: i.fetchPriority,
        "aria-label": i.altText,
        class: K(["image", i.objectPosition, i.objectFit, v(il)[i.proportion], i.imageBorder ? "boxShadow" : ""])
      }, null, 10, i0)
    ]));
  }
}), St = /* @__PURE__ */ _e(a0, [["__scopeId", "data-v-39545918"]]);
var kr = /* @__PURE__ */ ((n) => (n.horizontal = "horizontal", n.vertical = "vertical", n))(kr || {}), Bt = /* @__PURE__ */ ((n) => (n.overline = "overline", n.underline = "underline", n.noDivider = "noDivider", n))(Bt || {}), Gt = /* @__PURE__ */ ((n) => (n.xs = "xs", n.sm = "sm", n.md = "md", n.lg = "lg", n.xl = "xl", n))(Gt || {}), o0 = /* @__PURE__ */ ((n) => (n.none = "none", n.bottom = "bottom", n))(o0 || {});
const s0 = /* @__PURE__ */ Q({
  __name: "ListGroup",
  props: {
    orientation: {
      type: String,
      default: "vertical"
    },
    size: {
      type: String,
      default: "md"
    },
    borderStyle: {
      type: String,
      validator: (n) => Object.keys(Bt).includes(n),
      default: "noDivider"
    },
    theme: {
      type: String,
      default: "dark"
    }
  },
  setup(n) {
    const i = n;
    return (r, u) => (T(), U("ul", {
      class: K(["nova-list-group", i.orientation])
    }, [
      ue(r.$slots, "default", {
        borderStyle: i.borderStyle,
        size: i.size,
        theme: i.theme
      }, void 0, !0)
    ], 2));
  }
}), al = /* @__PURE__ */ _e(s0, [["__scopeId", "data-v-d55c4c90"]]);
var hc = /* @__PURE__ */ ((n) => (n.overline = "overline", n.underline = "underline", n.noDivider = "noDivider", n))(hc || {});
const u0 = /* @__PURE__ */ Q({
  __name: "ListItem",
  props: {
    size: {
      type: String,
      default: "md"
    },
    hasIcon: {
      type: Boolean
    },
    iconName: {
      type: String,
      default: Z.check
    },
    borderStyle: {
      type: String,
      validator: (n) => Object.keys(hc).includes(n)
    },
    theme: {
      type: String,
      default: "dark"
    }
  },
  setup(n) {
    const i = {
      xs: ft.sm,
      sm: ft.sm,
      md: ft.sm,
      lg: ft.md,
      xl: ft.lg
    }, r = n, u = {
      dark: "neutral-80",
      mid: "neutral-80",
      light: "neutral-2"
    }, o = $(() => i[r.size]), c = $(() => ({
      [`border-${r.borderStyle}`]: !0,
      [`border-${u[r.theme]}`]: !0,
      [`size-${r.size}`]: !0,
      [`text-${u[r.theme]}`]: !0
    }));
    return (s, d) => (T(), U("li", {
      class: K(["nova-list-item", c.value])
    }, [
      r.hasIcon ? (T(), ce(v(kt), {
        key: 0,
        iconName: n.iconName,
        size: o.value
      }, null, 8, ["iconName", "size"])) : ae("", !0),
      ue(s.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), nr = /* @__PURE__ */ _e(u0, [["__scopeId", "data-v-c6f365d3"]]);
var nl = /* @__PURE__ */ ((n) => (n.Play = "play", n.Pause = "pause", n.Ended = "ended", n))(nl || {});
const c0 = { class: "video-container" }, d0 = { class: "video-player-idle-container" }, f0 = ["poster"], v0 = ["src"], p0 = /* @__PURE__ */ Q({
  __name: "Video",
  props: {
    video: {
      type: Object,
      required: !0,
      default: () => ({
        url: "",
        posterImage: {
          url: ""
        }
      })
    }
  },
  emits: ["play", "pause", "ended"],
  setup(n, { emit: i }) {
    const r = n, u = i, o = B(), c = B(0), s = $(() => r.video && r.video.url ? r.video.url : ""), d = $(() => r.video && r.video.posterImage ? r.video.posterImage.url : ""), g = $(() => o.value && !o.value.paused && !o.value.ended && o.value.readyState > 2);
    function y(z) {
      const Y = (w) => String(w).padStart(2, "0"), D = Math.floor(z / 3600), O = Math.floor(z % 3600 / 60), E = Math.floor(z % 60);
      return `${Y(D)}:${Y(O)}:${Y(E)}`;
    }
    function _() {
      if (o.value && !isNaN(o.value.currentTime) && !isNaN(c.value) && c.value > 0)
        return Math.min(100, o.value.currentTime * 100 / c.value);
    }
    function m() {
      o.value && !g.value && o.value.play();
    }
    function S(z) {
      const Y = _();
      u(z, {
        video_percent: Y !== void 0 ? `${Y.toFixed(2)}%` : "N/A",
        video_duration: y(c.value),
        video_url: s.value
      });
    }
    function k() {
      o.value && (c.value ? (o.value.play(), S(nl.Play)) : o.value.onloadedmetadata = () => {
        var z;
        c.value = ((z = o.value) == null ? void 0 : z.duration) || 0, S(nl.Play);
      });
    }
    function A() {
      (_() === void 0 || !(o.value && o.value.ended)) && S(nl.Pause);
    }
    function L() {
      S(nl.Ended);
    }
    return (z, Y) => (T(), U("div", c0, [
      F("div", d0, [
        F("video", {
          ref_key: "videoEl",
          ref: o,
          class: "video-player",
          "data-video-player": "",
          controls: "",
          controlsList: "nodownload",
          preload: "none",
          poster: d.value,
          type: "video/mp4",
          onClickOnce: m,
          onKeyup: Wb(m, ["space"]),
          onPlay: k,
          onPause: A,
          onEnded: L
        }, [
          F("source", {
            src: s.value,
            type: "video/mp4"
          }, null, 8, v0),
          se(v(St), {
            src: d.value,
            proportion: "aspect16_9",
            "alt-text": "Your browser does not support the <video> tag",
            lazy: ""
          }, null, 8, ["src"])
        ], 40, f0)
      ])
    ]));
  }
}), h0 = /* @__PURE__ */ _e(p0, [["__scopeId", "data-v-5a29bf93"]]);
var Qt = /* @__PURE__ */ ((n) => (n.light = "light", n.dark = "dark", n.mid = "mid", n))(Qt || {}), mc = /* @__PURE__ */ ((n) => (n.light = "text-neutral-80", n.mid = "text-neutral-80 bg-neutral-8", n.dark = "text-neutral-2 bg-neutral-80", n))(mc || {});
const m0 = { class: "section-wrapper" }, g0 = { class: "text-column" }, b0 = {
  class: "img-column",
  tabindex: "-1"
}, y0 = /* @__PURE__ */ Q({
  __name: "FlexibleModule",
  props: {
    theme: {
      type: String,
      default: Qt.light
    },
    imgSrc: {
      type: String,
      required: !1
    },
    imgSrcset: {
      type: String,
      default: ""
    },
    imgFit: {
      type: String,
      default: Pt.cover
    },
    altText: {
      type: String,
      default: ""
    },
    isImageModule: {
      type: Boolean,
      default: !0
    },
    videoItem: {
      type: Object,
      required: !1
    },
    isFullBleed: {
      type: Boolean,
      default: !1
    }
  },
  setup(n) {
    const i = eo.blockOne, r = n, u = r.isFullBleed ? Mt.center : Mt.top, o = {
      light: "text-neutral-80",
      mid: "text-neutral-80",
      dark: "text-neutral-2"
    }, c = {
      light: "bg-white",
      mid: "bg-neutral-8",
      dark: "bg-neutral-80",
      none: ""
    }, s = $(() => c[r.theme]), d = $(() => o[r.theme]), g = $(() => r.isFullBleed && r.isImageModule), y = $(() => r.imgSrc ? r.imgSrc : "");
    return (_, m) => (T(), U("section", {
      class: K(["flexible-section", d.value, s.value, g.value ? "full-bleed-section" : "block-section", n.isImageModule ? "image-block" : "video-block"])
    }, [
      F("div", m0, [
        F("div", g0, [
          se(v(pc), {
            "block-type": v(i),
            "text-color": d.value
          }, {
            header: ne(() => [
              ue(_.$slots, "headerContent", {}, void 0, !0)
            ]),
            content: ne(() => [
              ue(_.$slots, "contentText", {}, void 0, !0)
            ]),
            button: ne(() => [
              ue(_.$slots, "buttonContent", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["block-type", "text-color"])
        ]),
        F("div", b0, [
          n.isImageModule ? (T(), ce(v(St), {
            key: 0,
            src: y.value,
            "src-set": n.imgSrcset,
            "alt-text": n.altText,
            "object-fit": n.imgFit,
            isLazy: !0,
            "object-position": v(u)
          }, null, 8, ["src", "src-set", "alt-text", "object-fit", "object-position"])) : (T(), ce(v(h0), {
            key: 1,
            video: n.videoItem
          }, null, 8, ["video"]))
        ])
      ])
    ], 2));
  }
}), qx = /* @__PURE__ */ _e(y0, [["__scopeId", "data-v-a1d7d86a"]]);
var gc = /* @__PURE__ */ ((n) => (n.backgroundImage = "backgroundImage", n.solid = "solid", n.form = "form", n))(gc || {});
const _0 = { class: "nova-thrasher-wrapper" }, w0 = { class: "nova-thrasher-text" }, x0 = {
  key: 0,
  class: "nova-thrasher-icon"
}, S0 = { class: "nova-thrasher-slot" }, T0 = /* @__PURE__ */ Q({
  __name: "Thrasher",
  props: {
    variant: {
      type: String,
      required: !0,
      default: "solid"
    },
    text: {
      type: String,
      required: !0
    },
    bgImgUrl: {
      type: String,
      required: !1
    },
    hasIcon: {
      type: Boolean,
      required: !0
    },
    fontColor: {
      type: String,
      default: "neutral"
    },
    href: {
      type: String,
      default: ""
    },
    bgColor: {
      type: String,
      default: "neutral"
    },
    thrasherType: {
      type: String,
      default: "a"
    }
  },
  setup(n) {
    const i = n, r = {
      mid: "text-neutral-80",
      light: "text-neutral-2"
    }, u = {
      light: "bg-white",
      mid: "bg-neutral-8",
      dark: "bg-neutral-80",
      none: ""
    }, o = $(() => i.bgImgUrl ? `url(${i.bgImgUrl})` : "");
    return (c, s) => (T(), ce(en(n.thrasherType), {
      href: n.href,
      class: "thrasher-main-container",
      target: "_blank"
    }, {
      default: ne(() => [
        F("div", {
          class: K(["nova-thrasher", v(gc)[i.variant], u[n.bgColor], r[i.fontColor]]),
          style: kn({ "background-image": o.value })
        }, [
          F("div", _0, [
            F("div", w0, [
              F("p", null, re(i.text), 1),
              i.hasIcon ? (T(), U("div", x0, [
                ue(c.$slots, "icon", {}, void 0, !0)
              ])) : ae("", !0)
            ]),
            F("div", S0, [
              ue(c.$slots, "aditionalContent", {}, void 0, !0)
            ])
          ])
        ], 6)
      ]),
      _: 3
    }, 8, ["href"]));
  }
}), Gx = /* @__PURE__ */ _e(T0, [["__scopeId", "data-v-93c91d06"]]);
var Ne = /* @__PURE__ */ ((n) => (n.md = "md", n.lg = "lg", n))(Ne || {}), Fe = /* @__PURE__ */ ((n) => (n.dark = "dark", n.light = "light", n))(Fe || {});
const I0 = ["aria-disabled", "aria-labelledby"], $0 = ["id"], C0 = {
  key: 0,
  class: "input-wrapper__optional"
}, k0 = {
  key: 1,
  class: "input-wrapper__required"
}, O0 = ["id"], E0 = ["id"], A0 = /* @__PURE__ */ Q({
  __name: "InputWrapper",
  props: {
    label: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      required: !0
    },
    error: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      derefault: !1
    },
    optionalText: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: Ne.md
    },
    fieldDescription: {
      type: String,
      default: ""
    },
    focused: {
      type: Boolean,
      default: !1
    },
    theme: {
      type: String,
      default: Fe.light
    },
    readOnly: {
      type: Boolean,
      default: !1
    },
    errorBorder: {
      type: Boolean,
      default: !0
    }
  },
  setup(n) {
    const i = n, r = $(() => !!i.error && !i.disabled && !i.readOnly);
    return (u, o) => (T(), U("fieldset", {
      class: K(["input-wrapper", {
        "input-wrapper--disabled": n.disabled,
        "input-wrapper--md": n.size === v(Ne).md,
        "input-wrapper--lg": n.size === v(Ne).lg,
        "input-wrapper--focused": n.focused,
        "input-wrapper--dark": n.theme === v(Fe).dark,
        "input-wrapper--light": n.theme === v(Fe).light
      }]),
      "aria-disabled": n.disabled || n.readOnly,
      "aria-labelledby": `${i.name}-label`
    }, [
      n.label ? (T(), U("legend", {
        key: 0,
        id: `${i.name}-label`,
        class: "input-wrapper__label"
      }, [
        Ke(re(n.label) + " ", 1),
        n.required ? (T(), U("span", k0, " * ")) : (T(), U("span", C0, re(n.optionalText), 1))
      ], 8, $0)) : ae("", !0),
      ue(u.$slots, "input", {}, void 0, !0),
      r.value ? (T(), U("p", {
        key: 1,
        id: `${i.name}-error`,
        class: K(["input-wrapper__error", { "input-wrapper__error--border": n.errorBorder }]),
        role: "alert"
      }, re(n.error), 11, O0)) : ae("", !0),
      n.fieldDescription && !i.error ? (T(), U("p", {
        key: 2,
        id: `${i.name}-description`,
        class: "input-wrapper__description"
      }, re(n.fieldDescription), 9, E0)) : ae("", !0)
    ], 10, I0));
  }
}), pi = /* @__PURE__ */ _e(A0, [["__scopeId", "data-v-f16d298a"]]);
var Sr = /* @__PURE__ */ ((n) => (n.radio = "radio", n.checkbox = "checkbox", n))(Sr || {});
const L0 = ["for"], R0 = { class: "input-group__input" }, D0 = ["value", "id", "checked", "onChange", "disabled", "name", "type"], P0 = /* @__PURE__ */ Q({
  __name: "InputGroup",
  props: {
    modelValue: { type: [String, Number, Boolean, Object, Array], default: () => [] },
    options: { default: () => [] },
    label: { default: "" },
    disabled: { type: Boolean, default: !1 },
    size: { default: Ne.md },
    name: { default: "input-group" },
    error: { default: "" },
    required: { type: Boolean, default: !1 },
    optionalText: { default: "" },
    fieldDescription: { default: "" },
    focused: { type: Boolean, default: !1 },
    horizontal: { type: Boolean, default: !1 },
    readOnly: { type: Boolean, default: !1 },
    theme: { default: Fe.light },
    type: { default: Sr.radio }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: i }) {
    const r = n, u = i, o = (g, y) => `input-${r.type}-${g}-${y}`, c = B([]), s = $(() => (g) => Array.isArray(r.modelValue) ? r.modelValue.includes(g.value) : r.modelValue === g.value), d = (g) => {
      if (r.type === Sr.radio)
        c.value = [g], u("update:modelValue", g);
      else if (r.type === Sr.checkbox) {
        let y = Array.isArray(r.modelValue) ? [...r.modelValue] : [];
        const _ = y.indexOf(g);
        _ !== -1 ? y.splice(_, 1) : y.push(g), c.value = y, u("update:modelValue", y);
      }
    };
    return (g, y) => (T(), ce(v(pi), {
      label: g.label,
      name: g.name,
      error: g.error,
      disabled: g.disabled,
      "optional-text": g.optionalText,
      "field-description": g.fieldDescription,
      focused: g.focused,
      size: g.size,
      theme: g.theme,
      required: g.required,
      "read-only": g.readOnly
    }, {
      input: ne(() => [
        F("fieldset", {
          class: K(["input-group", {
            "input-group--radio": g.type === v(Sr).radio,
            "input-group--checkbox": g.type === v(Sr).checkbox,
            "input-group--horizontal": g.horizontal,
            "input-group--read-only": g.readOnly,
            "input-group--light": g.theme === v(Fe).light,
            "input-group--dark": g.theme === v(Fe).dark
          }])
        }, [
          (T(!0), U(Be, null, Ye(g.options, (_, m) => (T(), U("label", {
            class: K(["input-group__input-label", {
              "input-group__input-label--md": g.size === v(Ne).md,
              "input-group__input-label--lg": g.size === v(Ne).lg,
              "input-group__input-label--disabled": g.disabled,
              "input-group__input-label--read-only": g.readOnly
            }]),
            for: o(r.name, _.value),
            key: `input-group-${m}`
          }, [
            F("span", R0, [
              F("input", {
                value: _.value,
                id: o(r.name, _.value),
                checked: s.value(_),
                onChange: (S) => d(_.value),
                disabled: g.disabled || g.readOnly,
                name: g.name,
                type: g.type
              }, null, 40, D0)
            ]),
            Ke(" " + re(_.label), 1)
          ], 10, L0))), 128))
        ], 2)
      ]),
      _: 1
    }, 8, ["label", "name", "error", "disabled", "optional-text", "field-description", "focused", "size", "theme", "required", "read-only"]));
  }
}), Vx = /* @__PURE__ */ _e(P0, [["__scopeId", "data-v-b90db566"]]), ri = {
  glass: "backdrop-blur-sm bg-neutral-80/30 bg-cover bg-blend-multiply",
  red: "bg-red-50 text-neutral-2"
}, li = {
  light: "bg-white",
  mid: "bg-neutral-8",
  dark: "bg-neutral-80"
}, B0 = { class: "max-w-8xl m-auto md:px-6 xl:px-8 gap-6 sm:gap-0 px-4 pb-[80px] pt-2 sm:p-0 flex flex-wrap sm:flex-nowrap" }, M0 = { class: "left basis-full sm:basis-1/3 sm:min-h-[330px] pt-3 pr-4.5" }, F0 = {
  key: 0,
  class: "t-title-sm"
}, z0 = /* @__PURE__ */ Q({
  __name: "Collaborate",
  props: {
    title: {},
    image: {},
    rightBlock: {},
    midBlock: {},
    theme: { default: "light" }
  },
  setup(n) {
    const i = n, r = B(!1), u = B(null), o = $(() => (li == null ? void 0 : li[i.theme]) ?? li.light), c = (m) => {
      const S = m != null && m.color ? ri == null ? void 0 : ri[m == null ? void 0 : m.color] : ri.glass, k = m != null && m.title ? "text-left border-0 cursor-pointer group min-h-[200px] sm:min-h-[330px] basis-full sm:basis-1/3 text-neutral-2 flex flex-col justify-between p-4.5 pt-3" : "sm:basis-1/3 hidden sm:block bg-transparent border-0";
      return m != null && m.title ? [S, k] : [k];
    }, s = (m) => (m == null ? void 0 : m.color) !== "red" && u.value === "mobile" ? y.value : null, d = (m) => {
      var k, A, L;
      const S = ((k = m == null ? void 0 : m.cta) == null ? void 0 : k.typeOfCta) === "link";
      return {
        ...m,
        class: c(m),
        style: s(m),
        is: S ? "a" : "button",
        href: S ? (A = m == null ? void 0 : m.cta) == null ? void 0 : A.link : void 0,
        target: S ? (L = m == null ? void 0 : m.cta) == null ? void 0 : L.openTabLink : void 0
      };
    }, g = $(() => {
      const m = d(i.midBlock ?? {}), S = d(i.rightBlock ?? {});
      return [m, S];
    }), y = $(() => {
      let m = i == null ? void 0 : i.image;
      return m += `?width=${r.value ? "600" : "1440"}`, m ? `background-image: url(${m})` : "background: none";
    });
    Ae(() => {
      _(), window.addEventListener("resize", _);
    }), vi(() => window.removeEventListener("resize", _));
    function _() {
      r.value = window.innerWidth < 640, u.value = window.innerWidth < 640 ? "mobile" : "desktop";
    }
    return (m, S) => (T(), U("section", {
      class: K(["bg-cover bg-no-repeat bg-center", o.value]),
      style: kn(u.value === "desktop" && y.value)
    }, [
      F("div", B0, [
        F("div", M0, [
          F("h2", {
            class: K(["t-title-md", m.theme === "dark" ? "text-neutral-2" : null])
          }, re(m.title), 3)
        ]),
        (T(!0), U(Be, null, Ye(g.value, (k) => (T(), ce(en(k.is), hn({
          key: k.title,
          ref_for: !0
        }, k, {
          onClick: (A) => m.$emit("blockClick", (k == null ? void 0 : k.cta) ?? {})
        }), {
          default: ne(() => [
            k != null && k.title ? (T(), U("h2", F0, re(k == null ? void 0 : k.title), 1)) : ae("", !0),
            k != null && k.title && (k != null && k.cta) ? (T(), ce(v(kt), {
              key: 1,
              size: v(ft).xxl,
              "icon-name": v(Z).arrowRight,
              class: "pt-7 transition-[transform] ease-out duration-300 group-hover:translate-x-[6px]"
            }, null, 8, ["size", "icon-name"])) : ae("", !0)
          ]),
          _: 2
        }, 1040, ["onClick"]))), 128))
      ])
    ], 6));
  }
}), Nx = /* @__PURE__ */ _e(z0, [["__scopeId", "data-v-2625297c"]]), U0 = {
  brand: ["ctaGroup", "oEmbed"],
  product: ["ctaGroup", "oEmbed"],
  allText: ["ctaGroup", "itemList"],
  wide: ["details", "ctaGroup", "logo"],
  campaign: ["details", "ctaGroup", "logo"],
  wideText: ["logo", "details", "ctaGroup", "aditionalContent"],
  research: ["logo", "details", "ctaGroup", "aditionalContent"]
};
oe(() => import("./index-CTidbLNL.mjs")), oe(() => import("./index-CIG_tbf2.mjs")), oe(() => import("./index-BEqzAnNk.mjs")), oe(() => import("./index-DnE58hZL.mjs")), oe(() => import("./index-DnE58hZL.mjs")), oe(() => import("./index-Bp8T5hD9.mjs")), oe(() => import("./index-Bp8T5hD9.mjs"));
const W0 = ["innerHTML"], H0 = /* @__PURE__ */ Q({
  __name: "RichText",
  props: {
    textContent: {
      type: String,
      required: !0,
      default: ""
    }
  },
  setup(n) {
    return (i, r) => (T(), U("div", {
      class: "rich-text",
      innerHTML: n.textContent
    }, null, 8, W0));
  }
}), Or = /* @__PURE__ */ _e(H0, [["__scopeId", "data-v-d8975ad8"]]), q0 = { class: "half-text" }, G0 = { class: "t-display-md" }, V0 = { class: "flex flex-col gap-6" }, N0 = { class: "cta-group" }, j0 = {
  class: /* @__PURE__ */ K(["half-image"])
}, K0 = /* @__PURE__ */ Q({
  __name: "BrandHero",
  props: {
    title: {
      type: String,
      default: "Placeholder title"
    },
    isBG: {
      type: Boolean,
      default: !1
    },
    image: {
      type: String,
      default: ""
    },
    srcSet: {
      type: String,
      default: ""
    },
    imgAltText: {
      type: String,
      default: "Placeholder Image Text"
    },
    copy: {
      type: String,
      default: ""
    },
    theme: {
      type: String,
      default: Qt.light
    },
    themingClasses: {
      type: String,
      default: ""
    },
    proportion: {
      type: String,
      default: "aspect4_3"
    }
  },
  setup(n) {
    const i = Cr(), r = n, u = Mt.center, o = r.isBG ? Pt.fill : Pt.cover, c = $(() => ({
      [Qt.light]: "gradient-overlay-bg--light",
      [Qt.dark]: "gradient-overlay-bg--dark",
      [Qt.mid]: "gradient-overlay-bg--mid"
    })[r.theme]), s = $(() => ({
      "--bg-image": `url(${r.image})`,
      "--start": "31%",
      "--end": "74%",
      "--direction": "90deg"
    })), d = $(() => {
      var g;
      return i.oEmbed && ((g = i.oEmbed()[0].children) == null ? void 0 : g.length) > 0;
    });
    return (g, y) => (T(), U("section", hn(g.$attrs, {
      class: ["hero-half-image", n.isBG && !d.value ? "hero-bg" : "", n.themingClasses]
    }), [
      F("div", q0, [
        F("h1", G0, re(n.title), 1),
        F("div", V0, [
          se(v(Or), {
            class: "copy t-title-sm",
            "text-content": n.copy
          }, null, 8, ["text-content"]),
          F("div", N0, [
            ue(g.$slots, "ctaGroup", {}, void 0, !0)
          ])
        ])
      ]),
      F("div", j0, [
        d.value ? (T(), U("div", {
          key: 0,
          class: K(["hero__oembed", [v(Mt).center, v(Pt).contain, v(il)[r.proportion]]])
        }, [
          ue(g.$slots, "oEmbed", {}, void 0, !0)
        ], 2)) : n.image ? (T(), ce(v(St), {
          key: 1,
          class: "hero-image",
          src: n.image,
          "src-set": n.srcSet,
          altText: n.imgAltText,
          "fetch-priority": v(ir).high,
          objectFit: v(o),
          objectPosition: v(u),
          proportion: n.proportion
        }, null, 8, ["src", "src-set", "altText", "fetch-priority", "objectFit", "objectPosition", "proportion"])) : ae("", !0),
        n.isBG && !d.value ? (T(), U("div", {
          key: 2,
          class: K(["gradient-overlay-bg", c.value]),
          style: kn(s.value)
        }, null, 6)) : ae("", !0)
      ])
    ], 16));
  }
}), Y0 = /* @__PURE__ */ _e(K0, [["__scopeId", "data-v-fcdce822"]]), Z0 = { class: "one-third-text" }, X0 = { class: "cta-group" }, J0 = { class: "two-thirds-image" }, Q0 = /* @__PURE__ */ Q({
  __name: "ProductHero",
  props: {
    title: {
      type: String,
      default: "Placeholder title"
    },
    isBG: {
      type: Boolean,
      default: !1
    },
    image: {
      type: String,
      default: ""
    },
    srcSet: {
      type: String,
      default: ""
    },
    imgAltText: {
      type: String,
      default: "Placeholder Image Text"
    },
    copy: {
      type: String,
      default: ""
    },
    themingClasses: {
      type: String,
      default: ""
    },
    proportion: {
      type: String,
      default: "aspect4_3"
    }
  },
  setup(n) {
    const i = Cr(), r = n, u = $(() => {
      var o;
      return i.oEmbed && ((o = i.oEmbed()[0].children) == null ? void 0 : o.length) > 0;
    });
    return (o, c) => (T(), U("section", {
      class: K(["hero-two-thirds-image", n.themingClasses])
    }, [
      F("div", Z0, [
        F("h1", null, re(n.title), 1),
        se(v(Or), {
          class: "copy",
          "text-content": n.copy
        }, null, 8, ["text-content"]),
        F("div", X0, [
          ue(o.$slots, "ctaGroup", {}, void 0, !0)
        ])
      ]),
      F("div", J0, [
        u.value ? (T(), U("div", {
          key: 0,
          class: K(["hero__oembed", [v(Mt).center, v(Pt).contain, v(il)[r.proportion]]])
        }, [
          ue(o.$slots, "oEmbed", {}, void 0, !0)
        ], 2)) : (T(), ce(v(St), {
          key: 1,
          src: n.image,
          "src-set": n.srcSet,
          "alt-text": n.imgAltText,
          "fetch-priority": v(ir).high,
          proportion: n.proportion,
          objectFit: v(Pt).contain,
          "object-position": v(Mt).center
        }, null, 8, ["src", "src-set", "alt-text", "fetch-priority", "proportion", "objectFit", "object-position"]))
      ])
    ], 2));
  }
}), ey = /* @__PURE__ */ _e(Q0, [["__scopeId", "data-v-a1dc96b1"]]), ty = { class: "hero-text" }, ny = {
  key: 0,
  class: "hero-icon"
}, ry = { class: "cta-group" }, ly = { class: "hero-list" }, iy = /* @__PURE__ */ Q({
  __name: "TextOnly",
  props: {
    title: {
      type: String,
      default: "Placeholder title"
    },
    isBG: {
      type: Boolean,
      default: !1
    },
    image: {
      type: String,
      default: "",
      required: !1
    },
    srcSet: {
      type: String,
      default: ""
    },
    imgAltText: {
      type: String,
      default: "Placeholder Image Text"
    },
    copy: {
      type: String,
      default: ""
    },
    themingClasses: {
      type: String,
      default: ""
    }
  },
  setup(n) {
    return (i, r) => (T(), U("section", {
      class: K(["text-hero", n.themingClasses])
    }, [
      F("div", ty, [
        n.image || n.srcSet ? (T(), U("div", ny, [
          se(v(St), {
            src: n.image,
            "no-scale": "",
            "src-set": n.srcSet,
            "fetch-priority": v(ir).high,
            "alt-text": n.imgAltText
          }, null, 8, ["src", "src-set", "fetch-priority", "alt-text"])
        ])) : ae("", !0),
        F("h1", null, re(n.title), 1),
        se(v(Or), {
          class: "copy",
          "text-content": n.copy
        }, null, 8, ["text-content"]),
        F("div", ry, [
          ue(i.$slots, "ctaGroup", {}, void 0, !0)
        ])
      ]),
      F("div", ly, [
        ue(i.$slots, "itemList", {}, void 0, !0)
      ])
    ], 2));
  }
}), ay = /* @__PURE__ */ _e(iy, [["__scopeId", "data-v-f20e4b60"]]), oy = { class: "hero-wrapper" }, sy = { class: "info" }, uy = { class: "main-info" }, cy = { class: "details-info" }, dy = { class: "details" }, fy = { class: "cta-group" }, vy = { class: "main-logo" }, py = /* @__PURE__ */ Q({
  __name: "WideHero",
  props: {
    variant: {
      type: String,
      default: "wide"
    },
    title: {
      type: String,
      default: "Placeholder title"
    },
    isBG: {
      type: Boolean,
      default: !1
    },
    image: {
      type: String,
      default: ""
    },
    srcSet: {
      type: String,
      default: ""
    },
    imgAltText: {
      type: String,
      default: "Placeholder Image Text"
    },
    copy: {
      type: String,
      default: ""
    },
    theme: {
      type: String,
      default: Qt.dark
    },
    themingClasses: {
      type: String,
      default: ""
    }
  },
  setup(n) {
    const i = n, r = Mt.center, u = {
      "--start": "31%",
      "--end": "74%",
      "--direction": "90deg"
    }, o = $(() => ({
      [Qt.light]: "gradient-overlay-bg--light",
      [Qt.dark]: "gradient-overlay-bg--dark",
      [Qt.mid]: "gradient-overlay-bg--mid"
    })[i.theme]);
    return (c, s) => (T(), U("section", {
      class: K(["wide-hero", n.variant, n.themingClasses])
    }, [
      se(v(St), {
        src: n.image,
        "src-set": n.srcSet,
        "alt-text": n.imgAltText,
        "fetch-priority": v(ir).high,
        objectFit: v(Pt).cover,
        objectPosition: v(r)
      }, null, 8, ["src", "src-set", "alt-text", "fetch-priority", "objectFit", "objectPosition"]),
      n.isBG ? (T(), U("div", {
        key: 0,
        class: K(["gradient-overlay-bg", o.value]),
        style: u
      }, null, 2)) : ae("", !0),
      F("div", oy, [
        F("div", sy, [
          F("div", uy, [
            F("h1", null, re(n.title), 1),
            se(v(Or), {
              class: "copy",
              "text-content": n.copy
            }, null, 8, ["text-content"])
          ]),
          F("div", cy, [
            F("div", dy, [
              ue(c.$slots, "details")
            ]),
            F("div", fy, [
              ue(c.$slots, "ctaGroup")
            ])
          ])
        ]),
        F("div", vy, [
          ue(c.$slots, "logo")
        ])
      ])
    ], 2));
  }
}), ju = /* @__PURE__ */ _e(py, [["__scopeId", "data-v-24712b23"]]), hy = { class: "hero-wrapper" }, my = { class: "hero-text" }, gy = { class: "main-logo" }, by = { class: "details" }, yy = { class: "cta-group" }, _y = { class: "aditional-content" }, wy = /* @__PURE__ */ Q({
  __name: "WideTextHero",
  props: {
    variant: {
      type: String,
      default: "wideText"
    },
    title: {
      type: String,
      default: "Placeholder title"
    },
    isBG: {
      type: Boolean,
      default: !1
    },
    image: {
      type: String,
      default: ""
    },
    srcSet: {
      type: String,
      default: ""
    },
    imgAltText: {
      type: String,
      default: "Placeholder Image Text"
    },
    copy: {
      type: String,
      default: ""
    },
    themingClasses: {
      type: String,
      default: ""
    },
    proportion: {
      type: String,
      default: "aspect4_3"
    }
  },
  setup(n) {
    const i = Mt.center;
    return (r, u) => (T(), U("section", {
      class: K(["wide-text-hero", n.variant, n.themingClasses])
    }, [
      n.image ? (T(), ce(v(St), {
        key: 0,
        src: n.image,
        "src-set": n.srcSet,
        "alt-text": n.imgAltText,
        "fetch-priority": v(ir).high,
        "object-fit": v(Pt).cover,
        "object-position": v(i),
        proportion: n.proportion
      }, null, 8, ["src", "src-set", "alt-text", "fetch-priority", "object-fit", "object-position", "proportion"])) : ae("", !0),
      F("div", hy, [
        F("div", my, [
          F("div", gy, [
            ue(r.$slots, "logo")
          ]),
          F("h1", null, re(n.title), 1),
          se(v(Or), {
            class: "copy",
            "text-content": n.copy
          }, null, 8, ["text-content"]),
          F("div", by, [
            ue(r.$slots, "details")
          ]),
          F("div", yy, [
            ue(r.$slots, "ctaGroup")
          ])
        ]),
        F("div", _y, [
          ue(r.$slots, "aditionalContent")
        ])
      ])
    ], 2));
  }
}), Ku = /* @__PURE__ */ _e(wy, [["__scopeId", "data-v-11bcfd5a"]]), jx = /* @__PURE__ */ Q({
  __name: "Hero",
  props: {
    variant: {
      type: String,
      default: "brand",
      required: !0
    },
    title: {
      type: String,
      default: "Placeholder title"
    },
    isBG: {
      type: Boolean,
      default: !1
    },
    image: {
      type: String,
      default: ""
    },
    srcSet: {
      type: String,
      default: ""
    },
    imgAltText: {
      type: String,
      default: "Placeholder Image Text"
    },
    copy: {
      type: String,
      default: ""
    },
    theme: {
      type: String,
      default: Qt.light
    },
    proportion: {
      type: String,
      default: "aspect4_3"
    }
  },
  setup(n) {
    const i = {
      brand: Y0,
      product: ey,
      allText: ay,
      wide: ju,
      campaign: ju,
      wideText: Ku,
      research: Ku
    }, r = n, u = $(() => mc[r.theme]);
    return (o, c) => (T(), ce(en(i[r.variant]), hn(r, { "theming-classes": u.value }), ci({ _: 2 }, [
      Ye(v(U0)[r.variant], (s, d) => ({
        name: s,
        fn: ne(() => [
          ue(o.$slots, s, { key: s })
        ])
      }))
    ]), 1040, ["theming-classes"]));
  }
}), xy = {
  key: 0,
  class: "card-flag-container"
}, Sy = { class: "card-flag" }, Ty = {
  key: 1,
  class: "flex justify-between gap-4.5"
}, Iy = { class: "flex-col grow mb-1" }, $y = { class: "card-eyebrow" }, Cy = { class: "t-title-sm card-title" }, ky = { class: "card-icon" }, Oy = {
  key: 2,
  class: "flex-col"
}, Ey = { class: "flex justify-between mb-1" }, Ay = {
  key: 4,
  class: "card-content-gap"
}, Ly = /* @__PURE__ */ Q({
  __name: "Card",
  props: {
    cardImageSrc: {
      type: String,
      default: ""
    },
    cardImageSrcSet: {
      type: String,
      default: ""
    },
    iconImageSrc: {
      type: String,
      default: ""
    },
    cardHref: {
      type: String
    },
    cardTarget: {
      type: String,
      validator(n) {
        return ["_self", "_blank"].includes(n);
      }
    },
    isLazy: {
      type: Boolean
    },
    hasOverline: {
      type: Boolean
    },
    height: {
      type: String,
      default: "auto"
    },
    contentType: {
      type: String,
      required: !0,
      default: "none"
    },
    descriptionAlign: {
      type: String,
      required: !0,
      default: "bottom"
    },
    graphicType: {
      type: String || null,
      default: "none"
    },
    noImage: {
      type: Boolean
    },
    timerText: {
      type: String
    },
    flagText: {
      type: String
    },
    ctaAlign: {
      type: String,
      default: "none"
    },
    altText: {
      type: String,
      default: "Card Image"
    },
    cardImageBorder: {
      type: Boolean
    },
    backgroundConfig: {
      type: Object,
      default: () => ({
        isActive: !1,
        gradientDirection: "to top",
        startColor: "",
        endColor: "",
        textColor: "light",
        image: "",
        isLazy: !1
      })
    },
    showGap: {
      default: !0,
      type: Boolean
    }
  },
  setup(n) {
    Hn((S) => ({
      "13c5f13d": m.backgroundConfig.gradientDirection,
      "2df670d3": m.backgroundConfig.startColor,
      "3fe3147a": m.backgroundConfig.endColor,
      "229722da": m.height
    }));
    const i = {
      dark: "text-neutral-80",
      mid: "text-neutral-80",
      light: "text-neutral-2"
    }, r = (S) => {
      try {
        return !!new URL(S);
      } catch {
        return !1;
      }
    }, u = (S) => typeof S == "string" && S.length > 0, o = $(() => r(m == null ? void 0 : m.iconImageSrc)), c = $(() => r(m.cardImageSrc)), s = $(() => u((m == null ? void 0 : m.timerText) || "")), d = $(() => u((m == null ? void 0 : m.flagText) || "")), g = $(() => {
      var S;
      return i[((S = m == null ? void 0 : m.backgroundConfig) == null ? void 0 : S.textColor) || "dark"];
    }), y = (S, k, A) => S === "outline" && !k && A ? "card-outline-image" : "", _ = $(() => m.backgroundConfig.textColor === "light" ? "border-neutral-2" : "border-neutral-30"), m = n;
    return (S, k) => {
      var A;
      return T(), U("div", {
        class: K(["card-container", `card-container-${n.contentType}`])
      }, [
        (A = n.backgroundConfig) != null && A.image && n.backgroundConfig.image !== "" ? (T(), ce(v(St), {
          key: 0,
          class: "card-container-background",
          src: n.backgroundConfig.image,
          "alt-text": "",
          "object-fit": v(Pt).cover,
          "object-position": v(Mt).center,
          "is-lazy": n.isLazy
        }, null, 8, ["src", "object-fit", "object-position", "is-lazy"])) : ae("", !0),
        (T(), ce(en(n.cardHref ? "a" : "article"), hn({ class: "card-component" }, S.$attrs, {
          href: n.cardHref,
          target: n.cardHref ? n.cardTarget : null
        }), {
          default: ne(() => [
            !n.noImage && c.value ? (T(), ce(v(St), {
              key: 0,
              class: "card-image",
              src: n.cardImageSrc,
              "src-set": n.cardImageSrcSet,
              proportion: "aspect3_2",
              "is-lazy": n.isLazy,
              "alt-text": n.altText,
              "image-border": n.cardImageBorder
            }, null, 8, ["src", "src-set", "is-lazy", "alt-text", "image-border"])) : ae("", !0),
            F("section", {
              class: K([
                "card-content",
                `card-${n.contentType}`,
                `card-identifier-${n.graphicType || "none"}`,
                y(n.contentType, n.noImage, c.value),
                g.value,
                _.value,
                { hasOverline: n.hasOverline }
              ])
            }, [
              d.value && n.graphicType === "flag" ? (T(), U("div", xy, [
                F("div", Sy, re(n.flagText), 1)
              ])) : ae("", !0),
              o.value && n.graphicType === "icon" ? (T(), U("div", Ty, [
                F("div", Iy, [
                  F("header", $y, [
                    ue(S.$slots, "card-eyebrow", {}, void 0, !0)
                  ]),
                  F("h3", Cy, [
                    ue(S.$slots, "card-title", {}, void 0, !0)
                  ])
                ]),
                F("div", ky, [
                  se(v(St), {
                    proportion: "aspect1_1",
                    src: n.iconImageSrc,
                    "is-lazy": n.isLazy,
                    "alt-text": n.altText,
                    "no-scale": ""
                  }, null, 8, ["src", "is-lazy", "alt-text"])
                ])
              ])) : (T(), U("div", Oy, [
                F("div", Ey, [
                  F("header", {
                    class: K(["card-eyebrow", g.value])
                  }, [
                    ue(S.$slots, "card-eyebrow", {}, void 0, !0)
                  ], 2),
                  s.value && n.graphicType === "timer" ? (T(), U("div", {
                    key: 0,
                    class: K(["card-timer", g.value])
                  }, [
                    se(v(kt), {
                      size: v(ft).sm,
                      iconName: v(Z).clock
                    }, null, 8, ["size", "iconName"]),
                    Ke(" " + re(n.timerText), 1)
                  ], 2)) : ae("", !0)
                ]),
                F("h3", {
                  class: K(["t-title-sm card-title", g.value])
                }, [
                  ue(S.$slots, "card-title", {}, void 0, !0)
                ], 2)
              ])),
              S.$slots["card-description"] && S.$slots["card-description"]({}).length > 0 ? (T(), U("div", {
                key: 3,
                class: K([`card-description__${n.descriptionAlign}`, "card-description", g.value])
              }, [
                ue(S.$slots, "card-description", {}, void 0, !0)
              ], 2)) : ae("", !0),
              n.showGap ? (T(), U("span", Ay)) : ae("", !0),
              S.$slots["card-ctas"] && S.$slots["card-ctas"]({}).length > 0 ? (T(), U("div", {
                key: 5,
                class: K([`card-cta__${n.ctaAlign}`, "card-cta"])
              }, [
                ue(S.$slots, "card-ctas", {}, void 0, !0)
              ], 2)) : ae("", !0)
            ], 2)
          ]),
          _: 3
        }, 16, ["href", "target"]))
      ], 2);
    };
  }
}), Kx = /* @__PURE__ */ _e(Ly, [["__scopeId", "data-v-c48270c7"]]);
var Ry = /* @__PURE__ */ ((n) => (n.fill = "fill", n.outline = "outline", n.float = "float", n.fullBleed = "full-bleed", n.none = "none", n))(Ry || {}), Dy = /* @__PURE__ */ ((n) => (n.top = "top", n.bottom = "bottom", n.none = "none", n))(Dy || {}), Py = /* @__PURE__ */ ((n) => (n.flag = "flag", n.timer = "timer", n.icon = "icon", n.none = "none", n))(Py || {}), bc = /* @__PURE__ */ ((n) => (n.light = "border-neutral-30 text-neutral-80", n.dark = "border-neutral-4 text-neutral-2", n))(bc || {});
const By = /* @__PURE__ */ Q({
  __name: "CardGrid",
  props: {
    cardGridVariant: {
      type: String,
      default: "dividerCardGrid"
    },
    cardGridTheme: {
      type: String,
      default: bc.light
    },
    maxCardsPerRow: {
      type: Number,
      default: 3
    }
  },
  setup(n) {
    const i = n;
    return (r, u) => (T(), U("div", {
      class: K(["card-grid", n.cardGridTheme])
    }, [
      F("div", {
        class: K([`card-row-${i.maxCardsPerRow}`, `card-grid-${i.cardGridVariant}`])
      }, [
        ue(r.$slots, "card-slot", {}, void 0, !0)
      ], 2)
    ], 2));
  }
}), Yx = /* @__PURE__ */ _e(By, [["__scopeId", "data-v-613d7a92"]]);
var to = /* @__PURE__ */ ((n) => (n.standard = "standard", n.small = "small", n))(to || {});
const My = {
  key: 0,
  class: /* @__PURE__ */ K(["accordion-content"])
}, Fy = {
  key: 0,
  class: /* @__PURE__ */ K(["accordion-text"])
}, zy = {
  class: /* @__PURE__ */ K(["accordion-cta"])
}, Uy = /* @__PURE__ */ Q({
  __name: "ListAccordion",
  props: {
    accordionSize: {
      type: String,
      default: to.standard
    },
    id: {
      type: String
    },
    showBorder: {
      type: Boolean,
      default: !0
    },
    itemTitle: {
      type: String
    },
    theme: {
      type: String,
      default: "light"
    },
    showAccordion: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["gtmEvent", "toggleAccordion"],
  setup(n, { emit: i }) {
    Hn((y) => ({
      "75528f2b": s[n.theme]
    }));
    const r = Cr(), u = n, o = {
      light: "bg-white",
      mid: "bg-neutral-8",
      dark: "bg-neutral-80"
    }, c = {
      light: "text-neutral-80",
      mid: "text-neutral-80",
      dark: "text-neutral-2"
    }, s = {
      light: "#222324",
      mid: "#222324",
      dark: "#555759"
    }, d = i, g = (y) => {
      d("toggleAccordion", y || ""), d("gtmEvent", {
        event: u.showAccordion ? "CollapsableText.Open" : "CollapsibleText.Close",
        label: u.itemTitle,
        action: "Click"
      });
    };
    return (y, _) => (T(), U("div", {
      class: K(["accordion-item", { "accordion-item--with-border": u.showBorder }, u.accordionSize, o[u.theme], c[u.theme]])
    }, [
      F("button", {
        class: K(["accordion-header", c[n.theme]]),
        onClick: _[0] || (_[0] = () => g(u.id))
      }, [
        F("p", null, re(u.itemTitle), 1),
        se(v(kt), {
          size: v(ft).lg,
          iconName: u.showAccordion ? v(Z).caretUp : v(Z).caretDown
        }, null, 8, ["size", "iconName"])
      ], 2),
      se(uc, { name: "accordion__transition" }, {
        default: ne(() => [
          u.showAccordion ? (T(), U("div", My, [
            v(r).accText ? (T(), U("div", Fy, [
              ue(y.$slots, "accText", {}, void 0, !0)
            ])) : ae("", !0),
            F("div", zy, [
              ue(y.$slots, "accCta", {}, void 0, !0)
            ])
          ])) : ae("", !0)
        ]),
        _: 3
      })
    ], 2));
  }
}), Wy = /* @__PURE__ */ _e(Uy, [["__scopeId", "data-v-0a43b940"]]);
function Jr(n, i, r) {
  let u = r.initialDeps ?? [], o;
  return () => {
    var c, s, d, g;
    let y;
    r.key && ((c = r.debug) != null && c.call(r)) && (y = Date.now());
    const _ = n();
    if (!(_.length !== u.length || _.some((k, A) => u[A] !== k)))
      return o;
    u = _;
    let S;
    if (r.key && ((s = r.debug) != null && s.call(r)) && (S = Date.now()), o = i(..._), r.key && ((d = r.debug) != null && d.call(r))) {
      const k = Math.round((Date.now() - y) * 100) / 100, A = Math.round((Date.now() - S) * 100) / 100, L = A / 16, z = (Y, D) => {
        for (Y = String(Y); Y.length < D; )
          Y = " " + Y;
        return Y;
      };
      console.info(
        `%c⏱ ${z(A, 5)} /${z(k, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * L, 120)
        )}deg 100% 31%);`,
        r == null ? void 0 : r.key
      );
    }
    return (g = r == null ? void 0 : r.onChange) == null || g.call(r, o), o;
  };
}
function Fa(n, i) {
  if (n === void 0)
    throw new Error(`Unexpected undefined${i ? `: ${i}` : ""}`);
  return n;
}
const Hy = (n, i) => Math.abs(n - i) < 1, qy = (n, i) => {
  let r;
  return function(...u) {
    clearTimeout(r), r = setTimeout(() => n.apply(this, u), i);
  };
}, Gy = (n) => n, Vy = (n) => {
  const i = Math.max(n.startIndex - n.overscan, 0), r = Math.min(n.endIndex + n.overscan, n.count - 1), u = [];
  for (let o = i; o <= r; o++)
    u.push(o);
  return u;
}, Ny = (n, i) => {
  const r = n.scrollElement;
  if (!r)
    return;
  const u = (c) => {
    const { width: s, height: d } = c;
    i({ width: Math.round(s), height: Math.round(d) });
  };
  if (u(r.getBoundingClientRect()), typeof ResizeObserver > "u")
    return () => {
    };
  const o = new ResizeObserver((c) => {
    const s = c[0];
    if (s != null && s.borderBoxSize) {
      const d = s.borderBoxSize[0];
      if (d) {
        u({ width: d.inlineSize, height: d.blockSize });
        return;
      }
    }
    u(r.getBoundingClientRect());
  });
  return o.observe(r, { box: "border-box" }), () => {
    o.unobserve(r);
  };
}, Yu = {
  passive: !0
}, jy = typeof window > "u" ? !0 : "onscrollend" in window, Ky = (n, i) => {
  const r = n.scrollElement;
  if (!r)
    return;
  let u = 0;
  const o = jy ? () => {
  } : qy(() => {
    i(u, !1);
  }, 150), c = (g) => () => {
    u = r[n.options.horizontal ? "scrollLeft" : "scrollTop"], o(), i(u, g);
  }, s = c(!0), d = c(!1);
  return d(), r.addEventListener("scroll", s, Yu), r.addEventListener("scrollend", d, Yu), () => {
    r.removeEventListener("scroll", s), r.removeEventListener("scrollend", d);
  };
}, Yy = (n, i, r) => {
  if (i != null && i.borderBoxSize) {
    const u = i.borderBoxSize[0];
    if (u)
      return Math.round(
        u[r.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    n.getBoundingClientRect()[r.options.horizontal ? "width" : "height"]
  );
}, Zy = (n, {
  adjustments: i = 0,
  behavior: r
}, u) => {
  var o, c;
  const s = n + i;
  (c = (o = u.scrollElement) == null ? void 0 : o.scrollTo) == null || c.call(o, {
    [u.options.horizontal ? "left" : "top"]: s,
    behavior: r
  });
};
class Xy {
  constructor(i) {
    this.unsubs = [], this.scrollElement = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollDirection = null, this.scrollAdjustments = 0, this.measureElementCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let r = null;
      const u = () => r || (typeof ResizeObserver < "u" ? r = new ResizeObserver((o) => {
        o.forEach((c) => {
          this._measureElement(c.target, c);
        });
      }) : null);
      return {
        disconnect: () => {
          var o;
          return (o = u()) == null ? void 0 : o.disconnect();
        },
        observe: (o) => {
          var c;
          return (c = u()) == null ? void 0 : c.observe(o, { box: "border-box" });
        },
        unobserve: (o) => {
          var c;
          return (c = u()) == null ? void 0 : c.unobserve(o);
        }
      };
    })(), this.range = null, this.setOptions = (r) => {
      Object.entries(r).forEach(([u, o]) => {
        typeof o > "u" && delete r[u];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: Gy,
        rangeExtractor: Vy,
        onChange: () => {
        },
        measureElement: Yy,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        ...r
      };
    }, this.notify = (r, u) => {
      var o, c;
      const { startIndex: s, endIndex: d } = this.range ?? {
        startIndex: void 0,
        endIndex: void 0
      }, g = this.calculateRange();
      (r || s !== (g == null ? void 0 : g.startIndex) || d !== (g == null ? void 0 : g.endIndex)) && ((c = (o = this.options).onChange) == null || c.call(o, this, u));
    }, this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((r) => r()), this.unsubs = [], this.scrollElement = null;
    }, this._didMount = () => (this.measureElementCache.forEach(this.observer.observe), () => {
      this.observer.disconnect(), this.cleanup();
    }), this._willUpdate = () => {
      const r = this.options.getScrollElement();
      this.scrollElement !== r && (this.cleanup(), this.scrollElement = r, this._scrollToOffset(this.scrollOffset, {
        adjustments: void 0,
        behavior: void 0
      }), this.unsubs.push(
        this.options.observeElementRect(this, (u) => {
          this.scrollRect = u, this.notify(!1, !1);
        })
      ), this.unsubs.push(
        this.options.observeElementOffset(this, (u, o) => {
          this.scrollAdjustments = 0, this.scrollDirection = o ? this.scrollOffset < u ? "forward" : "backward" : null, this.scrollOffset = u;
          const c = this.isScrolling;
          this.isScrolling = o, this.notify(c !== o, o);
        })
      ));
    }, this.getSize = () => this.scrollRect[this.options.horizontal ? "width" : "height"], this.getMeasurementOptions = Jr(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey
      ],
      (r, u, o, c) => (this.pendingMeasuredCacheIndexes = [], {
        count: r,
        paddingStart: u,
        scrollMargin: o,
        getItemKey: c
      }),
      {
        key: !1
      }
    ), this.getFurthestMeasurement = (r, u) => {
      const o = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map();
      for (let s = u - 1; s >= 0; s--) {
        const d = r[s];
        if (o.has(d.lane))
          continue;
        const g = c.get(
          d.lane
        );
        if (g == null || d.end > g.end ? c.set(d.lane, d) : d.end < g.end && o.set(d.lane, !0), o.size === this.options.lanes)
          break;
      }
      return c.size === this.options.lanes ? Array.from(c.values()).sort((s, d) => s.end === d.end ? s.index - d.index : s.end - d.end)[0] : void 0;
    }, this.getMeasurements = Jr(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: r, paddingStart: u, scrollMargin: o, getItemKey: c }, s) => {
        const d = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const g = this.measurementsCache.slice(0, d);
        for (let y = d; y < r; y++) {
          const _ = c(y), m = this.options.lanes === 1 ? g[y - 1] : this.getFurthestMeasurement(g, y), S = m ? m.end + this.options.gap : u + o, k = s.get(_), A = typeof k == "number" ? k : this.options.estimateSize(y), L = S + A, z = m ? m.lane : y % this.options.lanes;
          g[y] = {
            index: y,
            start: S,
            size: A,
            end: L,
            key: _,
            lane: z
          };
        }
        return this.measurementsCache = g, g;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Jr(
      () => [this.getMeasurements(), this.getSize(), this.scrollOffset],
      (r, u, o) => this.range = r.length > 0 && u > 0 ? Jy({
        measurements: r,
        outerSize: u,
        scrollOffset: o
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = Jr(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (r, u, o, c) => u === null ? [] : r({
        startIndex: u.startIndex,
        endIndex: u.endIndex,
        overscan: o,
        count: c
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (r) => {
      const u = this.options.indexAttribute, o = r.getAttribute(u);
      return o ? parseInt(o, 10) : (console.warn(
        `Missing attribute name '${u}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (r, u) => {
      const o = this.measurementsCache[this.indexFromElement(r)];
      if (!o || !r.isConnected) {
        this.measureElementCache.forEach((d, g) => {
          d === r && (this.observer.unobserve(r), this.measureElementCache.delete(g));
        });
        return;
      }
      const c = this.measureElementCache.get(o.key);
      c !== r && (c && this.observer.unobserve(c), this.observer.observe(r), this.measureElementCache.set(o.key, r));
      const s = this.options.measureElement(r, u, this);
      this.resizeItem(o, s);
    }, this.resizeItem = (r, u) => {
      const o = this.itemSizeCache.get(r.key) ?? r.size, c = u - o;
      c !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(r, c, this) : r.start < this.scrollOffset + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", c), this._scrollToOffset(this.scrollOffset, {
        adjustments: this.scrollAdjustments += c,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(r.index), this.itemSizeCache = new Map(this.itemSizeCache.set(r.key, u)), this.notify(!0, !1));
    }, this.measureElement = (r) => {
      r && this._measureElement(r, void 0);
    }, this.getVirtualItems = Jr(
      () => [this.getIndexes(), this.getMeasurements()],
      (r, u) => {
        const o = [];
        for (let c = 0, s = r.length; c < s; c++) {
          const d = r[c], g = u[d];
          o.push(g);
        }
        return o;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (r) => {
      const u = this.getMeasurements();
      return Fa(
        u[yc(
          0,
          u.length - 1,
          (o) => Fa(u[o]).start,
          r
        )]
      );
    }, this.getOffsetForAlignment = (r, u) => {
      const o = this.getSize();
      u === "auto" && (r <= this.scrollOffset ? u = "start" : r >= this.scrollOffset + o ? u = "end" : u = "start"), u === "start" ? r = r : u === "end" ? r = r - o : u === "center" && (r = r - o / 2);
      const c = this.options.horizontal ? "scrollWidth" : "scrollHeight", d = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[c] : this.scrollElement[c] : 0) - this.getSize();
      return Math.max(Math.min(d, r), 0);
    }, this.getOffsetForIndex = (r, u = "auto") => {
      r = Math.max(0, Math.min(r, this.options.count - 1));
      const o = Fa(this.getMeasurements()[r]);
      if (u === "auto")
        if (o.end >= this.scrollOffset + this.getSize() - this.options.scrollPaddingEnd)
          u = "end";
        else if (o.start <= this.scrollOffset + this.options.scrollPaddingStart)
          u = "start";
        else
          return [this.scrollOffset, u];
      const c = u === "end" ? o.end + this.options.scrollPaddingEnd : o.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(c, u), u];
    }, this.isDynamicMode = () => this.measureElementCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && (clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (r, { align: u = "start", behavior: o } = {}) => {
      this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(r, u), {
        adjustments: void 0,
        behavior: o
      });
    }, this.scrollToIndex = (r, { align: u = "auto", behavior: o } = {}) => {
      r = Math.max(0, Math.min(r, this.options.count - 1)), this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const [c, s] = this.getOffsetForIndex(r, u);
      this._scrollToOffset(c, { adjustments: void 0, behavior: o }), o !== "smooth" && this.isDynamicMode() && (this.scrollToIndexTimeoutId = setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.measureElementCache.has(
          this.options.getItemKey(r)
        )) {
          const [g] = this.getOffsetForIndex(r, s);
          Hy(g, this.scrollOffset) || this.scrollToIndex(r, { align: s, behavior: o });
        } else
          this.scrollToIndex(r, { align: s, behavior: o });
      }));
    }, this.scrollBy = (r, { behavior: u } = {}) => {
      this.cancelScrollToIndex(), u === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.scrollOffset + r, {
        adjustments: void 0,
        behavior: u
      });
    }, this.getTotalSize = () => {
      var r;
      const u = this.getMeasurements();
      let o;
      return u.length === 0 ? o = this.options.paddingStart : o = this.options.lanes === 1 ? ((r = u[u.length - 1]) == null ? void 0 : r.end) ?? 0 : Math.max(
        ...u.slice(-this.options.lanes).map((c) => c.end)
      ), o - this.options.scrollMargin + this.options.paddingEnd;
    }, this._scrollToOffset = (r, {
      adjustments: u,
      behavior: o
    }) => {
      this.options.scrollToFn(r, { behavior: o, adjustments: u }, this);
    }, this.measure = () => {
      var r, u;
      this.itemSizeCache = /* @__PURE__ */ new Map(), (u = (r = this.options).onChange) == null || u.call(r, this, !1);
    }, this.setOptions(i), this.scrollRect = this.options.initialRect, this.scrollOffset = typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset, this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((r) => {
      this.itemSizeCache.set(r.key, r.size);
    }), this.notify(!1, !1);
  }
}
const yc = (n, i, r, u) => {
  for (; n <= i; ) {
    const o = (n + i) / 2 | 0, c = r(o);
    if (c < u)
      n = o + 1;
    else if (c > u)
      i = o - 1;
    else
      return o;
  }
  return n > 0 ? n - 1 : 0;
};
function Jy({
  measurements: n,
  outerSize: i,
  scrollOffset: r
}) {
  const u = n.length - 1, c = yc(0, u, (d) => n[d].start, r);
  let s = c;
  for (; s < u && n[s].end < r + i; )
    s++;
  return { startIndex: c, endIndex: s };
}
function Qy(n) {
  const i = new Xy(v(n)), r = cc(i), u = i._didMount();
  return vt(
    () => v(n).getScrollElement(),
    (o) => {
      o && i._willUpdate();
    },
    {
      immediate: !0
    }
  ), vt(
    () => v(n),
    (o) => {
      i.setOptions({
        ...o,
        onChange: (c, s) => {
          var d;
          Vu(r), (d = o.onChange) == null || d.call(o, c, s);
        }
      }), i._willUpdate(), Vu(r);
    },
    {
      immediate: !0
    }
  ), Hb(u), r;
}
function e1(n) {
  return Qy(
    $(() => ({
      observeElementRect: Ny,
      observeElementOffset: Ky,
      scrollToFn: Zy,
      ...v(n)
    }))
  );
}
function _c(n, i, r) {
  let u = B(r == null ? void 0 : r.value), o = $(() => n.value !== void 0);
  return [$(() => o.value ? n.value : u.value), function(c) {
    return o.value || (u.value = c), i == null ? void 0 : i(c);
  }];
}
function hi(n) {
  typeof queueMicrotask == "function" ? queueMicrotask(n) : Promise.resolve().then(n).catch((i) => setTimeout(() => {
    throw i;
  }));
}
function Wn() {
  let n = [], i = { addEventListener(r, u, o, c) {
    return r.addEventListener(u, o, c), i.add(() => r.removeEventListener(u, o, c));
  }, requestAnimationFrame(...r) {
    let u = requestAnimationFrame(...r);
    i.add(() => cancelAnimationFrame(u));
  }, nextFrame(...r) {
    i.requestAnimationFrame(() => {
      i.requestAnimationFrame(...r);
    });
  }, setTimeout(...r) {
    let u = setTimeout(...r);
    i.add(() => clearTimeout(u));
  }, microTask(...r) {
    let u = { current: !0 };
    return hi(() => {
      u.current && r[0]();
    }), i.add(() => {
      u.current = !1;
    });
  }, style(r, u, o) {
    let c = r.style.getPropertyValue(u);
    return Object.assign(r.style, { [u]: o }), this.add(() => {
      Object.assign(r.style, { [u]: c });
    });
  }, group(r) {
    let u = Wn();
    return r(u), this.add(() => u.dispose());
  }, add(r) {
    return n.push(r), () => {
      let u = n.indexOf(r);
      if (u >= 0)
        for (let o of n.splice(u, 1))
          o();
    };
  }, dispose() {
    for (let r of n.splice(0))
      r();
  } };
  return i;
}
function t1() {
  let n = Wn();
  return yt(() => n.dispose()), n;
}
function n1() {
  let n = t1();
  return (i) => {
    n.dispose(), n.nextFrame(i);
  };
}
var Zu;
let r1 = Symbol("headlessui.useid"), l1 = 0;
const ht = (Zu = Gu.useId) != null ? Zu : function() {
  return Gu.inject(r1, () => `${++l1}`)();
};
function J(n) {
  var i;
  if (n == null || n.value == null)
    return null;
  let r = (i = n.value.$el) != null ? i : n.value;
  return r instanceof Node ? r : null;
}
function He(n, i, ...r) {
  if (n in i) {
    let o = i[n];
    return typeof o == "function" ? o(...r) : o;
  }
  let u = new Error(`Tried to handle "${n}" but there is no handler defined. Only defined handlers are: ${Object.keys(i).map((o) => `"${o}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(u, He), u;
}
var i1 = Object.defineProperty, a1 = (n, i, r) => i in n ? i1(n, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : n[i] = r, Xu = (n, i, r) => (a1(n, typeof i != "symbol" ? i + "" : i, r), r);
let o1 = class {
  constructor() {
    Xu(this, "current", this.detect()), Xu(this, "currentId", 0);
  }
  set(i) {
    this.current !== i && (this.currentId = 0, this.current = i);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, ol = new o1();
function On(n) {
  if (ol.isServer)
    return null;
  if (n instanceof Node)
    return n.ownerDocument;
  if (n != null && n.hasOwnProperty("value")) {
    let i = J(n);
    if (i)
      return i.ownerDocument;
  }
  return document;
}
let qa = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((n) => `${n}:not([tabindex='-1'])`).join(",");
var dt = ((n) => (n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n))(dt || {}), Ir = ((n) => (n[n.Error = 0] = "Error", n[n.Overflow = 1] = "Overflow", n[n.Success = 2] = "Success", n[n.Underflow = 3] = "Underflow", n))(Ir || {}), s1 = ((n) => (n[n.Previous = -1] = "Previous", n[n.Next = 1] = "Next", n))(s1 || {});
function u1(n = document.body) {
  return n == null ? [] : Array.from(n.querySelectorAll(qa)).sort((i, r) => Math.sign((i.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var no = ((n) => (n[n.Strict = 0] = "Strict", n[n.Loose = 1] = "Loose", n))(no || {});
function wc(n, i = 0) {
  var r;
  return n === ((r = On(n)) == null ? void 0 : r.body) ? !1 : He(i, { 0() {
    return n.matches(qa);
  }, 1() {
    let u = n;
    for (; u !== null; ) {
      if (u.matches(qa))
        return !0;
      u = u.parentElement;
    }
    return !1;
  } });
}
var c1 = ((n) => (n[n.Keyboard = 0] = "Keyboard", n[n.Mouse = 1] = "Mouse", n))(c1 || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (n) => {
  n.metaKey || n.altKey || n.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (n) => {
  n.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : n.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function tr(n) {
  n == null || n.focus({ preventScroll: !0 });
}
let d1 = ["textarea", "input"].join(",");
function f1(n) {
  var i, r;
  return (r = (i = n == null ? void 0 : n.matches) == null ? void 0 : i.call(n, d1)) != null ? r : !1;
}
function zn(n, i = (r) => r) {
  return n.slice().sort((r, u) => {
    let o = i(r), c = i(u);
    if (o === null || c === null)
      return 0;
    let s = o.compareDocumentPosition(c);
    return s & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : s & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function pn(n, i, { sorted: r = !0, relativeTo: u = null, skipElements: o = [] } = {}) {
  var c;
  let s = (c = Array.isArray(n) ? n.length > 0 ? n[0].ownerDocument : document : n == null ? void 0 : n.ownerDocument) != null ? c : document, d = Array.isArray(n) ? r ? zn(n) : n : u1(n);
  o.length > 0 && d.length > 1 && (d = d.filter((A) => !o.includes(A))), u = u ?? s.activeElement;
  let g = (() => {
    if (i & 5)
      return 1;
    if (i & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), y = (() => {
    if (i & 1)
      return 0;
    if (i & 2)
      return Math.max(0, d.indexOf(u)) - 1;
    if (i & 4)
      return Math.max(0, d.indexOf(u)) + 1;
    if (i & 8)
      return d.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), _ = i & 32 ? { preventScroll: !0 } : {}, m = 0, S = d.length, k;
  do {
    if (m >= S || m + S <= 0)
      return 0;
    let A = y + m;
    if (i & 16)
      A = (A + S) % S;
    else {
      if (A < 0)
        return 3;
      if (A >= S)
        return 1;
    }
    k = d[A], k == null || k.focus(_), m += g;
  } while (k !== s.activeElement);
  return i & 6 && f1(k) && k.select(), 2;
}
function xc() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function v1() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Sc() {
  return xc() || v1();
}
function ii(n, i, r) {
  ol.isServer || ut((u) => {
    document.addEventListener(n, i, r), u(() => document.removeEventListener(n, i, r));
  });
}
function Tc(n, i, r) {
  ol.isServer || ut((u) => {
    window.addEventListener(n, i, r), u(() => window.removeEventListener(n, i, r));
  });
}
function ro(n, i, r = $(() => !0)) {
  function u(c, s) {
    if (!r.value || c.defaultPrevented)
      return;
    let d = s(c);
    if (d === null || !d.getRootNode().contains(d))
      return;
    let g = function y(_) {
      return typeof _ == "function" ? y(_()) : Array.isArray(_) || _ instanceof Set ? _ : [_];
    }(n);
    for (let y of g) {
      if (y === null)
        continue;
      let _ = y instanceof HTMLElement ? y : J(y);
      if (_ != null && _.contains(d) || c.composed && c.composedPath().includes(_))
        return;
    }
    return !wc(d, no.Loose) && d.tabIndex !== -1 && c.preventDefault(), i(c, d);
  }
  let o = B(null);
  ii("pointerdown", (c) => {
    var s, d;
    r.value && (o.value = ((d = (s = c.composedPath) == null ? void 0 : s.call(c)) == null ? void 0 : d[0]) || c.target);
  }, !0), ii("mousedown", (c) => {
    var s, d;
    r.value && (o.value = ((d = (s = c.composedPath) == null ? void 0 : s.call(c)) == null ? void 0 : d[0]) || c.target);
  }, !0), ii("click", (c) => {
    Sc() || o.value && (u(c, () => o.value), o.value = null);
  }, !0), ii("touchend", (c) => u(c, () => c.target instanceof HTMLElement ? c.target : null), !0), Tc("blur", (c) => u(c, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function Ju(n, i) {
  if (n)
    return n;
  let r = i ?? "button";
  if (typeof r == "string" && r.toLowerCase() === "button")
    return "button";
}
function lo(n, i) {
  let r = B(Ju(n.value.type, n.value.as));
  return Ae(() => {
    r.value = Ju(n.value.type, n.value.as);
  }), ut(() => {
    var u;
    r.value || J(i) && J(i) instanceof HTMLButtonElement && !((u = J(i)) != null && u.hasAttribute("type")) && (r.value = "button");
  }), r;
}
function Qu(n) {
  return [n.screenX, n.screenY];
}
function Ic() {
  let n = B([-1, -1]);
  return { wasMoved(i) {
    let r = Qu(i);
    return n.value[0] === r[0] && n.value[1] === r[1] ? !1 : (n.value = r, !0);
  }, update(i) {
    n.value = Qu(i);
  } };
}
function p1({ container: n, accept: i, walk: r, enabled: u }) {
  ut(() => {
    let o = n.value;
    if (!o || u !== void 0 && !u.value)
      return;
    let c = On(n);
    if (!c)
      return;
    let s = Object.assign((g) => i(g), { acceptNode: i }), d = c.createTreeWalker(o, NodeFilter.SHOW_ELEMENT, s, !1);
    for (; d.nextNode(); )
      r(d.currentNode);
  });
}
var tn = ((n) => (n[n.None = 0] = "None", n[n.RenderStrategy = 1] = "RenderStrategy", n[n.Static = 2] = "Static", n))(tn || {}), Un = ((n) => (n[n.Unmount = 0] = "Unmount", n[n.Hidden = 1] = "Hidden", n))(Un || {});
function ze({ visible: n = !0, features: i = 0, ourProps: r, theirProps: u, ...o }) {
  var c;
  let s = Cc(u, r), d = Object.assign(o, { props: s });
  if (n || i & 2 && s.static)
    return za(d);
  if (i & 1) {
    let g = (c = s.unmount) == null || c ? 0 : 1;
    return He(g, { 0() {
      return null;
    }, 1() {
      return za({ ...o, props: { ...s, hidden: !0, style: { display: "none" } } });
    } });
  }
  return za(d);
}
function za({ props: n, attrs: i, slots: r, slot: u, name: o }) {
  var c, s;
  let { as: d, ...g } = ar(n, ["unmount", "static"]), y = (c = r.default) == null ? void 0 : c.call(r, u), _ = {};
  if (u) {
    let m = !1, S = [];
    for (let [k, A] of Object.entries(u))
      typeof A == "boolean" && (m = !0), A === !0 && S.push(k);
    m && (_["data-headlessui-state"] = S.join(" "));
  }
  if (d === "template") {
    if (y = $c(y ?? []), Object.keys(g).length > 0 || Object.keys(i).length > 0) {
      let [m, ...S] = y ?? [];
      if (!h1(m) || S.length > 0)
        throw new Error(['Passing props on "template"!', "", `The current component <${o} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(g).concat(Object.keys(i)).map((L) => L.trim()).filter((L, z, Y) => Y.indexOf(L) === z).sort((L, z) => L.localeCompare(z)).map((L) => `  - ${L}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((L) => `  - ${L}`).join(`
`)].join(`
`));
      let k = Cc((s = m.props) != null ? s : {}, g, _), A = dc(m, k, !0);
      for (let L in k)
        L.startsWith("on") && (A.props || (A.props = {}), A.props[L] = k[L]);
      return A;
    }
    return Array.isArray(y) && y.length === 1 ? y[0] : y;
  }
  return Ge(d, Object.assign({}, g, _), { default: () => y });
}
function $c(n) {
  return n.flatMap((i) => i.type === Be ? $c(i.children) : [i]);
}
function Cc(...n) {
  if (n.length === 0)
    return {};
  if (n.length === 1)
    return n[0];
  let i = {}, r = {};
  for (let u of n)
    for (let o in u)
      o.startsWith("on") && typeof u[o] == "function" ? (r[o] != null || (r[o] = []), r[o].push(u[o])) : i[o] = u[o];
  if (i.disabled || i["aria-disabled"])
    return Object.assign(i, Object.fromEntries(Object.keys(r).map((u) => [u, void 0])));
  for (let u in r)
    Object.assign(i, { [u](o, ...c) {
      let s = r[u];
      for (let d of s) {
        if (o instanceof Event && o.defaultPrevented)
          return;
        d(o, ...c);
      }
    } });
  return i;
}
function kc(n) {
  let i = Object.assign({}, n);
  for (let r in i)
    i[r] === void 0 && delete i[r];
  return i;
}
function ar(n, i = []) {
  let r = Object.assign({}, n);
  for (let u of i)
    u in r && delete r[u];
  return r;
}
function h1(n) {
  return n == null ? !1 : typeof n.type == "string" || typeof n.type == "object" || typeof n.type == "function";
}
var rr = ((n) => (n[n.None = 1] = "None", n[n.Focusable = 2] = "Focusable", n[n.Hidden = 4] = "Hidden", n))(rr || {});
let lr = Q({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(n, { slots: i, attrs: r }) {
  return () => {
    var u;
    let { features: o, ...c } = n, s = { "aria-hidden": (o & 2) === 2 ? !0 : (u = c["aria-hidden"]) != null ? u : void 0, hidden: (o & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(o & 4) === 4 && (o & 2) !== 2 && { display: "none" } } };
    return ze({ ourProps: s, theirProps: c, slot: {}, attrs: r, slots: i, name: "Hidden" });
  };
} }), Oc = Symbol("Context");
var it = ((n) => (n[n.Open = 1] = "Open", n[n.Closed = 2] = "Closed", n[n.Closing = 4] = "Closing", n[n.Opening = 8] = "Opening", n))(it || {});
function m1() {
  return sl() !== null;
}
function sl() {
  return pt(Oc, null);
}
function io(n) {
  Ct(Oc, n);
}
var Se = ((n) => (n.Space = " ", n.Enter = "Enter", n.Escape = "Escape", n.Backspace = "Backspace", n.Delete = "Delete", n.ArrowLeft = "ArrowLeft", n.ArrowUp = "ArrowUp", n.ArrowRight = "ArrowRight", n.ArrowDown = "ArrowDown", n.Home = "Home", n.End = "End", n.PageUp = "PageUp", n.PageDown = "PageDown", n.Tab = "Tab", n))(Se || {}), Ec = ((n) => (n[n.Left = 0] = "Left", n[n.Right = 2] = "Right", n))(Ec || {});
function g1(n) {
  function i() {
    document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", i));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", i), i());
}
let Cn = [];
g1(() => {
  function n(i) {
    i.target instanceof HTMLElement && i.target !== document.body && Cn[0] !== i.target && (Cn.unshift(i.target), Cn = Cn.filter((r) => r != null && r.isConnected), Cn.splice(10));
  }
  window.addEventListener("click", n, { capture: !0 }), window.addEventListener("mousedown", n, { capture: !0 }), window.addEventListener("focus", n, { capture: !0 }), document.body.addEventListener("click", n, { capture: !0 }), document.body.addEventListener("mousedown", n, { capture: !0 }), document.body.addEventListener("focus", n, { capture: !0 });
});
function b1(n) {
  throw new Error("Unexpected object: " + n);
}
var De = ((n) => (n[n.First = 0] = "First", n[n.Previous = 1] = "Previous", n[n.Next = 2] = "Next", n[n.Last = 3] = "Last", n[n.Specific = 4] = "Specific", n[n.Nothing = 5] = "Nothing", n))(De || {});
function Ga(n, i) {
  let r = i.resolveItems();
  if (r.length <= 0)
    return null;
  let u = i.resolveActiveIndex(), o = u ?? -1;
  switch (n.focus) {
    case 0: {
      for (let c = 0; c < r.length; ++c)
        if (!i.resolveDisabled(r[c], c, r))
          return c;
      return u;
    }
    case 1: {
      o === -1 && (o = r.length);
      for (let c = o - 1; c >= 0; --c)
        if (!i.resolveDisabled(r[c], c, r))
          return c;
      return u;
    }
    case 2: {
      for (let c = o + 1; c < r.length; ++c)
        if (!i.resolveDisabled(r[c], c, r))
          return c;
      return u;
    }
    case 3: {
      for (let c = r.length - 1; c >= 0; --c)
        if (!i.resolveDisabled(r[c], c, r))
          return c;
      return u;
    }
    case 4: {
      for (let c = 0; c < r.length; ++c)
        if (i.resolveId(r[c], c, r) === n.id)
          return c;
      return u;
    }
    case 5:
      return null;
    default:
      b1(n);
  }
}
function ao(n = {}, i = null, r = []) {
  for (let [u, o] of Object.entries(n))
    Lc(r, Ac(i, u), o);
  return r;
}
function Ac(n, i) {
  return n ? n + "[" + i + "]" : i;
}
function Lc(n, i, r) {
  if (Array.isArray(r))
    for (let [u, o] of r.entries())
      Lc(n, Ac(i, u.toString()), o);
  else
    r instanceof Date ? n.push([i, r.toISOString()]) : typeof r == "boolean" ? n.push([i, r ? "1" : "0"]) : typeof r == "string" ? n.push([i, r]) : typeof r == "number" ? n.push([i, `${r}`]) : r == null ? n.push([i, ""]) : ao(r, i, n);
}
function y1(n, i) {
  return n === i;
}
var _1 = ((n) => (n[n.Open = 0] = "Open", n[n.Closed = 1] = "Closed", n))(_1 || {}), w1 = ((n) => (n[n.Single = 0] = "Single", n[n.Multi = 1] = "Multi", n))(w1 || {}), x1 = ((n) => (n[n.Pointer = 0] = "Pointer", n[n.Focus = 1] = "Focus", n[n.Other = 2] = "Other", n))(x1 || {});
let Rc = Symbol("ComboboxContext");
function or(n) {
  let i = pt(Rc, null);
  if (i === null) {
    let r = new Error(`<${n} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, or), r;
  }
  return i;
}
let Dc = Symbol("VirtualContext"), S1 = Q({ name: "VirtualProvider", setup(n, { slots: i }) {
  let r = or("VirtualProvider"), u = $(() => {
    let d = J(r.optionsRef);
    if (!d)
      return { start: 0, end: 0 };
    let g = window.getComputedStyle(d);
    return { start: parseFloat(g.paddingBlockStart || g.paddingTop), end: parseFloat(g.paddingBlockEnd || g.paddingBottom) };
  }), o = e1($(() => ({ scrollPaddingStart: u.value.start, scrollPaddingEnd: u.value.end, count: r.virtual.value.options.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    return J(r.optionsRef);
  }, overscan: 12 }))), c = $(() => {
    var d;
    return (d = r.virtual.value) == null ? void 0 : d.options;
  }), s = B(0);
  return vt([c], () => {
    s.value += 1;
  }), Ct(Dc, r.virtual.value ? o : null), () => [Ge("div", { style: { position: "relative", width: "100%", height: `${o.value.getTotalSize()}px` }, ref: (d) => {
    if (d) {
      if (typeof process < "u" && process.env.JEST_WORKER_ID !== void 0 || r.activationTrigger.value === 0)
        return;
      r.activeOptionIndex.value !== null && r.virtual.value.options.length > r.activeOptionIndex.value && o.value.scrollToIndex(r.activeOptionIndex.value);
    }
  } }, o.value.getVirtualItems().map((d) => dc(i.default({ option: r.virtual.value.options[d.index], open: r.comboboxState.value === 0 })[0], { key: `${s.value}-${d.index}`, "data-index": d.index, "aria-setsize": r.virtual.value.options.length, "aria-posinset": d.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${d.start}px)`, overflowAnchor: "none" } })))];
} }), T1 = Q({ name: "Combobox", emits: { "update:modelValue": (n) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], nullable: !0, default: null }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, nullable: { type: Boolean, default: !1 }, multiple: { type: [Boolean], default: !1 }, immediate: { type: [Boolean], default: !1 }, virtual: { type: Object, default: null } }, inheritAttrs: !1, setup(n, { slots: i, attrs: r, emit: u }) {
  let o = B(1), c = B(null), s = B(null), d = B(null), g = B(null), y = B({ static: !1, hold: !1 }), _ = B([]), m = B(null), S = B(2), k = B(!1);
  function A(G = (X) => X) {
    let X = m.value !== null ? _.value[m.value] : null, ve = G(_.value.slice()), pe = ve.length > 0 && ve[0].dataRef.order.value !== null ? ve.sort((de, te) => de.dataRef.order.value - te.dataRef.order.value) : zn(ve, (de) => J(de.dataRef.domRef)), Ce = X ? pe.indexOf(X) : null;
    return Ce === -1 && (Ce = null), { options: pe, activeOptionIndex: Ce };
  }
  let L = $(() => n.multiple ? 1 : 0), z = $(() => n.nullable), [Y, D] = _c($(() => n.modelValue), (G) => u("update:modelValue", G), $(() => n.defaultValue)), O = $(() => Y.value === void 0 ? He(L.value, { 1: [], 0: void 0 }) : Y.value), E = null, w = null;
  function M(G) {
    return He(L.value, { 0() {
      return D == null ? void 0 : D(G);
    }, 1: () => {
      let X = st(R.value.value).slice(), ve = st(G), pe = X.findIndex((Ce) => R.compare(ve, st(Ce)));
      return pe === -1 ? X.push(ve) : X.splice(pe, 1), D == null ? void 0 : D(X);
    } });
  }
  let W = $(() => {
  });
  vt([W], ([G], [X]) => {
    if (R.virtual.value && G && X && m.value !== null) {
      let ve = G.indexOf(X[m.value]);
      ve !== -1 ? m.value = ve : m.value = null;
    }
  });
  let R = { comboboxState: o, value: O, mode: L, compare(G, X) {
    if (typeof n.by == "string") {
      let ve = n.by;
      return (G == null ? void 0 : G[ve]) === (X == null ? void 0 : X[ve]);
    }
    return n.by === null ? y1(G, X) : n.by(G, X);
  }, calculateIndex(G) {
    return R.virtual.value ? n.by === null ? R.virtual.value.options.indexOf(G) : R.virtual.value.options.findIndex((X) => R.compare(X, G)) : _.value.findIndex((X) => R.compare(X.dataRef.value, G));
  }, defaultValue: $(() => n.defaultValue), nullable: z, immediate: $(() => !1), virtual: $(() => null), inputRef: s, labelRef: c, buttonRef: d, optionsRef: g, disabled: $(() => n.disabled), options: _, change(G) {
    D(G);
  }, activeOptionIndex: $(() => {
    if (k.value && m.value === null && (R.virtual.value ? R.virtual.value.options.length > 0 : _.value.length > 0)) {
      if (R.virtual.value) {
        let X = R.virtual.value.options.findIndex((ve) => {
          var pe;
          return !((pe = R.virtual.value) != null && pe.disabled(ve));
        });
        if (X !== -1)
          return X;
      }
      let G = _.value.findIndex((X) => !X.dataRef.disabled);
      if (G !== -1)
        return G;
    }
    return m.value;
  }), activationTrigger: S, optionsPropsRef: y, closeCombobox() {
    k.value = !1, !n.disabled && o.value !== 1 && (o.value = 1, m.value = null);
  }, openCombobox() {
    if (k.value = !0, !n.disabled && o.value !== 0) {
      if (R.value.value) {
        let G = R.calculateIndex(R.value.value);
        G !== -1 && (m.value = G);
      }
      o.value = 0;
    }
  }, setActivationTrigger(G) {
    S.value = G;
  }, goToOption(G, X, ve) {
    k.value = !1, E !== null && cancelAnimationFrame(E), E = requestAnimationFrame(() => {
      if (n.disabled || g.value && !y.value.static && o.value === 1)
        return;
      if (R.virtual.value) {
        m.value = G === De.Specific ? X : Ga({ focus: G }, { resolveItems: () => R.virtual.value.options, resolveActiveIndex: () => {
          var de, te;
          return (te = (de = R.activeOptionIndex.value) != null ? de : R.virtual.value.options.findIndex((fe) => {
            var ke;
            return !((ke = R.virtual.value) != null && ke.disabled(fe));
          })) != null ? te : null;
        }, resolveDisabled: (de) => R.virtual.value.disabled(de), resolveId() {
          throw new Error("Function not implemented.");
        } }), S.value = ve ?? 2;
        return;
      }
      let pe = A();
      if (pe.activeOptionIndex === null) {
        let de = pe.options.findIndex((te) => !te.dataRef.disabled);
        de !== -1 && (pe.activeOptionIndex = de);
      }
      let Ce = G === De.Specific ? X : Ga({ focus: G }, { resolveItems: () => pe.options, resolveActiveIndex: () => pe.activeOptionIndex, resolveId: (de) => de.id, resolveDisabled: (de) => de.dataRef.disabled });
      m.value = Ce, S.value = ve ?? 2, _.value = pe.options;
    });
  }, selectOption(G) {
    let X = _.value.find((pe) => pe.id === G);
    if (!X)
      return;
    let { dataRef: ve } = X;
    M(ve.value);
  }, selectActiveOption() {
    if (R.activeOptionIndex.value !== null) {
      if (R.virtual.value)
        M(R.virtual.value.options[R.activeOptionIndex.value]);
      else {
        let { dataRef: G } = _.value[R.activeOptionIndex.value];
        M(G.value);
      }
      R.goToOption(De.Specific, R.activeOptionIndex.value);
    }
  }, registerOption(G, X) {
    let ve = fc({ id: G, dataRef: X });
    if (R.virtual.value) {
      _.value.push(ve);
      return;
    }
    w && cancelAnimationFrame(w);
    let pe = A((Ce) => (Ce.push(ve), Ce));
    m.value === null && R.isSelected(X.value.value) && (pe.activeOptionIndex = pe.options.indexOf(ve)), _.value = pe.options, m.value = pe.activeOptionIndex, S.value = 2, pe.options.some((Ce) => !J(Ce.dataRef.domRef)) && (w = requestAnimationFrame(() => {
      let Ce = A();
      _.value = Ce.options, m.value = Ce.activeOptionIndex;
    }));
  }, unregisterOption(G, X) {
    if (E !== null && cancelAnimationFrame(E), X && (k.value = !0), R.virtual.value) {
      _.value = _.value.filter((pe) => pe.id !== G);
      return;
    }
    let ve = A((pe) => {
      let Ce = pe.findIndex((de) => de.id === G);
      return Ce !== -1 && pe.splice(Ce, 1), pe;
    });
    _.value = ve.options, m.value = ve.activeOptionIndex, S.value = 2;
  }, isSelected(G) {
    return He(L.value, { 0: () => R.compare(st(R.value.value), st(G)), 1: () => st(R.value.value).some((X) => R.compare(st(X), st(G))) });
  }, isActive(G) {
    return m.value === R.calculateIndex(G);
  } };
  ro([s, d, g], () => R.closeCombobox(), $(() => o.value === 0)), Ct(Rc, R), io($(() => He(o.value, { 0: it.Open, 1: it.Closed })));
  let q = $(() => {
    var G;
    return (G = J(s)) == null ? void 0 : G.closest("form");
  });
  return Ae(() => {
    vt([q], () => {
      if (!q.value || n.defaultValue === void 0)
        return;
      function G() {
        R.change(n.defaultValue);
      }
      return q.value.addEventListener("reset", G), () => {
        var X;
        (X = q.value) == null || X.removeEventListener("reset", G);
      };
    }, { immediate: !0 });
  }), () => {
    var G, X, ve;
    let { name: pe, disabled: Ce, form: de, ...te } = n, fe = { open: o.value === 0, disabled: Ce, activeIndex: R.activeOptionIndex.value, activeOption: R.activeOptionIndex.value === null ? null : R.virtual.value ? R.virtual.value.options[(G = R.activeOptionIndex.value) != null ? G : 0] : (ve = (X = R.options.value[R.activeOptionIndex.value]) == null ? void 0 : X.dataRef.value) != null ? ve : null, value: O.value };
    return Ge(Be, [...pe != null && O.value != null ? ao({ [pe]: O.value }).map(([ke, tt]) => Ge(lr, kc({ features: rr.Hidden, key: ke, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: de, disabled: Ce, name: ke, value: tt }))) : [], ze({ theirProps: { ...r, ...ar(te, ["by", "defaultValue", "immediate", "modelValue", "multiple", "nullable", "onUpdate:modelValue", "virtual"]) }, ourProps: {}, slot: fe, slots: i, attrs: r, name: "Combobox" })]);
  };
} });
Q({ name: "ComboboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(n, { attrs: i, slots: r }) {
  var u;
  let o = (u = n.id) != null ? u : `headlessui-combobox-label-${ht()}`, c = or("ComboboxLabel");
  function s() {
    var d;
    (d = J(c.inputRef)) == null || d.focus({ preventScroll: !0 });
  }
  return () => {
    let d = { open: c.comboboxState.value === 0, disabled: c.disabled.value }, { ...g } = n, y = { id: o, ref: c.labelRef, onClick: s };
    return ze({ ourProps: y, theirProps: g, slot: d, attrs: i, slots: r, name: "ComboboxLabel" });
  };
} });
let I1 = Q({ name: "ComboboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(n, { attrs: i, slots: r, expose: u }) {
  var o;
  let c = (o = n.id) != null ? o : `headlessui-combobox-button-${ht()}`, s = or("ComboboxButton");
  u({ el: s.buttonRef, $el: s.buttonRef });
  function d(_) {
    s.disabled.value || (s.comboboxState.value === 0 ? s.closeCombobox() : (_.preventDefault(), s.openCombobox()), xt(() => {
      var m;
      return (m = J(s.inputRef)) == null ? void 0 : m.focus({ preventScroll: !0 });
    }));
  }
  function g(_) {
    switch (_.key) {
      case Se.ArrowDown:
        _.preventDefault(), _.stopPropagation(), s.comboboxState.value === 1 && s.openCombobox(), xt(() => {
          var m;
          return (m = s.inputRef.value) == null ? void 0 : m.focus({ preventScroll: !0 });
        });
        return;
      case Se.ArrowUp:
        _.preventDefault(), _.stopPropagation(), s.comboboxState.value === 1 && (s.openCombobox(), xt(() => {
          s.value.value || s.goToOption(De.Last);
        })), xt(() => {
          var m;
          return (m = s.inputRef.value) == null ? void 0 : m.focus({ preventScroll: !0 });
        });
        return;
      case Se.Escape:
        if (s.comboboxState.value !== 0)
          return;
        _.preventDefault(), s.optionsRef.value && !s.optionsPropsRef.value.static && _.stopPropagation(), s.closeCombobox(), xt(() => {
          var m;
          return (m = s.inputRef.value) == null ? void 0 : m.focus({ preventScroll: !0 });
        });
        return;
    }
  }
  let y = lo($(() => ({ as: n.as, type: i.type })), s.buttonRef);
  return () => {
    var _, m;
    let S = { open: s.comboboxState.value === 0, disabled: s.disabled.value, value: s.value.value }, { ...k } = n, A = { ref: s.buttonRef, id: c, type: y.value, tabindex: "-1", "aria-haspopup": "listbox", "aria-controls": (_ = J(s.optionsRef)) == null ? void 0 : _.id, "aria-expanded": s.comboboxState.value === 0, "aria-labelledby": s.labelRef.value ? [(m = J(s.labelRef)) == null ? void 0 : m.id, c].join(" ") : void 0, disabled: s.disabled.value === !0 ? !0 : void 0, onKeydown: g, onClick: d };
    return ze({ ourProps: A, theirProps: k, slot: S, attrs: i, slots: r, name: "ComboboxButton" });
  };
} }), $1 = Q({ name: "ComboboxInput", props: { as: { type: [Object, String], default: "input" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, displayValue: { type: Function }, defaultValue: { type: String, default: void 0 }, id: { type: String, default: null } }, emits: { change: (n) => !0 }, setup(n, { emit: i, attrs: r, slots: u, expose: o }) {
  var c;
  let s = (c = n.id) != null ? c : `headlessui-combobox-input-${ht()}`, d = or("ComboboxInput"), g = $(() => On(J(d.inputRef))), y = { value: !1 };
  o({ el: d.inputRef, $el: d.inputRef });
  function _() {
    d.change(null);
    let w = J(d.optionsRef);
    w && (w.scrollTop = 0), d.goToOption(De.Nothing);
  }
  let m = $(() => {
    var w;
    let M = d.value.value;
    return J(d.inputRef) ? typeof n.displayValue < "u" && M !== void 0 ? (w = n.displayValue(M)) != null ? w : "" : typeof M == "string" ? M : "" : "";
  });
  Ae(() => {
    vt([m, d.comboboxState, g], ([w, M], [W, R]) => {
      if (y.value)
        return;
      let q = J(d.inputRef);
      q && ((R === 0 && M === 1 || w !== W) && (q.value = w), requestAnimationFrame(() => {
        var G;
        if (y.value || !q || ((G = g.value) == null ? void 0 : G.activeElement) !== q)
          return;
        let { selectionStart: X, selectionEnd: ve } = q;
        Math.abs((ve ?? 0) - (X ?? 0)) === 0 && X === 0 && q.setSelectionRange(q.value.length, q.value.length);
      }));
    }, { immediate: !0 }), vt([d.comboboxState], ([w], [M]) => {
      if (w === 0 && M === 1) {
        if (y.value)
          return;
        let W = J(d.inputRef);
        if (!W)
          return;
        let R = W.value, { selectionStart: q, selectionEnd: G, selectionDirection: X } = W;
        W.value = "", W.value = R, X !== null ? W.setSelectionRange(q, G, X) : W.setSelectionRange(q, G);
      }
    });
  });
  let S = B(!1);
  function k() {
    S.value = !0;
  }
  function A() {
    Wn().nextFrame(() => {
      S.value = !1;
    });
  }
  let L = n1();
  function z(w) {
    switch (y.value = !0, L(() => {
      y.value = !1;
    }), w.key) {
      case Se.Enter:
        if (y.value = !1, d.comboboxState.value !== 0 || S.value)
          return;
        if (w.preventDefault(), w.stopPropagation(), d.activeOptionIndex.value === null) {
          d.closeCombobox();
          return;
        }
        d.selectActiveOption(), d.mode.value === 0 && d.closeCombobox();
        break;
      case Se.ArrowDown:
        return y.value = !1, w.preventDefault(), w.stopPropagation(), He(d.comboboxState.value, { 0: () => d.goToOption(De.Next), 1: () => d.openCombobox() });
      case Se.ArrowUp:
        return y.value = !1, w.preventDefault(), w.stopPropagation(), He(d.comboboxState.value, { 0: () => d.goToOption(De.Previous), 1: () => {
          d.openCombobox(), xt(() => {
            d.value.value || d.goToOption(De.Last);
          });
        } });
      case Se.Home:
        if (w.shiftKey)
          break;
        return y.value = !1, w.preventDefault(), w.stopPropagation(), d.goToOption(De.First);
      case Se.PageUp:
        return y.value = !1, w.preventDefault(), w.stopPropagation(), d.goToOption(De.First);
      case Se.End:
        if (w.shiftKey)
          break;
        return y.value = !1, w.preventDefault(), w.stopPropagation(), d.goToOption(De.Last);
      case Se.PageDown:
        return y.value = !1, w.preventDefault(), w.stopPropagation(), d.goToOption(De.Last);
      case Se.Escape:
        if (y.value = !1, d.comboboxState.value !== 0)
          return;
        w.preventDefault(), d.optionsRef.value && !d.optionsPropsRef.value.static && w.stopPropagation(), d.nullable.value && d.mode.value === 0 && d.value.value === null && _(), d.closeCombobox();
        break;
      case Se.Tab:
        if (y.value = !1, d.comboboxState.value !== 0)
          return;
        d.mode.value === 0 && d.activationTrigger.value !== 1 && d.selectActiveOption(), d.closeCombobox();
        break;
    }
  }
  function Y(w) {
    i("change", w), d.nullable.value && d.mode.value === 0 && w.target.value === "" && _(), d.openCombobox();
  }
  function D(w) {
    var M, W, R;
    let q = (M = w.relatedTarget) != null ? M : Cn.find((G) => G !== w.currentTarget);
    if (y.value = !1, !((W = J(d.optionsRef)) != null && W.contains(q)) && !((R = J(d.buttonRef)) != null && R.contains(q)) && d.comboboxState.value === 0)
      return w.preventDefault(), d.mode.value === 0 && (d.nullable.value && d.value.value === null ? _() : d.activationTrigger.value !== 1 && d.selectActiveOption()), d.closeCombobox();
  }
  function O(w) {
    var M, W, R;
    let q = (M = w.relatedTarget) != null ? M : Cn.find((G) => G !== w.currentTarget);
    (W = J(d.buttonRef)) != null && W.contains(q) || (R = J(d.optionsRef)) != null && R.contains(q) || d.disabled.value || d.immediate.value && d.comboboxState.value !== 0 && (d.openCombobox(), Wn().nextFrame(() => {
      d.setActivationTrigger(1);
    }));
  }
  let E = $(() => {
    var w, M, W, R;
    return (R = (W = (M = n.defaultValue) != null ? M : d.defaultValue.value !== void 0 ? (w = n.displayValue) == null ? void 0 : w.call(n, d.defaultValue.value) : null) != null ? W : d.defaultValue.value) != null ? R : "";
  });
  return () => {
    var w, M, W, R, q, G, X;
    let ve = { open: d.comboboxState.value === 0 }, { displayValue: pe, onChange: Ce, ...de } = n, te = { "aria-controls": (w = d.optionsRef.value) == null ? void 0 : w.id, "aria-expanded": d.comboboxState.value === 0, "aria-activedescendant": d.activeOptionIndex.value === null ? void 0 : d.virtual.value ? (M = d.options.value.find((fe) => !d.virtual.value.disabled(fe.dataRef.value) && d.compare(fe.dataRef.value, d.virtual.value.options[d.activeOptionIndex.value]))) == null ? void 0 : M.id : (W = d.options.value[d.activeOptionIndex.value]) == null ? void 0 : W.id, "aria-labelledby": (G = (R = J(d.labelRef)) == null ? void 0 : R.id) != null ? G : (q = J(d.buttonRef)) == null ? void 0 : q.id, "aria-autocomplete": "list", id: s, onCompositionstart: k, onCompositionend: A, onKeydown: z, onInput: Y, onFocus: O, onBlur: D, role: "combobox", type: (X = r.type) != null ? X : "text", tabIndex: 0, ref: d.inputRef, defaultValue: E.value, disabled: d.disabled.value === !0 ? !0 : void 0 };
    return ze({ ourProps: te, theirProps: de, slot: ve, attrs: r, slots: u, features: tn.RenderStrategy | tn.Static, name: "ComboboxInput" });
  };
} }), C1 = Q({ name: "ComboboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, hold: { type: [Boolean], default: !1 } }, setup(n, { attrs: i, slots: r, expose: u }) {
  let o = or("ComboboxOptions"), c = `headlessui-combobox-options-${ht()}`;
  u({ el: o.optionsRef, $el: o.optionsRef }), ut(() => {
    o.optionsPropsRef.value.static = n.static;
  }), ut(() => {
    o.optionsPropsRef.value.hold = n.hold;
  });
  let s = sl(), d = $(() => s !== null ? (s.value & it.Open) === it.Open : o.comboboxState.value === 0);
  p1({ container: $(() => J(o.optionsRef)), enabled: $(() => o.comboboxState.value === 0), accept(y) {
    return y.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : y.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(y) {
    y.setAttribute("role", "none");
  } });
  function g(y) {
    y.preventDefault();
  }
  return () => {
    var y, _, m;
    let S = { open: o.comboboxState.value === 0 }, k = { "aria-labelledby": (m = (y = J(o.labelRef)) == null ? void 0 : y.id) != null ? m : (_ = J(o.buttonRef)) == null ? void 0 : _.id, id: c, ref: o.optionsRef, role: "listbox", "aria-multiselectable": o.mode.value === 1 ? !0 : void 0, onMousedown: g }, A = ar(n, ["hold"]);
    return ze({ ourProps: k, theirProps: A, slot: S, attrs: i, slots: o.virtual.value && o.comboboxState.value === 0 ? { ...r, default: () => [Ge(S1, {}, r.default)] } : r, features: tn.RenderStrategy | tn.Static, visible: d.value, name: "ComboboxOptions" });
  };
} }), k1 = Q({ name: "ComboboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, order: { type: [Number], default: null } }, setup(n, { slots: i, attrs: r, expose: u }) {
  let o = or("ComboboxOption"), c = `headlessui-combobox-option-${ht()}`, s = B(null), d = $(() => n.disabled);
  u({ el: s, $el: s });
  let g = $(() => {
    var D;
    return o.virtual.value ? o.activeOptionIndex.value === o.calculateIndex(n.value) : o.activeOptionIndex.value === null ? !1 : ((D = o.options.value[o.activeOptionIndex.value]) == null ? void 0 : D.id) === c;
  }), y = $(() => o.isSelected(n.value)), _ = pt(Dc, null), m = $(() => ({ disabled: n.disabled, value: n.value, domRef: s, order: $(() => n.order) }));
  Ae(() => o.registerOption(c, m)), yt(() => o.unregisterOption(c, g.value)), ut(() => {
    let D = J(s);
    D && (_ == null || _.value.measureElement(D));
  }), ut(() => {
    o.comboboxState.value === 0 && g.value && (o.virtual.value || o.activationTrigger.value !== 0 && xt(() => {
      var D, O;
      return (O = (D = J(s)) == null ? void 0 : D.scrollIntoView) == null ? void 0 : O.call(D, { block: "nearest" });
    }));
  });
  function S(D) {
    D.preventDefault(), D.button === Ec.Left && (d.value || (o.selectOption(c), Sc() || requestAnimationFrame(() => {
      var O;
      return (O = J(o.inputRef)) == null ? void 0 : O.focus({ preventScroll: !0 });
    }), o.mode.value === 0 && o.closeCombobox()));
  }
  function k() {
    var D;
    if (n.disabled || (D = o.virtual.value) != null && D.disabled(n.value))
      return o.goToOption(De.Nothing);
    let O = o.calculateIndex(n.value);
    o.goToOption(De.Specific, O);
  }
  let A = Ic();
  function L(D) {
    A.update(D);
  }
  function z(D) {
    var O;
    if (!A.wasMoved(D) || n.disabled || (O = o.virtual.value) != null && O.disabled(n.value) || g.value)
      return;
    let E = o.calculateIndex(n.value);
    o.goToOption(De.Specific, E, 0);
  }
  function Y(D) {
    var O;
    A.wasMoved(D) && (n.disabled || (O = o.virtual.value) != null && O.disabled(n.value) || g.value && (o.optionsPropsRef.value.hold || o.goToOption(De.Nothing)));
  }
  return () => {
    let { disabled: D } = n, O = { active: g.value, selected: y.value, disabled: D }, E = { id: c, ref: s, role: "option", tabIndex: D === !0 ? void 0 : -1, "aria-disabled": D === !0 ? !0 : void 0, "aria-selected": y.value, disabled: void 0, onMousedown: S, onFocus: k, onPointerenter: L, onMouseenter: L, onPointermove: z, onMousemove: z, onPointerleave: Y, onMouseleave: Y }, w = ar(n, ["order", "value"]);
    return ze({ ourProps: E, theirProps: w, slot: O, attrs: r, slots: i, name: "ComboboxOption" });
  };
} });
function Pc(n, i, r, u) {
  ol.isServer || ut((o) => {
    n = n ?? window, n.addEventListener(i, r, u), o(() => n.removeEventListener(i, r, u));
  });
}
var rl = ((n) => (n[n.Forwards = 0] = "Forwards", n[n.Backwards = 1] = "Backwards", n))(rl || {});
function O1() {
  let n = B(0);
  return Tc("keydown", (i) => {
    i.key === "Tab" && (n.value = i.shiftKey ? 1 : 0);
  }), n;
}
function Bc(n) {
  if (!n)
    return /* @__PURE__ */ new Set();
  if (typeof n == "function")
    return new Set(n());
  let i = /* @__PURE__ */ new Set();
  for (let r of n.value) {
    let u = J(r);
    u instanceof HTMLElement && i.add(u);
  }
  return i;
}
var Mc = ((n) => (n[n.None = 1] = "None", n[n.InitialFocus = 2] = "InitialFocus", n[n.TabLock = 4] = "TabLock", n[n.FocusLock = 8] = "FocusLock", n[n.RestoreFocus = 16] = "RestoreFocus", n[n.All = 30] = "All", n))(Mc || {});
let Qr = Object.assign(Q({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: B(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(n, { attrs: i, slots: r, expose: u }) {
  let o = B(null);
  u({ el: o, $el: o });
  let c = $(() => On(o)), s = B(!1);
  Ae(() => s.value = !0), yt(() => s.value = !1), A1({ ownerDocument: c }, $(() => s.value && !!(n.features & 16)));
  let d = L1({ ownerDocument: c, container: o, initialFocus: $(() => n.initialFocus) }, $(() => s.value && !!(n.features & 2)));
  R1({ ownerDocument: c, container: o, containers: n.containers, previousActiveElement: d }, $(() => s.value && !!(n.features & 8)));
  let g = O1();
  function y(k) {
    let A = J(o);
    A && ((L) => L())(() => {
      He(g.value, { [rl.Forwards]: () => {
        pn(A, dt.First, { skipElements: [k.relatedTarget] });
      }, [rl.Backwards]: () => {
        pn(A, dt.Last, { skipElements: [k.relatedTarget] });
      } });
    });
  }
  let _ = B(!1);
  function m(k) {
    k.key === "Tab" && (_.value = !0, requestAnimationFrame(() => {
      _.value = !1;
    }));
  }
  function S(k) {
    if (!s.value)
      return;
    let A = Bc(n.containers);
    J(o) instanceof HTMLElement && A.add(J(o));
    let L = k.relatedTarget;
    L instanceof HTMLElement && L.dataset.headlessuiFocusGuard !== "true" && (Fc(A, L) || (_.value ? pn(J(o), He(g.value, { [rl.Forwards]: () => dt.Next, [rl.Backwards]: () => dt.Previous }) | dt.WrapAround, { relativeTo: k.target }) : k.target instanceof HTMLElement && tr(k.target)));
  }
  return () => {
    let k = {}, A = { ref: o, onKeydown: m, onFocusout: S }, { features: L, initialFocus: z, containers: Y, ...D } = n;
    return Ge(Be, [!!(L & 4) && Ge(lr, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: y, features: rr.Focusable }), ze({ ourProps: A, theirProps: { ...i, ...D }, slot: k, attrs: i, slots: r, name: "FocusTrap" }), !!(L & 4) && Ge(lr, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: y, features: rr.Focusable })]);
  };
} }), { features: Mc });
function E1(n) {
  let i = B(Cn.slice());
  return vt([n], ([r], [u]) => {
    u === !0 && r === !1 ? hi(() => {
      i.value.splice(0);
    }) : u === !1 && r === !0 && (i.value = Cn.slice());
  }, { flush: "post" }), () => {
    var r;
    return (r = i.value.find((u) => u != null && u.isConnected)) != null ? r : null;
  };
}
function A1({ ownerDocument: n }, i) {
  let r = E1(i);
  Ae(() => {
    ut(() => {
      var u, o;
      i.value || ((u = n.value) == null ? void 0 : u.activeElement) === ((o = n.value) == null ? void 0 : o.body) && tr(r());
    }, { flush: "post" });
  }), yt(() => {
    i.value && tr(r());
  });
}
function L1({ ownerDocument: n, container: i, initialFocus: r }, u) {
  let o = B(null), c = B(!1);
  return Ae(() => c.value = !0), yt(() => c.value = !1), Ae(() => {
    vt([i, r, u], (s, d) => {
      if (s.every((y, _) => (d == null ? void 0 : d[_]) === y) || !u.value)
        return;
      let g = J(i);
      g && hi(() => {
        var y, _;
        if (!c.value)
          return;
        let m = J(r), S = (y = n.value) == null ? void 0 : y.activeElement;
        if (m) {
          if (m === S) {
            o.value = S;
            return;
          }
        } else if (g.contains(S)) {
          o.value = S;
          return;
        }
        m ? tr(m) : pn(g, dt.First | dt.NoScroll) === Ir.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), o.value = (_ = n.value) == null ? void 0 : _.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), o;
}
function R1({ ownerDocument: n, container: i, containers: r, previousActiveElement: u }, o) {
  var c;
  Pc((c = n.value) == null ? void 0 : c.defaultView, "focus", (s) => {
    if (!o.value)
      return;
    let d = Bc(r);
    J(i) instanceof HTMLElement && d.add(J(i));
    let g = u.value;
    if (!g)
      return;
    let y = s.target;
    y && y instanceof HTMLElement ? Fc(d, y) ? (u.value = y, tr(y)) : (s.preventDefault(), s.stopPropagation(), tr(g)) : tr(u.value);
  }, !0);
}
function Fc(n, i) {
  for (let r of n)
    if (r.contains(i))
      return !0;
  return !1;
}
function D1(n) {
  let i = cc(n.getSnapshot());
  return yt(n.subscribe(() => {
    i.value = n.getSnapshot();
  })), i;
}
function P1(n, i) {
  let r = n(), u = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return r;
  }, subscribe(o) {
    return u.add(o), () => u.delete(o);
  }, dispatch(o, ...c) {
    let s = i[o].call(r, ...c);
    s && (r = s, u.forEach((d) => d()));
  } };
}
function B1() {
  let n;
  return { before({ doc: i }) {
    var r;
    let u = i.documentElement;
    n = ((r = i.defaultView) != null ? r : window).innerWidth - u.clientWidth;
  }, after({ doc: i, d: r }) {
    let u = i.documentElement, o = u.clientWidth - u.offsetWidth, c = n - o;
    r.style(u, "paddingRight", `${c}px`);
  } };
}
function M1() {
  return xc() ? { before({ doc: n, d: i, meta: r }) {
    function u(o) {
      return r.containers.flatMap((c) => c()).some((c) => c.contains(o));
    }
    i.microTask(() => {
      var o;
      if (window.getComputedStyle(n.documentElement).scrollBehavior !== "auto") {
        let d = Wn();
        d.style(n.documentElement, "scrollBehavior", "auto"), i.add(() => i.microTask(() => d.dispose()));
      }
      let c = (o = window.scrollY) != null ? o : window.pageYOffset, s = null;
      i.addEventListener(n, "click", (d) => {
        if (d.target instanceof HTMLElement)
          try {
            let g = d.target.closest("a");
            if (!g)
              return;
            let { hash: y } = new URL(g.href), _ = n.querySelector(y);
            _ && !u(_) && (s = _);
          } catch {
          }
      }, !0), i.addEventListener(n, "touchstart", (d) => {
        if (d.target instanceof HTMLElement)
          if (u(d.target)) {
            let g = d.target;
            for (; g.parentElement && u(g.parentElement); )
              g = g.parentElement;
            i.style(g, "overscrollBehavior", "contain");
          } else
            i.style(d.target, "touchAction", "none");
      }), i.addEventListener(n, "touchmove", (d) => {
        if (d.target instanceof HTMLElement) {
          if (d.target.tagName === "INPUT")
            return;
          if (u(d.target)) {
            let g = d.target;
            for (; g.parentElement && g.dataset.headlessuiPortal !== "" && !(g.scrollHeight > g.clientHeight || g.scrollWidth > g.clientWidth); )
              g = g.parentElement;
            g.dataset.headlessuiPortal === "" && d.preventDefault();
          } else
            d.preventDefault();
        }
      }, { passive: !1 }), i.add(() => {
        var d;
        let g = (d = window.scrollY) != null ? d : window.pageYOffset;
        c !== g && window.scrollTo(0, c), s && s.isConnected && (s.scrollIntoView({ block: "nearest" }), s = null);
      });
    });
  } } : {};
}
function F1() {
  return { before({ doc: n, d: i }) {
    i.style(n.documentElement, "overflow", "hidden");
  } };
}
function z1(n) {
  let i = {};
  for (let r of n)
    Object.assign(i, r(i));
  return i;
}
let er = P1(() => /* @__PURE__ */ new Map(), { PUSH(n, i) {
  var r;
  let u = (r = this.get(n)) != null ? r : { doc: n, count: 0, d: Wn(), meta: /* @__PURE__ */ new Set() };
  return u.count++, u.meta.add(i), this.set(n, u), this;
}, POP(n, i) {
  let r = this.get(n);
  return r && (r.count--, r.meta.delete(i)), this;
}, SCROLL_PREVENT({ doc: n, d: i, meta: r }) {
  let u = { doc: n, d: i, meta: z1(r) }, o = [M1(), B1(), F1()];
  o.forEach(({ before: c }) => c == null ? void 0 : c(u)), o.forEach(({ after: c }) => c == null ? void 0 : c(u));
}, SCROLL_ALLOW({ d: n }) {
  n.dispose();
}, TEARDOWN({ doc: n }) {
  this.delete(n);
} });
er.subscribe(() => {
  let n = er.getSnapshot(), i = /* @__PURE__ */ new Map();
  for (let [r] of n)
    i.set(r, r.documentElement.style.overflow);
  for (let r of n.values()) {
    let u = i.get(r.doc) === "hidden", o = r.count !== 0;
    (o && !u || !o && u) && er.dispatch(r.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", r), r.count === 0 && er.dispatch("TEARDOWN", r);
  }
});
function U1(n, i, r) {
  let u = D1(er), o = $(() => {
    let c = n.value ? u.value.get(n.value) : void 0;
    return c ? c.count > 0 : !1;
  });
  return vt([n, i], ([c, s], [d], g) => {
    if (!c || !s)
      return;
    er.dispatch("PUSH", c, r);
    let y = !1;
    g(() => {
      y || (er.dispatch("POP", d ?? c, r), y = !0);
    });
  }, { immediate: !0 }), o;
}
let Ua = /* @__PURE__ */ new Map(), el = /* @__PURE__ */ new Map();
function ec(n, i = B(!0)) {
  ut((r) => {
    var u;
    if (!i.value)
      return;
    let o = J(n);
    if (!o)
      return;
    r(function() {
      var s;
      if (!o)
        return;
      let d = (s = el.get(o)) != null ? s : 1;
      if (d === 1 ? el.delete(o) : el.set(o, d - 1), d !== 1)
        return;
      let g = Ua.get(o);
      g && (g["aria-hidden"] === null ? o.removeAttribute("aria-hidden") : o.setAttribute("aria-hidden", g["aria-hidden"]), o.inert = g.inert, Ua.delete(o));
    });
    let c = (u = el.get(o)) != null ? u : 0;
    el.set(o, c + 1), c === 0 && (Ua.set(o, { "aria-hidden": o.getAttribute("aria-hidden"), inert: o.inert }), o.setAttribute("aria-hidden", "true"), o.inert = !0);
  });
}
function W1({ defaultContainers: n = [], portals: i, mainTreeNodeRef: r } = {}) {
  let u = B(null), o = On(u);
  function c() {
    var s, d, g;
    let y = [];
    for (let _ of n)
      _ !== null && (_ instanceof HTMLElement ? y.push(_) : "value" in _ && _.value instanceof HTMLElement && y.push(_.value));
    if (i != null && i.value)
      for (let _ of i.value)
        y.push(_);
    for (let _ of (s = o == null ? void 0 : o.querySelectorAll("html > *, body > *")) != null ? s : [])
      _ !== document.body && _ !== document.head && _ instanceof HTMLElement && _.id !== "headlessui-portal-root" && (_.contains(J(u)) || _.contains((g = (d = J(u)) == null ? void 0 : d.getRootNode()) == null ? void 0 : g.host) || y.some((m) => _.contains(m)) || y.push(_));
    return y;
  }
  return { resolveContainers: c, contains(s) {
    return c().some((d) => d.contains(s));
  }, mainTreeNodeRef: u, MainTreeNode() {
    return r != null ? null : Ge(lr, { features: rr.Hidden, ref: u });
  } };
}
let zc = Symbol("ForcePortalRootContext");
function H1() {
  return pt(zc, !1);
}
let Va = Q({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(n, { slots: i, attrs: r }) {
  return Ct(zc, n.force), () => {
    let { force: u, ...o } = n;
    return ze({ theirProps: o, ourProps: {}, slot: {}, slots: i, attrs: r, name: "ForcePortalRoot" });
  };
} }), Uc = Symbol("StackContext");
var Na = ((n) => (n[n.Add = 0] = "Add", n[n.Remove = 1] = "Remove", n))(Na || {});
function q1() {
  return pt(Uc, () => {
  });
}
function G1({ type: n, enabled: i, element: r, onUpdate: u }) {
  let o = q1();
  function c(...s) {
    u == null || u(...s), o(...s);
  }
  Ae(() => {
    vt(i, (s, d) => {
      s ? c(0, n, r) : d === !0 && c(1, n, r);
    }, { immediate: !0, flush: "sync" });
  }), yt(() => {
    i.value && c(1, n, r);
  }), Ct(Uc, c);
}
let Wc = Symbol("DescriptionContext");
function V1() {
  let n = pt(Wc, null);
  if (n === null)
    throw new Error("Missing parent");
  return n;
}
function N1({ slot: n = B({}), name: i = "Description", props: r = {} } = {}) {
  let u = B([]);
  function o(c) {
    return u.value.push(c), () => {
      let s = u.value.indexOf(c);
      s !== -1 && u.value.splice(s, 1);
    };
  }
  return Ct(Wc, { register: o, slot: n, name: i, props: r }), $(() => u.value.length > 0 ? u.value.join(" ") : void 0);
}
let j1 = Q({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: null } }, setup(n, { attrs: i, slots: r }) {
  var u;
  let o = (u = n.id) != null ? u : `headlessui-description-${ht()}`, c = V1();
  return Ae(() => yt(c.register(o))), () => {
    let { name: s = "Description", slot: d = B({}), props: g = {} } = c, { ...y } = n, _ = { ...Object.entries(g).reduce((m, [S, k]) => Object.assign(m, { [S]: v(k) }), {}), id: o };
    return ze({ ourProps: _, theirProps: y, slot: d.value, attrs: i, slots: r, name: s });
  };
} });
function K1(n) {
  let i = On(n);
  if (!i) {
    if (n === null)
      return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${n}`);
  }
  let r = i.getElementById("headlessui-portal-root");
  if (r)
    return r;
  let u = i.createElement("div");
  return u.setAttribute("id", "headlessui-portal-root"), i.body.appendChild(u);
}
const ja = /* @__PURE__ */ new WeakMap();
function Y1(n) {
  var i;
  return (i = ja.get(n)) != null ? i : 0;
}
function tc(n, i) {
  let r = i(Y1(n));
  return r <= 0 ? ja.delete(n) : ja.set(n, r), r;
}
let Hc = Q({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(n, { slots: i, attrs: r }) {
  let u = B(null), o = $(() => On(u)), c = H1(), s = pt(qc, null), d = B(c === !0 || s == null ? K1(u.value) : s.resolveTarget());
  d.value && tc(d.value, (S) => S + 1);
  let g = B(!1);
  Ae(() => {
    g.value = !0;
  }), ut(() => {
    c || s != null && (d.value = s.resolveTarget());
  });
  let y = pt(Ka, null), _ = !1, m = qb();
  return vt(u, () => {
    if (_ || !y)
      return;
    let S = J(u);
    S && (yt(y.register(S), m), _ = !0);
  }), yt(() => {
    var S, k;
    let A = (S = o.value) == null ? void 0 : S.getElementById("headlessui-portal-root");
    !A || d.value !== A || tc(d.value, (L) => L - 1) || d.value.children.length > 0 || (k = d.value.parentElement) == null || k.removeChild(d.value);
  }), () => {
    if (!g.value || d.value === null)
      return null;
    let S = { ref: u, "data-headlessui-portal": "" };
    return Ge(Gb, { to: d.value }, ze({ ourProps: S, theirProps: n, slot: {}, attrs: r, slots: i, name: "Portal" }));
  };
} }), Ka = Symbol("PortalParentContext");
function Z1() {
  let n = pt(Ka, null), i = B([]);
  function r(c) {
    return i.value.push(c), n && n.register(c), () => u(c);
  }
  function u(c) {
    let s = i.value.indexOf(c);
    s !== -1 && i.value.splice(s, 1), n && n.unregister(c);
  }
  let o = { register: r, unregister: u, portals: i };
  return [i, Q({ name: "PortalWrapper", setup(c, { slots: s }) {
    return Ct(Ka, o), () => {
      var d;
      return (d = s.default) == null ? void 0 : d.call(s);
    };
  } })];
}
let qc = Symbol("PortalGroupContext"), X1 = Q({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(n, { attrs: i, slots: r }) {
  let u = fc({ resolveTarget() {
    return n.target;
  } });
  return Ct(qc, u), () => {
    let { target: o, ...c } = n;
    return ze({ theirProps: c, ourProps: {}, slot: {}, attrs: i, slots: r, name: "PortalGroup" });
  };
} });
var J1 = ((n) => (n[n.Open = 0] = "Open", n[n.Closed = 1] = "Closed", n))(J1 || {});
let Ya = Symbol("DialogContext");
function ul(n) {
  let i = pt(Ya, null);
  if (i === null) {
    let r = new Error(`<${n} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, ul), r;
  }
  return i;
}
let ai = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", Q1 = Q({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: ai }, initialFocus: { type: Object, default: null }, id: { type: String, default: null }, role: { type: String, default: "dialog" } }, emits: { close: (n) => !0 }, setup(n, { emit: i, attrs: r, slots: u, expose: o }) {
  var c, s;
  let d = (c = n.id) != null ? c : `headlessui-dialog-${ht()}`, g = B(!1);
  Ae(() => {
    g.value = !0;
  });
  let y = !1, _ = $(() => n.role === "dialog" || n.role === "alertdialog" ? n.role : (y || (y = !0, console.warn(`Invalid role [${_}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog")), m = B(0), S = sl(), k = $(() => n.open === ai && S !== null ? (S.value & it.Open) === it.Open : n.open), A = B(null), L = $(() => On(A));
  if (o({ el: A, $el: A }), !(n.open !== ai || S !== null))
    throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof k.value != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${k.value === ai ? void 0 : n.open}`);
  let z = $(() => g.value && k.value ? 0 : 1), Y = $(() => z.value === 0), D = $(() => m.value > 1), O = pt(Ya, null) !== null, [E, w] = Z1(), { resolveContainers: M, mainTreeNodeRef: W, MainTreeNode: R } = W1({ portals: E, defaultContainers: [$(() => {
    var we;
    return (we = fe.panelRef.value) != null ? we : A.value;
  })] }), q = $(() => D.value ? "parent" : "leaf"), G = $(() => S !== null ? (S.value & it.Closing) === it.Closing : !1), X = $(() => O || G.value ? !1 : Y.value), ve = $(() => {
    var we, Qe, Ot;
    return (Ot = Array.from((Qe = (we = L.value) == null ? void 0 : we.querySelectorAll("body > *")) != null ? Qe : []).find((Et) => Et.id === "headlessui-portal-root" ? !1 : Et.contains(J(W)) && Et instanceof HTMLElement)) != null ? Ot : null;
  });
  ec(ve, X);
  let pe = $(() => D.value ? !0 : Y.value), Ce = $(() => {
    var we, Qe, Ot;
    return (Ot = Array.from((Qe = (we = L.value) == null ? void 0 : we.querySelectorAll("[data-headlessui-portal]")) != null ? Qe : []).find((Et) => Et.contains(J(W)) && Et instanceof HTMLElement)) != null ? Ot : null;
  });
  ec(Ce, pe), G1({ type: "Dialog", enabled: $(() => z.value === 0), element: A, onUpdate: (we, Qe) => {
    if (Qe === "Dialog")
      return He(we, { [Na.Add]: () => m.value += 1, [Na.Remove]: () => m.value -= 1 });
  } });
  let de = N1({ name: "DialogDescription", slot: $(() => ({ open: k.value })) }), te = B(null), fe = { titleId: te, panelRef: B(null), dialogState: z, setTitleId(we) {
    te.value !== we && (te.value = we);
  }, close() {
    i("close", !1);
  } };
  Ct(Ya, fe);
  let ke = $(() => !(!Y.value || D.value));
  ro(M, (we, Qe) => {
    we.preventDefault(), fe.close(), xt(() => Qe == null ? void 0 : Qe.focus());
  }, ke);
  let tt = $(() => !(D.value || z.value !== 0));
  Pc((s = L.value) == null ? void 0 : s.defaultView, "keydown", (we) => {
    tt.value && (we.defaultPrevented || we.key === Se.Escape && (we.preventDefault(), we.stopPropagation(), fe.close()));
  });
  let Le = $(() => !(G.value || z.value !== 0 || O));
  return U1(L, Le, (we) => {
    var Qe;
    return { containers: [...(Qe = we.containers) != null ? Qe : [], M] };
  }), ut((we) => {
    if (z.value !== 0)
      return;
    let Qe = J(A);
    if (!Qe)
      return;
    let Ot = new ResizeObserver((Et) => {
      for (let un of Et) {
        let mn = un.target.getBoundingClientRect();
        mn.x === 0 && mn.y === 0 && mn.width === 0 && mn.height === 0 && fe.close();
      }
    });
    Ot.observe(Qe), we(() => Ot.disconnect());
  }), () => {
    let { open: we, initialFocus: Qe, ...Ot } = n, Et = { ...r, ref: A, id: d, role: _.value, "aria-modal": z.value === 0 ? !0 : void 0, "aria-labelledby": te.value, "aria-describedby": de.value }, un = { open: z.value === 0 };
    return Ge(Va, { force: !0 }, () => [Ge(Hc, () => Ge(X1, { target: A.value }, () => Ge(Va, { force: !1 }, () => Ge(Qr, { initialFocus: Qe, containers: M, features: Y.value ? He(q.value, { parent: Qr.features.RestoreFocus, leaf: Qr.features.All & ~Qr.features.FocusLock }) : Qr.features.None }, () => Ge(w, {}, () => ze({ ourProps: Et, theirProps: { ...Ot, ...r }, slot: un, attrs: r, slots: u, visible: z.value === 0, features: tn.RenderStrategy | tn.Static, name: "Dialog" })))))), Ge(R)]);
  };
} });
Q({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(n, { attrs: i, slots: r }) {
  var u;
  let o = (u = n.id) != null ? u : `headlessui-dialog-overlay-${ht()}`, c = ul("DialogOverlay");
  function s(d) {
    d.target === d.currentTarget && (d.preventDefault(), d.stopPropagation(), c.close());
  }
  return () => {
    let { ...d } = n;
    return ze({ ourProps: { id: o, "aria-hidden": !0, onClick: s }, theirProps: d, slot: { open: c.dialogState.value === 0 }, attrs: i, slots: r, name: "DialogOverlay" });
  };
} });
Q({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, inheritAttrs: !1, setup(n, { attrs: i, slots: r, expose: u }) {
  var o;
  let c = (o = n.id) != null ? o : `headlessui-dialog-backdrop-${ht()}`, s = ul("DialogBackdrop"), d = B(null);
  return u({ el: d, $el: d }), Ae(() => {
    if (s.panelRef.value === null)
      throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { ...g } = n, y = { id: c, ref: d, "aria-hidden": !0 };
    return Ge(Va, { force: !0 }, () => Ge(Hc, () => ze({ ourProps: y, theirProps: { ...i, ...g }, slot: { open: s.dialogState.value === 0 }, attrs: i, slots: r, name: "DialogBackdrop" })));
  };
} });
let e_ = Q({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(n, { attrs: i, slots: r, expose: u }) {
  var o;
  let c = (o = n.id) != null ? o : `headlessui-dialog-panel-${ht()}`, s = ul("DialogPanel");
  u({ el: s.panelRef, $el: s.panelRef });
  function d(g) {
    g.stopPropagation();
  }
  return () => {
    let { ...g } = n, y = { id: c, ref: s.panelRef, onClick: d };
    return ze({ ourProps: y, theirProps: g, slot: { open: s.dialogState.value === 0 }, attrs: i, slots: r, name: "DialogPanel" });
  };
} }), nc = Q({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: null } }, setup(n, { attrs: i, slots: r }) {
  var u;
  let o = (u = n.id) != null ? u : `headlessui-dialog-title-${ht()}`, c = ul("DialogTitle");
  return Ae(() => {
    c.setTitleId(o), yt(() => c.setTitleId(null));
  }), () => {
    let { ...s } = n;
    return ze({ ourProps: { id: o }, theirProps: s, slot: { open: c.dialogState.value === 0 }, attrs: i, slots: r, name: "DialogTitle" });
  };
} }), t_ = j1, rc = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function lc(n) {
  var i, r;
  let u = (i = n.innerText) != null ? i : "", o = n.cloneNode(!0);
  if (!(o instanceof HTMLElement))
    return u;
  let c = !1;
  for (let d of o.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    d.remove(), c = !0;
  let s = c ? (r = o.innerText) != null ? r : "" : u;
  return rc.test(s) && (s = s.replace(rc, "")), s;
}
function n_(n) {
  let i = n.getAttribute("aria-label");
  if (typeof i == "string")
    return i.trim();
  let r = n.getAttribute("aria-labelledby");
  if (r) {
    let u = r.split(" ").map((o) => {
      let c = document.getElementById(o);
      if (c) {
        let s = c.getAttribute("aria-label");
        return typeof s == "string" ? s.trim() : lc(c).trim();
      }
      return null;
    }).filter(Boolean);
    if (u.length > 0)
      return u.join(", ");
  }
  return lc(n).trim();
}
function r_(n) {
  let i = B(""), r = B("");
  return () => {
    let u = J(n);
    if (!u)
      return "";
    let o = u.innerText;
    if (i.value === o)
      return r.value;
    let c = n_(u).trim().toLowerCase();
    return i.value = o, r.value = c, c;
  };
}
function l_(n, i) {
  return n === i;
}
var i_ = ((n) => (n[n.Open = 0] = "Open", n[n.Closed = 1] = "Closed", n))(i_ || {}), a_ = ((n) => (n[n.Single = 0] = "Single", n[n.Multi = 1] = "Multi", n))(a_ || {}), o_ = ((n) => (n[n.Pointer = 0] = "Pointer", n[n.Other = 1] = "Other", n))(o_ || {});
function s_(n) {
  requestAnimationFrame(() => requestAnimationFrame(n));
}
let Gc = Symbol("ListboxContext");
function cl(n) {
  let i = pt(Gc, null);
  if (i === null) {
    let r = new Error(`<${n} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, cl), r;
  }
  return i;
}
let u_ = Q({ name: "Listbox", emits: { "update:modelValue": (n) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => l_ }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(n, { slots: i, attrs: r, emit: u }) {
  let o = B(1), c = B(null), s = B(null), d = B(null), g = B([]), y = B(""), _ = B(null), m = B(1);
  function S(O = (E) => E) {
    let E = _.value !== null ? g.value[_.value] : null, w = zn(O(g.value.slice()), (W) => J(W.dataRef.domRef)), M = E ? w.indexOf(E) : null;
    return M === -1 && (M = null), { options: w, activeOptionIndex: M };
  }
  let k = $(() => n.multiple ? 1 : 0), [A, L] = _c($(() => n.modelValue), (O) => u("update:modelValue", O), $(() => n.defaultValue)), z = $(() => A.value === void 0 ? He(k.value, { 1: [], 0: void 0 }) : A.value), Y = { listboxState: o, value: z, mode: k, compare(O, E) {
    if (typeof n.by == "string") {
      let w = n.by;
      return (O == null ? void 0 : O[w]) === (E == null ? void 0 : E[w]);
    }
    return n.by(O, E);
  }, orientation: $(() => n.horizontal ? "horizontal" : "vertical"), labelRef: c, buttonRef: s, optionsRef: d, disabled: $(() => n.disabled), options: g, searchQuery: y, activeOptionIndex: _, activationTrigger: m, closeListbox() {
    n.disabled || o.value !== 1 && (o.value = 1, _.value = null);
  }, openListbox() {
    n.disabled || o.value !== 0 && (o.value = 0);
  }, goToOption(O, E, w) {
    if (n.disabled || o.value === 1)
      return;
    let M = S(), W = Ga(O === De.Specific ? { focus: De.Specific, id: E } : { focus: O }, { resolveItems: () => M.options, resolveActiveIndex: () => M.activeOptionIndex, resolveId: (R) => R.id, resolveDisabled: (R) => R.dataRef.disabled });
    y.value = "", _.value = W, m.value = w ?? 1, g.value = M.options;
  }, search(O) {
    if (n.disabled || o.value === 1)
      return;
    let E = y.value !== "" ? 0 : 1;
    y.value += O.toLowerCase();
    let w = (_.value !== null ? g.value.slice(_.value + E).concat(g.value.slice(0, _.value + E)) : g.value).find((W) => W.dataRef.textValue.startsWith(y.value) && !W.dataRef.disabled), M = w ? g.value.indexOf(w) : -1;
    M === -1 || M === _.value || (_.value = M, m.value = 1);
  }, clearSearch() {
    n.disabled || o.value !== 1 && y.value !== "" && (y.value = "");
  }, registerOption(O, E) {
    let w = S((M) => [...M, { id: O, dataRef: E }]);
    g.value = w.options, _.value = w.activeOptionIndex;
  }, unregisterOption(O) {
    let E = S((w) => {
      let M = w.findIndex((W) => W.id === O);
      return M !== -1 && w.splice(M, 1), w;
    });
    g.value = E.options, _.value = E.activeOptionIndex, m.value = 1;
  }, theirOnChange(O) {
    n.disabled || L(O);
  }, select(O) {
    n.disabled || L(He(k.value, { 0: () => O, 1: () => {
      let E = st(Y.value.value).slice(), w = st(O), M = E.findIndex((W) => Y.compare(w, st(W)));
      return M === -1 ? E.push(w) : E.splice(M, 1), E;
    } }));
  } };
  ro([s, d], (O, E) => {
    var w;
    Y.closeListbox(), wc(E, no.Loose) || (O.preventDefault(), (w = J(s)) == null || w.focus());
  }, $(() => o.value === 0)), Ct(Gc, Y), io($(() => He(o.value, { 0: it.Open, 1: it.Closed })));
  let D = $(() => {
    var O;
    return (O = J(s)) == null ? void 0 : O.closest("form");
  });
  return Ae(() => {
    vt([D], () => {
      if (!D.value || n.defaultValue === void 0)
        return;
      function O() {
        Y.theirOnChange(n.defaultValue);
      }
      return D.value.addEventListener("reset", O), () => {
        var E;
        (E = D.value) == null || E.removeEventListener("reset", O);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: O, modelValue: E, disabled: w, form: M, ...W } = n, R = { open: o.value === 0, disabled: w, value: z.value };
    return Ge(Be, [...O != null && z.value != null ? ao({ [O]: z.value }).map(([q, G]) => Ge(lr, kc({ features: rr.Hidden, key: q, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: M, disabled: w, name: q, value: G }))) : [], ze({ ourProps: {}, theirProps: { ...r, ...ar(W, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: R, slots: i, attrs: r, name: "Listbox" })]);
  };
} });
Q({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(n, { attrs: i, slots: r }) {
  var u;
  let o = (u = n.id) != null ? u : `headlessui-listbox-label-${ht()}`, c = cl("ListboxLabel");
  function s() {
    var d;
    (d = J(c.buttonRef)) == null || d.focus({ preventScroll: !0 });
  }
  return () => {
    let d = { open: c.listboxState.value === 0, disabled: c.disabled.value }, { ...g } = n, y = { id: o, ref: c.labelRef, onClick: s };
    return ze({ ourProps: y, theirProps: g, slot: d, attrs: i, slots: r, name: "ListboxLabel" });
  };
} });
let c_ = Q({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(n, { attrs: i, slots: r, expose: u }) {
  var o;
  let c = (o = n.id) != null ? o : `headlessui-listbox-button-${ht()}`, s = cl("ListboxButton");
  u({ el: s.buttonRef, $el: s.buttonRef });
  function d(m) {
    switch (m.key) {
      case Se.Space:
      case Se.Enter:
      case Se.ArrowDown:
        m.preventDefault(), s.openListbox(), xt(() => {
          var S;
          (S = J(s.optionsRef)) == null || S.focus({ preventScroll: !0 }), s.value.value || s.goToOption(De.First);
        });
        break;
      case Se.ArrowUp:
        m.preventDefault(), s.openListbox(), xt(() => {
          var S;
          (S = J(s.optionsRef)) == null || S.focus({ preventScroll: !0 }), s.value.value || s.goToOption(De.Last);
        });
        break;
    }
  }
  function g(m) {
    switch (m.key) {
      case Se.Space:
        m.preventDefault();
        break;
    }
  }
  function y(m) {
    s.disabled.value || (s.listboxState.value === 0 ? (s.closeListbox(), xt(() => {
      var S;
      return (S = J(s.buttonRef)) == null ? void 0 : S.focus({ preventScroll: !0 });
    })) : (m.preventDefault(), s.openListbox(), s_(() => {
      var S;
      return (S = J(s.optionsRef)) == null ? void 0 : S.focus({ preventScroll: !0 });
    })));
  }
  let _ = lo($(() => ({ as: n.as, type: i.type })), s.buttonRef);
  return () => {
    var m, S;
    let k = { open: s.listboxState.value === 0, disabled: s.disabled.value, value: s.value.value }, { ...A } = n, L = { ref: s.buttonRef, id: c, type: _.value, "aria-haspopup": "listbox", "aria-controls": (m = J(s.optionsRef)) == null ? void 0 : m.id, "aria-expanded": s.listboxState.value === 0, "aria-labelledby": s.labelRef.value ? [(S = J(s.labelRef)) == null ? void 0 : S.id, c].join(" ") : void 0, disabled: s.disabled.value === !0 ? !0 : void 0, onKeydown: d, onKeyup: g, onClick: y };
    return ze({ ourProps: L, theirProps: A, slot: k, attrs: i, slots: r, name: "ListboxButton" });
  };
} }), d_ = Q({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(n, { attrs: i, slots: r, expose: u }) {
  var o;
  let c = (o = n.id) != null ? o : `headlessui-listbox-options-${ht()}`, s = cl("ListboxOptions"), d = B(null);
  u({ el: s.optionsRef, $el: s.optionsRef });
  function g(m) {
    switch (d.value && clearTimeout(d.value), m.key) {
      case Se.Space:
        if (s.searchQuery.value !== "")
          return m.preventDefault(), m.stopPropagation(), s.search(m.key);
      case Se.Enter:
        if (m.preventDefault(), m.stopPropagation(), s.activeOptionIndex.value !== null) {
          let S = s.options.value[s.activeOptionIndex.value];
          s.select(S.dataRef.value);
        }
        s.mode.value === 0 && (s.closeListbox(), xt(() => {
          var S;
          return (S = J(s.buttonRef)) == null ? void 0 : S.focus({ preventScroll: !0 });
        }));
        break;
      case He(s.orientation.value, { vertical: Se.ArrowDown, horizontal: Se.ArrowRight }):
        return m.preventDefault(), m.stopPropagation(), s.goToOption(De.Next);
      case He(s.orientation.value, { vertical: Se.ArrowUp, horizontal: Se.ArrowLeft }):
        return m.preventDefault(), m.stopPropagation(), s.goToOption(De.Previous);
      case Se.Home:
      case Se.PageUp:
        return m.preventDefault(), m.stopPropagation(), s.goToOption(De.First);
      case Se.End:
      case Se.PageDown:
        return m.preventDefault(), m.stopPropagation(), s.goToOption(De.Last);
      case Se.Escape:
        m.preventDefault(), m.stopPropagation(), s.closeListbox(), xt(() => {
          var S;
          return (S = J(s.buttonRef)) == null ? void 0 : S.focus({ preventScroll: !0 });
        });
        break;
      case Se.Tab:
        m.preventDefault(), m.stopPropagation();
        break;
      default:
        m.key.length === 1 && (s.search(m.key), d.value = setTimeout(() => s.clearSearch(), 350));
        break;
    }
  }
  let y = sl(), _ = $(() => y !== null ? (y.value & it.Open) === it.Open : s.listboxState.value === 0);
  return () => {
    var m, S;
    let k = { open: s.listboxState.value === 0 }, { ...A } = n, L = { "aria-activedescendant": s.activeOptionIndex.value === null || (m = s.options.value[s.activeOptionIndex.value]) == null ? void 0 : m.id, "aria-multiselectable": s.mode.value === 1 ? !0 : void 0, "aria-labelledby": (S = J(s.buttonRef)) == null ? void 0 : S.id, "aria-orientation": s.orientation.value, id: c, onKeydown: g, role: "listbox", tabIndex: 0, ref: s.optionsRef };
    return ze({ ourProps: L, theirProps: A, slot: k, attrs: i, slots: r, features: tn.RenderStrategy | tn.Static, visible: _.value, name: "ListboxOptions" });
  };
} }), f_ = Q({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(n, { slots: i, attrs: r, expose: u }) {
  var o;
  let c = (o = n.id) != null ? o : `headlessui-listbox-option-${ht()}`, s = cl("ListboxOption"), d = B(null);
  u({ el: d, $el: d });
  let g = $(() => s.activeOptionIndex.value !== null ? s.options.value[s.activeOptionIndex.value].id === c : !1), y = $(() => He(s.mode.value, { 0: () => s.compare(st(s.value.value), st(n.value)), 1: () => st(s.value.value).some((O) => s.compare(st(O), st(n.value))) })), _ = $(() => He(s.mode.value, { 1: () => {
    var O;
    let E = st(s.value.value);
    return ((O = s.options.value.find((w) => E.some((M) => s.compare(st(M), st(w.dataRef.value))))) == null ? void 0 : O.id) === c;
  }, 0: () => y.value })), m = r_(d), S = $(() => ({ disabled: n.disabled, value: n.value, get textValue() {
    return m();
  }, domRef: d }));
  Ae(() => s.registerOption(c, S)), yt(() => s.unregisterOption(c)), Ae(() => {
    vt([s.listboxState, y], () => {
      s.listboxState.value === 0 && y.value && He(s.mode.value, { 1: () => {
        _.value && s.goToOption(De.Specific, c);
      }, 0: () => {
        s.goToOption(De.Specific, c);
      } });
    }, { immediate: !0 });
  }), ut(() => {
    s.listboxState.value === 0 && g.value && s.activationTrigger.value !== 0 && xt(() => {
      var O, E;
      return (E = (O = J(d)) == null ? void 0 : O.scrollIntoView) == null ? void 0 : E.call(O, { block: "nearest" });
    });
  });
  function k(O) {
    if (n.disabled)
      return O.preventDefault();
    s.select(n.value), s.mode.value === 0 && (s.closeListbox(), xt(() => {
      var E;
      return (E = J(s.buttonRef)) == null ? void 0 : E.focus({ preventScroll: !0 });
    }));
  }
  function A() {
    if (n.disabled)
      return s.goToOption(De.Nothing);
    s.goToOption(De.Specific, c);
  }
  let L = Ic();
  function z(O) {
    L.update(O);
  }
  function Y(O) {
    L.wasMoved(O) && (n.disabled || g.value || s.goToOption(De.Specific, c, 0));
  }
  function D(O) {
    L.wasMoved(O) && (n.disabled || g.value && s.goToOption(De.Nothing));
  }
  return () => {
    let { disabled: O } = n, E = { active: g.value, selected: y.value, disabled: O }, { value: w, disabled: M, ...W } = n, R = { id: c, ref: d, role: "option", tabIndex: O === !0 ? void 0 : -1, "aria-disabled": O === !0 ? !0 : void 0, "aria-selected": y.value, disabled: void 0, onClick: k, onFocus: A, onPointerenter: z, onMouseenter: z, onPointermove: Y, onMousemove: Y, onPointerleave: D, onMouseleave: D };
    return ze({ ourProps: R, theirProps: W, slot: E, attrs: r, slots: i, name: "ListboxOption" });
  };
} }), v_ = Q({ props: { onFocus: { type: Function, required: !0 } }, setup(n) {
  let i = B(!0);
  return () => i.value ? Ge(lr, { as: "button", type: "button", features: rr.Focusable, onFocus(r) {
    r.preventDefault();
    let u, o = 50;
    function c() {
      var s;
      if (o-- <= 0) {
        u && cancelAnimationFrame(u);
        return;
      }
      if ((s = n.onFocus) != null && s.call(n)) {
        i.value = !1, cancelAnimationFrame(u);
        return;
      }
      u = requestAnimationFrame(c);
    }
    u = requestAnimationFrame(c);
  } }) : null;
} });
var p_ = ((n) => (n[n.Forwards = 0] = "Forwards", n[n.Backwards = 1] = "Backwards", n))(p_ || {}), h_ = ((n) => (n[n.Less = -1] = "Less", n[n.Equal = 0] = "Equal", n[n.Greater = 1] = "Greater", n))(h_ || {});
let Vc = Symbol("TabsContext");
function dl(n) {
  let i = pt(Vc, null);
  if (i === null) {
    let r = new Error(`<${n} /> is missing a parent <TabGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, dl), r;
  }
  return i;
}
let oo = Symbol("TabsSSRContext"), m_ = Q({ name: "TabGroup", emits: { change: (n) => !0 }, props: { as: { type: [Object, String], default: "template" }, selectedIndex: { type: [Number], default: null }, defaultIndex: { type: [Number], default: 0 }, vertical: { type: [Boolean], default: !1 }, manual: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(n, { slots: i, attrs: r, emit: u }) {
  var o;
  let c = B((o = n.selectedIndex) != null ? o : n.defaultIndex), s = B([]), d = B([]), g = $(() => n.selectedIndex !== null), y = $(() => g.value ? n.selectedIndex : c.value);
  function _(L) {
    var z;
    let Y = zn(m.tabs.value, J), D = zn(m.panels.value, J), O = Y.filter((E) => {
      var w;
      return !((w = J(E)) != null && w.hasAttribute("disabled"));
    });
    if (L < 0 || L > Y.length - 1) {
      let E = He(c.value === null ? 0 : Math.sign(L - c.value), { [-1]: () => 1, 0: () => He(Math.sign(L), { [-1]: () => 0, 0: () => 0, 1: () => 1 }), 1: () => 0 }), w = He(E, { 0: () => Y.indexOf(O[0]), 1: () => Y.indexOf(O[O.length - 1]) });
      w !== -1 && (c.value = w), m.tabs.value = Y, m.panels.value = D;
    } else {
      let E = Y.slice(0, L), w = [...Y.slice(L), ...E].find((W) => O.includes(W));
      if (!w)
        return;
      let M = (z = Y.indexOf(w)) != null ? z : m.selectedIndex.value;
      M === -1 && (M = m.selectedIndex.value), c.value = M, m.tabs.value = Y, m.panels.value = D;
    }
  }
  let m = { selectedIndex: $(() => {
    var L, z;
    return (z = (L = c.value) != null ? L : n.defaultIndex) != null ? z : null;
  }), orientation: $(() => n.vertical ? "vertical" : "horizontal"), activation: $(() => n.manual ? "manual" : "auto"), tabs: s, panels: d, setSelectedIndex(L) {
    y.value !== L && u("change", L), g.value || _(L);
  }, registerTab(L) {
    var z;
    if (s.value.includes(L))
      return;
    let Y = s.value[c.value];
    if (s.value.push(L), s.value = zn(s.value, J), !g.value) {
      let D = (z = s.value.indexOf(Y)) != null ? z : c.value;
      D !== -1 && (c.value = D);
    }
  }, unregisterTab(L) {
    let z = s.value.indexOf(L);
    z !== -1 && s.value.splice(z, 1);
  }, registerPanel(L) {
    d.value.includes(L) || (d.value.push(L), d.value = zn(d.value, J));
  }, unregisterPanel(L) {
    let z = d.value.indexOf(L);
    z !== -1 && d.value.splice(z, 1);
  } };
  Ct(Vc, m);
  let S = B({ tabs: [], panels: [] }), k = B(!1);
  Ae(() => {
    k.value = !0;
  }), Ct(oo, $(() => k.value ? null : S.value));
  let A = $(() => n.selectedIndex);
  return Ae(() => {
    vt([A], () => {
      var L;
      return _((L = n.selectedIndex) != null ? L : n.defaultIndex);
    }, { immediate: !0 });
  }), ut(() => {
    if (!g.value || y.value == null || m.tabs.value.length <= 0)
      return;
    let L = zn(m.tabs.value, J);
    L.some((z, Y) => J(m.tabs.value[Y]) !== J(z)) && m.setSelectedIndex(L.findIndex((z) => J(z) === J(m.tabs.value[y.value])));
  }), () => {
    let L = { selectedIndex: c.value };
    return Ge(Be, [s.value.length <= 0 && Ge(v_, { onFocus: () => {
      for (let z of s.value) {
        let Y = J(z);
        if ((Y == null ? void 0 : Y.tabIndex) === 0)
          return Y.focus(), !0;
      }
      return !1;
    } }), ze({ theirProps: { ...r, ...ar(n, ["selectedIndex", "defaultIndex", "manual", "vertical", "onChange"]) }, ourProps: {}, slot: L, slots: i, attrs: r, name: "TabGroup" })]);
  };
} }), g_ = Q({ name: "TabList", props: { as: { type: [Object, String], default: "div" } }, setup(n, { attrs: i, slots: r }) {
  let u = dl("TabList");
  return () => {
    let o = { selectedIndex: u.selectedIndex.value }, c = { role: "tablist", "aria-orientation": u.orientation.value };
    return ze({ ourProps: c, theirProps: n, slot: o, attrs: i, slots: r, name: "TabList" });
  };
} }), b_ = Q({ name: "Tab", props: { as: { type: [Object, String], default: "button" }, disabled: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, setup(n, { attrs: i, slots: r, expose: u }) {
  var o;
  let c = (o = n.id) != null ? o : `headlessui-tabs-tab-${ht()}`, s = dl("Tab"), d = B(null);
  u({ el: d, $el: d }), Ae(() => s.registerTab(d)), yt(() => s.unregisterTab(d));
  let g = pt(oo), y = $(() => {
    if (g.value) {
      let D = g.value.tabs.indexOf(c);
      return D === -1 ? g.value.tabs.push(c) - 1 : D;
    }
    return -1;
  }), _ = $(() => {
    let D = s.tabs.value.indexOf(d);
    return D === -1 ? y.value : D;
  }), m = $(() => _.value === s.selectedIndex.value);
  function S(D) {
    var O;
    let E = D();
    if (E === Ir.Success && s.activation.value === "auto") {
      let w = (O = On(d)) == null ? void 0 : O.activeElement, M = s.tabs.value.findIndex((W) => J(W) === w);
      M !== -1 && s.setSelectedIndex(M);
    }
    return E;
  }
  function k(D) {
    let O = s.tabs.value.map((E) => J(E)).filter(Boolean);
    if (D.key === Se.Space || D.key === Se.Enter) {
      D.preventDefault(), D.stopPropagation(), s.setSelectedIndex(_.value);
      return;
    }
    switch (D.key) {
      case Se.Home:
      case Se.PageUp:
        return D.preventDefault(), D.stopPropagation(), S(() => pn(O, dt.First));
      case Se.End:
      case Se.PageDown:
        return D.preventDefault(), D.stopPropagation(), S(() => pn(O, dt.Last));
    }
    if (S(() => He(s.orientation.value, { vertical() {
      return D.key === Se.ArrowUp ? pn(O, dt.Previous | dt.WrapAround) : D.key === Se.ArrowDown ? pn(O, dt.Next | dt.WrapAround) : Ir.Error;
    }, horizontal() {
      return D.key === Se.ArrowLeft ? pn(O, dt.Previous | dt.WrapAround) : D.key === Se.ArrowRight ? pn(O, dt.Next | dt.WrapAround) : Ir.Error;
    } })) === Ir.Success)
      return D.preventDefault();
  }
  let A = B(!1);
  function L() {
    var D;
    A.value || (A.value = !0, !n.disabled && ((D = J(d)) == null || D.focus({ preventScroll: !0 }), s.setSelectedIndex(_.value), hi(() => {
      A.value = !1;
    })));
  }
  function z(D) {
    D.preventDefault();
  }
  let Y = lo($(() => ({ as: n.as, type: i.type })), d);
  return () => {
    var D, O;
    let E = { selected: m.value, disabled: (D = n.disabled) != null ? D : !1 }, { ...w } = n, M = { ref: d, onKeydown: k, onMousedown: z, onClick: L, id: c, role: "tab", type: Y.value, "aria-controls": (O = J(s.panels.value[_.value])) == null ? void 0 : O.id, "aria-selected": m.value, tabIndex: m.value ? 0 : -1, disabled: n.disabled ? !0 : void 0 };
    return ze({ ourProps: M, theirProps: w, slot: E, attrs: i, slots: r, name: "Tab" });
  };
} });
Q({ name: "TabPanels", props: { as: { type: [Object, String], default: "div" } }, setup(n, { slots: i, attrs: r }) {
  let u = dl("TabPanels");
  return () => {
    let o = { selectedIndex: u.selectedIndex.value };
    return ze({ theirProps: n, ourProps: {}, slot: o, attrs: r, slots: i, name: "TabPanels" });
  };
} });
Q({ name: "TabPanel", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null }, tabIndex: { type: Number, default: 0 } }, setup(n, { attrs: i, slots: r, expose: u }) {
  var o;
  let c = (o = n.id) != null ? o : `headlessui-tabs-panel-${ht()}`, s = dl("TabPanel"), d = B(null);
  u({ el: d, $el: d }), Ae(() => s.registerPanel(d)), yt(() => s.unregisterPanel(d));
  let g = pt(oo), y = $(() => {
    if (g.value) {
      let S = g.value.panels.indexOf(c);
      return S === -1 ? g.value.panels.push(c) - 1 : S;
    }
    return -1;
  }), _ = $(() => {
    let S = s.panels.value.indexOf(d);
    return S === -1 ? y.value : S;
  }), m = $(() => _.value === s.selectedIndex.value);
  return () => {
    var S;
    let k = { selected: m.value }, { tabIndex: A, ...L } = n, z = { ref: d, id: c, role: "tabpanel", "aria-labelledby": (S = J(s.tabs.value[_.value])) == null ? void 0 : S.id, tabIndex: m.value ? A : -1 };
    return !m.value && n.unmount && !n.static ? Ge(lr, { as: "span", "aria-hidden": !0, ...z }) : ze({ ourProps: z, theirProps: L, slot: k, attrs: i, slots: r, features: tn.Static | tn.RenderStrategy, visible: m.value, name: "TabPanel" });
  };
} });
function y_(n) {
  let i = { called: !1 };
  return (...r) => {
    if (!i.called)
      return i.called = !0, n(...r);
  };
}
function Wa(n, ...i) {
  n && i.length > 0 && n.classList.add(...i);
}
function oi(n, ...i) {
  n && i.length > 0 && n.classList.remove(...i);
}
var Za = ((n) => (n.Finished = "finished", n.Cancelled = "cancelled", n))(Za || {});
function __(n, i) {
  let r = Wn();
  if (!n)
    return r.dispose;
  let { transitionDuration: u, transitionDelay: o } = getComputedStyle(n), [c, s] = [u, o].map((d) => {
    let [g = 0] = d.split(",").filter(Boolean).map((y) => y.includes("ms") ? parseFloat(y) : parseFloat(y) * 1e3).sort((y, _) => _ - y);
    return g;
  });
  return c !== 0 ? r.setTimeout(() => i("finished"), c + s) : i("finished"), r.add(() => i("cancelled")), r.dispose;
}
function ic(n, i, r, u, o, c) {
  let s = Wn(), d = c !== void 0 ? y_(c) : () => {
  };
  return oi(n, ...o), Wa(n, ...i, ...r), s.nextFrame(() => {
    oi(n, ...r), Wa(n, ...u), s.add(__(n, (g) => (oi(n, ...u, ...i), Wa(n, ...o), d(g))));
  }), s.add(() => oi(n, ...i, ...r, ...u, ...o)), s.add(() => d("cancelled")), s.dispose;
}
function Jn(n = "") {
  return n.split(/\s+/).filter((i) => i.length > 1);
}
let so = Symbol("TransitionContext");
var w_ = ((n) => (n.Visible = "visible", n.Hidden = "hidden", n))(w_ || {});
function x_() {
  return pt(so, null) !== null;
}
function S_() {
  let n = pt(so, null);
  if (n === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return n;
}
function T_() {
  let n = pt(uo, null);
  if (n === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return n;
}
let uo = Symbol("NestingContext");
function mi(n) {
  return "children" in n ? mi(n.children) : n.value.filter(({ state: i }) => i === "visible").length > 0;
}
function Nc(n) {
  let i = B([]), r = B(!1);
  Ae(() => r.value = !0), yt(() => r.value = !1);
  function u(c, s = Un.Hidden) {
    let d = i.value.findIndex(({ id: g }) => g === c);
    d !== -1 && (He(s, { [Un.Unmount]() {
      i.value.splice(d, 1);
    }, [Un.Hidden]() {
      i.value[d].state = "hidden";
    } }), !mi(i) && r.value && (n == null || n()));
  }
  function o(c) {
    let s = i.value.find(({ id: d }) => d === c);
    return s ? s.state !== "visible" && (s.state = "visible") : i.value.push({ id: c, state: "visible" }), () => u(c, Un.Unmount);
  }
  return { children: i, register: o, unregister: u };
}
let jc = tn.RenderStrategy, Kc = Q({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(n, { emit: i, attrs: r, slots: u, expose: o }) {
  let c = B(0);
  function s() {
    c.value |= it.Opening, i("beforeEnter");
  }
  function d() {
    c.value &= ~it.Opening, i("afterEnter");
  }
  function g() {
    c.value |= it.Closing, i("beforeLeave");
  }
  function y() {
    c.value &= ~it.Closing, i("afterLeave");
  }
  if (!x_() && m1())
    return () => Ge(Yc, { ...n, onBeforeEnter: s, onAfterEnter: d, onBeforeLeave: g, onAfterLeave: y }, u);
  let _ = B(null), m = $(() => n.unmount ? Un.Unmount : Un.Hidden);
  o({ el: _, $el: _ });
  let { show: S, appear: k } = S_(), { register: A, unregister: L } = T_(), z = B(S.value ? "visible" : "hidden"), Y = { value: !0 }, D = ht(), O = { value: !1 }, E = Nc(() => {
    !O.value && z.value !== "hidden" && (z.value = "hidden", L(D), y());
  });
  Ae(() => {
    let pe = A(D);
    yt(pe);
  }), ut(() => {
    if (m.value === Un.Hidden && D) {
      if (S.value && z.value !== "visible") {
        z.value = "visible";
        return;
      }
      He(z.value, { hidden: () => L(D), visible: () => A(D) });
    }
  });
  let w = Jn(n.enter), M = Jn(n.enterFrom), W = Jn(n.enterTo), R = Jn(n.entered), q = Jn(n.leave), G = Jn(n.leaveFrom), X = Jn(n.leaveTo);
  Ae(() => {
    ut(() => {
      if (z.value === "visible") {
        let pe = J(_);
        if (pe instanceof Comment && pe.data === "")
          throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function ve(pe) {
    let Ce = Y.value && !k.value, de = J(_);
    !de || !(de instanceof HTMLElement) || Ce || (O.value = !0, S.value && s(), S.value || g(), pe(S.value ? ic(de, w, M, W, R, (te) => {
      O.value = !1, te === Za.Finished && d();
    }) : ic(de, q, G, X, R, (te) => {
      O.value = !1, te === Za.Finished && (mi(E) || (z.value = "hidden", L(D), y()));
    })));
  }
  return Ae(() => {
    vt([S], (pe, Ce, de) => {
      ve(de), Y.value = !1;
    }, { immediate: !0 });
  }), Ct(uo, E), io($(() => He(z.value, { visible: it.Open, hidden: it.Closed }) | c.value)), () => {
    let { appear: pe, show: Ce, enter: de, enterFrom: te, enterTo: fe, entered: ke, leave: tt, leaveFrom: Le, leaveTo: we, ...Qe } = n, Ot = { ref: _ }, Et = { ...Qe, ...k.value && S.value && ol.isServer ? { class: K([r.class, Qe.class, ...w, ...M]) } : {} };
    return ze({ theirProps: Et, ourProps: Ot, slot: {}, slots: u, attrs: r, features: jc, visible: z.value === "visible", name: "TransitionChild" });
  };
} }), I_ = Kc, Yc = Q({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(n, { emit: i, attrs: r, slots: u }) {
  let o = sl(), c = $(() => n.show === null && o !== null ? (o.value & it.Open) === it.Open : n.show);
  ut(() => {
    if (![!0, !1].includes(c.value))
      throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let s = B(c.value ? "visible" : "hidden"), d = Nc(() => {
    s.value = "hidden";
  }), g = B(!0), y = { show: c, appear: $(() => n.appear || !g.value) };
  return Ae(() => {
    ut(() => {
      g.value = !1, c.value ? s.value = "visible" : mi(d) || (s.value = "hidden");
    });
  }), Ct(uo, d), Ct(so, y), () => {
    let _ = ar(n, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), m = { unmount: n.unmount };
    return ze({ ourProps: { ...m, as: "template" }, theirProps: {}, slot: {}, slots: { ...u, default: () => [Ge(I_, { onBeforeEnter: () => i("beforeEnter"), onAfterEnter: () => i("afterEnter"), onBeforeLeave: () => i("beforeLeave"), onAfterLeave: () => i("afterLeave"), ...r, ...m, ..._ }, u.default)] }, attrs: {}, features: jc, visible: s.value === "visible", name: "Transition" });
  };
} });
const $_ = { class: "relative w-full" }, C_ = {
  key: 0,
  class: "relative cursor-default select-none px-4 py-2 text-gray-700"
}, k_ = /* @__PURE__ */ Q({
  __name: "SelectLong",
  props: {
    name: {},
    options: {},
    modelValue: { type: [String, Number, Boolean, Object, Array, null], default: null },
    label: { default: "" },
    error: { default: "" },
    required: { type: Boolean, default: !1 },
    optionalText: { default: "" },
    disabled: { type: Boolean, default: !1 },
    size: { default: Ne.md },
    fieldDescription: { default: "" },
    focused: { type: Boolean, default: !1 },
    theme: { default: Fe.light },
    readOnly: { type: Boolean, default: !1 },
    placeholder: { default: "" }
  },
  emits: ["updateField"],
  setup(n, { emit: i }) {
    const r = n, u = B(r.modelValue);
    let o = B(r.placeholder);
    const c = i, s = (m) => {
      u.value = m, g(), c("updateField", m.value);
    }, d = () => {
      o.value = "";
    }, g = () => {
      y.value = "";
    }, y = B(""), _ = $(
      () => y.value === "" ? r.options : r.options.filter((m) => m.label.toLowerCase().includes(y.value.toLowerCase()))
    );
    return (m, S) => (T(), ce(v(pi), {
      label: m.label,
      name: m.name,
      error: m.error,
      "error-border": !1,
      disabled: m.disabled,
      "optional-text": m.optionalText,
      required: m.required,
      "field-description": m.fieldDescription,
      focused: m.focused,
      size: m.size,
      theme: m.theme,
      "read-only": m.readOnly
    }, {
      input: ne(() => [
        m.readOnly ? (T(), U("span", {
          key: 0,
          class: K(["combo__label combo__label--read-only", { "combo__lab el--md": m.size === v(Ne).md, "combo__label--lg": m.size === v(Ne).lg }])
        }, re(u.value ? u.value.label : m.placeholder), 3)) : (T(), U("div", {
          key: 1,
          class: K(["combo__wrapper", {
            "combo--disabled": m.disabled,
            "combo--light": m.theme === v(Fe).light,
            "combo--dark": m.theme === v(Fe).dark,
            "combo--md": m.size === v(Ne).md,
            "combo--lg": m.size === v(Ne).lg,
            "combo--error": !!m.error && !m.disabled
          }])
        }, [
          se(v(T1), {
            modelValue: u.value,
            "onUpdate:modelValue": [
              S[1] || (S[1] = (k) => u.value = k),
              s
            ]
          }, {
            default: ne(() => [
              F("div", $_, [
                se(v($1), {
                  onChange: S[0] || (S[0] = (k) => y.value = k.target.value),
                  onFocus: d,
                  displayValue: (k) => u.value ? k == null ? void 0 : k.label : v(o),
                  id: `input-text-${m.name}`,
                  class: K(["combo__input-text", {
                    "combo--disabled": m.disabled,
                    "combo--light": m.theme === v(Fe).light,
                    "combo--dark": m.theme === v(Fe).dark,
                    "combo--md": m.size === v(Ne).md,
                    "combo--lg": m.size === v(Ne).lg,
                    "combo--error": !!m.error && !m.disabled
                  }]),
                  autocomplete: "off"
                }, null, 8, ["displayValue", "id", "class"]),
                m.disabled ? ae("", !0) : (T(), ce(v(I1), {
                  key: 0,
                  class: "combo__button",
                  onClick: g
                }, {
                  default: ne(() => [
                    se(v(kt), {
                      "icon-name": v(Z).caretDown,
                      size: v(ft).sm
                    }, null, 8, ["icon-name", "size"])
                  ]),
                  _: 1
                }))
              ]),
              se(v(C1), {
                class: K(["combo__options", {
                  "bg-neutral-8": m.theme === v(Fe).light,
                  "bg-neutral-80": m.theme === v(Fe).dark
                }])
              }, {
                default: ne(() => [
                  _.value.length === 0 && y.value !== "" ? (T(), U("div", C_, " Nothing found. ")) : ae("", !0),
                  (T(!0), U(Be, null, Ye(_.value, (k, A) => (T(), ce(v(k1), {
                    class: "input__option list-none",
                    key: `combo-option-${A}`,
                    value: k
                  }, {
                    default: ne(({ active: L }) => [
                      F("span", {
                        class: K(["combo__option__label", {
                          "bg-neutral-15": L && m.theme === v(Fe).light,
                          "bg-neutral-70": L && m.theme === v(Fe).dark
                        }])
                      }, re(k.label), 3)
                    ]),
                    _: 2
                  }, 1032, ["value"]))), 128))
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ], 2))
      ]),
      _: 1
    }, 8, ["label", "name", "error", "disabled", "optional-text", "required", "field-description", "focused", "size", "theme", "read-only"]));
  }
}), O_ = /* @__PURE__ */ _e(k_, [["__scopeId", "data-v-c8f8fb95"]]), E_ = { class: "select__label" }, A_ = /* @__PURE__ */ Q({
  __name: "SelectShort",
  props: {
    name: {},
    options: {},
    modelValue: { type: [String, Number, Boolean, Object, Array, null], default: null },
    label: { default: "" },
    error: { default: "" },
    required: { type: Boolean, default: !1 },
    optionalText: { default: "" },
    disabled: { type: Boolean, default: !1 },
    size: { default: Ne.md },
    fieldDescription: { default: "" },
    focused: { type: Boolean, default: !1 },
    theme: { default: Fe.light },
    readOnly: { type: Boolean, default: !1 },
    placeholder: { default: "" }
  },
  emits: ["updateField"],
  setup(n, { emit: i }) {
    const u = B(n.modelValue), o = i, c = (s) => {
      u.value = s, o("updateField", s.value);
    };
    return (s, d) => (T(), ce(v(pi), {
      label: s.label,
      name: s.name,
      error: s.error,
      "error-border": !1,
      disabled: s.disabled,
      "optional-text": s.optionalText,
      required: s.required,
      "field-description": s.fieldDescription,
      focused: s.focused,
      size: s.size,
      theme: s.theme,
      "read-only": s.readOnly
    }, {
      input: ne(() => [
        s.readOnly ? (T(), U("span", {
          key: 0,
          class: K(["select__label select__label--read-only", { "select__label--md": s.size === v(Ne).md, "select__label--lg": s.size === v(Ne).lg }])
        }, re(u.value ? u.value.label : s.placeholder), 3)) : (T(), ce(v(u_), {
          key: 1,
          modelValue: u.value,
          "onUpdate:modelValue": c
        }, {
          default: ne(({ open: g }) => [
            F("div", {
              class: K(["select__wrapper", {
                "select__wrapper--disabled": s.disabled,
                "select__wrapper--light": s.theme === v(Fe).light,
                "select__wrapper--dark": s.theme === v(Fe).dark,
                "select__wrapper--md": s.size === v(Ne).md,
                "select__wrapper--lg": s.size === v(Ne).lg
              }])
            }, [
              se(v(c_), {
                class: K(["select__button", { "select__button--open": g, "select__button--error": s.error && !s.disabled && !s.readOnly }])
              }, {
                default: ne(() => [
                  F("span", E_, re(u.value ? u.value.label : s.placeholder), 1),
                  g ? (T(), ce(v(kt), {
                    key: 0,
                    "icon-name": v(Z).caretUp,
                    size: v(ft).sm
                  }, null, 8, ["icon-name", "size"])) : (T(), ce(v(kt), {
                    key: 1,
                    "icon-name": v(Z).caretDown,
                    size: v(ft).sm
                  }, null, 8, ["icon-name", "size"]))
                ]),
                _: 2
              }, 1032, ["class"]),
              se(uc, {
                "enter-active-class": "transition ease-out duration-100",
                "enter-from-class": "opacity-0",
                "enter-to-class": "opacity-100",
                "leave-active-class": "transition ease-in duration-100",
                "leave-from-class": "opacity-100",
                "leave-to-class": "opacity-0"
              }, {
                default: ne(() => [
                  se(v(d_), { class: "select__options" }, {
                    default: ne(() => [
                      (T(!0), U(Be, null, Ye(s.options, (y, _) => (T(), ce(v(f_), {
                        key: `select-option-${_}`,
                        value: y,
                        disabled: s.disabled,
                        class: "select__option"
                      }, {
                        default: ne(({ active: m }) => [
                          F("span", {
                            class: K(["select__option__label", { "bg-neutral-15": m && s.theme === v(Fe).light, "bg-neutral-70": m && s.theme === v(Fe).dark }])
                          }, re(y.label), 3)
                        ]),
                        _: 2
                      }, 1032, ["value", "disabled"]))), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ], 2)
          ]),
          _: 1
        }, 8, ["modelValue"]))
      ]),
      _: 1
    }, 8, ["label", "name", "error", "disabled", "optional-text", "required", "field-description", "focused", "size", "theme", "read-only"]));
  }
}), L_ = /* @__PURE__ */ _e(A_, [["__scopeId", "data-v-b139e524"]]), Xx = /* @__PURE__ */ Q({
  __name: "Select",
  props: {
    name: {},
    options: {},
    modelValue: { type: [String, Number, Boolean, Object, Array, null], default: null },
    label: { default: "" },
    error: { default: "" },
    required: { type: Boolean, default: !1 },
    optionalText: { default: "" },
    disabled: { type: Boolean, default: !1 },
    size: { default: Ne.md },
    fieldDescription: { default: "" },
    focused: { type: Boolean, default: !1 },
    theme: { default: Fe.light },
    readOnly: { type: Boolean, default: !1 },
    placeholder: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: i }) {
    const r = n, u = $(() => r.options.length >= 20 ? O_ : L_), o = i, c = (s) => {
      o("update:modelValue", s);
    };
    return (s, d) => (T(), ce(en(u.value), hn(r, { onUpdateField: c }), null, 16));
  }
}), R_ = { class: "text-card-grid" }, D_ = { class: "text-block" }, P_ = /* @__PURE__ */ Q({
  __name: "TextCardGrid",
  props: {
    textCardGridVariant: {
      type: String,
      default: "gutterCardGrid"
    }
  },
  setup(n) {
    const i = n;
    return (r, u) => (T(), U("div", R_, [
      F("div", D_, [
        ue(r.$slots, "text-block-slot", {}, void 0, !0)
      ]),
      F("div", {
        class: K(["text-card-row-2", `text-card-grid-${i.textCardGridVariant}`])
      }, [
        ue(r.$slots, "text-card-slot", {}, void 0, !0)
      ], 2)
    ]));
  }
}), Jx = /* @__PURE__ */ _e(P_, [["__scopeId", "data-v-c1f89246"]]);
var Qn = /* @__PURE__ */ ((n) => (n.filled = "", n.outline = " border border-solid bg-transparent", n.float = "float", n.transparent = "bg-transparent", n))(Qn || {}), Xa = /* @__PURE__ */ ((n) => (n.mid = "bg-neutral-10 bg-border-neutral-30 text-neutral-80", n.light = "bg-neutral-10 text-neutral-80", n.dark = "bg-neutral-60 border-neutral-4 text-neutral-2", n))(Xa || {});
const B_ = { class: "card-component" }, M_ = { class: "card-figure" }, F_ = { class: "card-subheader" }, z_ = { class: "card-description" }, U_ = /* @__PURE__ */ Q({
  __name: "StatCard",
  props: {
    cardVariant: {
      type: String,
      default: Qn.filled
    },
    cardTheme: {
      type: String,
      default: Xa.light
    }
  },
  setup(n) {
    const i = n, r = $(() => {
      const o = Qn[i.cardVariant] === Qn.filled, c = Qn[i.cardVariant] === Qn.transparent, s = Xa[i.cardTheme], d = u(o, c);
      return [
        "card-container",
        Qn[i.cardVariant],
        s,
        d
      ];
    }), u = (o, c) => {
      if (!o || c)
        return "bg-transparent";
    };
    return (o, c) => (T(), U("div", {
      class: K([r.value])
    }, [
      F("article", B_, [
        F("section", M_, [
          ue(o.$slots, "card-figure", {}, void 0, !0),
          F("div", F_, [
            ue(o.$slots, "card-subheader", {}, void 0, !0)
          ])
        ]),
        F("section", z_, [
          ue(o.$slots, "card-description", {}, void 0, !0)
        ])
      ])
    ], 2));
  }
}), Qx = /* @__PURE__ */ _e(U_, [["__scopeId", "data-v-cca9b07a"]]);
var Ja = /* @__PURE__ */ ((n) => (n.input = "input", n.textarea = "textarea", n))(Ja || {}), Zc = /* @__PURE__ */ ((n) => (n.hidden = "hidden", n.text = "text", n.password = "password", n.email = "email", n.number = "number", n.tel = "tel", n.date = "date", n.time = "time", n.range = "range", n.color = "color", n.file = "file", n.url = "url", n.search = "search", n.month = "month", n.week = "week", n["datetime-local"] = "datetime-local", n))(Zc || {});
const eS = {
  time: Z.none,
  date: Z.none,
  week: Z.none,
  month: Z.none,
  "datetime-local": Z.none,
  file: Z.none,
  search: Z.none,
  email: Z.none,
  number: Z.none,
  tel: Z.none,
  url: Z.none,
  password: Z.none,
  text: Z.none,
  range: Z.none,
  color: Z.none,
  hidden: Z.none
}, W_ = /* @__PURE__ */ Q({
  __name: "InputText",
  props: {
    modelValue: {
      type: [String, Number, Boolean, Object, Array],
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    multiline: {
      type: Boolean,
      default: !1
    },
    lines: {
      type: Number,
      default: 4
    },
    type: {
      type: String,
      required: !0,
      validator: (n) => Object.values(Zc).includes(n)
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    },
    optionalText: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    size: {
      type: Object,
      validator: (n) => Object.values(Ne).includes(n),
      default: Ne.md
    },
    fieldDescription: {
      type: String,
      default: ""
    },
    focused: {
      type: Boolean,
      default: !1
    },
    theme: {
      type: Object,
      validator: (n) => Object.values(Fe).includes(n),
      default: Fe.light
    },
    readOnly: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "input"],
  setup(n, { emit: i }) {
    const r = n, u = i, o = $({
      get: () => r.modelValue,
      set: (y) => {
        u("update:modelValue", y);
      }
    }), c = (y) => {
      const _ = y.target.value;
      _ !== null && (o.value = _, u("update:modelValue", _));
    }, s = $(() => r.multiline ? Ja.textarea : Ja.input), d = $(() => r.multiline ? void 0 : r.type), g = $(() => r.multiline && r.lines ? r.lines : void 0);
    return (y, _) => (T(), ce(v(pi), {
      label: n.label,
      name: n.name,
      error: n.error,
      "error-border": !1,
      disabled: n.disabled,
      "optional-text": n.optionalText,
      required: n.required,
      "field-description": n.fieldDescription,
      focused: n.focused,
      size: n.size,
      theme: n.theme,
      "read-only": n.readOnly,
      class: "select-mode"
    }, {
      input: ne(() => [
        n.readOnly && !n.disabled ? (T(), U("span", {
          key: 0,
          class: K([
            "input-text input-text--read-only",
            {
              "input-text--md": n.size === v(Ne).md,
              "input-text--lg": n.size === v(Ne).lg
            }
          ])
        }, re(o.value || n.placeholder), 3)) : (T(), ce(en(s.value), {
          key: 1,
          value: o.value,
          onInput: c,
          name: n.name,
          autocomplete: "on",
          placeholder: n.placeholder,
          type: d.value,
          rows: g.value,
          class: K(["input-text", {
            "input-text--disabled": n.disabled,
            "input-text--light": n.theme === v(Fe).light,
            "input-text--dark": n.theme === v(Fe).dark,
            "input-text--md": n.size === v(Ne).md,
            "input-text--lg": n.size === v(Ne).lg,
            "input-text--error": !!n.error && !n.disabled
          }]),
          id: `input-text-${n.name}`,
          disabled: n.disabled
        }, null, 40, ["value", "name", "placeholder", "type", "rows", "class", "id", "disabled"]))
      ]),
      _: 1
    }, 8, ["label", "name", "error", "disabled", "optional-text", "required", "field-description", "focused", "size", "theme", "read-only"]));
  }
}), tS = /* @__PURE__ */ _e(W_, [["__scopeId", "data-v-9648fe75"]]), H_ = ["id", "aria-labelledby", "aria-describedby"], q_ = ["id"], G_ = ["id"], V_ = /* @__PURE__ */ Q({
  __name: "Form",
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    theme: {
      type: String,
      default: Fe.light
    },
    formId: {
      type: String,
      required: !0
    },
    submitted: {
      type: Boolean,
      default: !1
    },
    isInline: {
      type: Boolean,
      default: !1
    }
  },
  setup(n) {
    return (i, r) => (T(), U("form", {
      class: K(["form", { "form--no-gap": !n.title && !n.description, "form--light": n.theme === v(Fe).light, "form--dark": n.theme === v(Fe).dark }]),
      id: `form-${n.formId}`,
      "aria-labelledby": `form-${n.formId}-title`,
      "aria-describedby": `form-${n.formId}-description`
    }, [
      n.submitted ? ae("", !0) : (T(), ce(v(pc), {
        key: 0,
        "block-type": v(eo).blockOne,
        "has-button": !1
      }, ci({ _: 2 }, [
        n.title ? {
          name: "header",
          fn: ne(() => [
            F("h1", {
              id: `form-${n.formId}-title`,
              class: "form__title"
            }, re(n.title), 9, q_)
          ]),
          key: "0"
        } : void 0,
        n.description ? {
          name: "content",
          fn: ne(() => [
            F("p", {
              id: `form-${n.formId}-description`,
              class: "form__description"
            }, re(n.description), 9, G_)
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["block-type"])),
      n.submitted ? ue(i.$slots, "submit-message", { key: 2 }, void 0, !0) : (T(), U("section", {
        key: 1,
        class: K(["form__elements", n.isInline ? "inline-form" : ""])
      }, [
        ue(i.$slots, "elements", {}, void 0, !0),
        ue(i.$slots, "submit", {}, void 0, !0)
      ], 2))
    ], 10, H_));
  }
}), nS = /* @__PURE__ */ _e(V_, [["__scopeId", "data-v-84c99ebf"]]), N_ = { class: "carousel-container" }, j_ = { class: "carousel-display" }, K_ = {
  key: 0,
  class: "scroll-buttons"
}, Y_ = /* @__PURE__ */ Q({
  __name: "Carousel",
  props: {
    noGaps: {
      type: Boolean,
      default: !0
    },
    sm: {
      description: "Sets the viewport columns and items to jump. `2, 1` Shows two columns and moves one. `2` Shows and moves 2 columns.",
      type: String,
      default: "2, 1"
    },
    md: {
      description: "Sets the viewport columns and items to jump. `2, 1` Shows two columns and moves one. `2` Shows and moves 2 columns.",
      type: String
    },
    lg: {
      description: "Sets the viewport columns and items to jump. `2, 1` Shows two columns and moves one. `2` Shows and moves 2 columns.",
      type: String
    },
    xl: {
      description: "Sets the viewport columns and items to jump. `2, 1` Shows two columns and moves one. `2` Shows and moves 2 columns.",
      type: String
    },
    shouldAutoScroll: {
      type: Boolean,
      default: !1
    },
    autoScrollSpeed: {
      type: Number,
      default: 5e3
    }
  },
  setup(n) {
    Hn((w) => ({
      "02e614ca": s.value[0][0],
      "02c9e5c8": s.value[1][0],
      "02adb6c6": s.value[2][0],
      "029187c4": s.value[3][0]
    }));
    const i = n;
    let r;
    const u = B(0), o = B(null), c = B("left"), s = $(() => {
      let w = _(i == null ? void 0 : i.sm), M = i != null && i.md ? _(i == null ? void 0 : i.md) : w, W = i != null && i.lg ? _(i == null ? void 0 : i.lg) : M, R = i != null && i.xl ? _(i == null ? void 0 : i.xl) : W;
      return [w, M, W, R];
    }), d = B(!1), g = $(() => {
      var w;
      return o.value ? (w = o.value.children) == null ? void 0 : w.length : 0;
    }), y = $(() => {
      var W, R, q;
      const w = o.value ? o.value.getBoundingClientRect() : { x: 0 };
      return (((q = (R = (W = o.value) == null ? void 0 : W.children) == null ? void 0 : R[u.value]) == null ? void 0 : q.getBoundingClientRect()) ?? { x: 0 }).x - w.x;
    }), _ = (w) => {
      let [M, W] = w.split(",").map(Number);
      return W = W <= 0 || !W ? M : Math.min(M, W), [M, W];
    }, m = () => {
      const [w, M, W, R] = s.value, q = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      return q < 640 ? w : q >= 640 && q < 768 ? M : q >= 768 && q < 1024 ? W : q > 1024 ? R : w;
    }, S = () => {
      i.shouldAutoScroll && (r || (r = setInterval(k, i.autoScrollSpeed)), d.value = !0);
    }, k = () => {
      u.value === g.value - 1 && (u.value = -1), Y();
    }, A = () => {
      r && d.value && clearInterval(r), d.value = !1;
    }, L = (w) => {
      var R;
      let [M, W] = m();
      g.value <= M || (u.value = w(u.value, W, g.value, M), (R = o.value) == null || R.scrollBy({ left: y.value }), c.value = O(u.value, g.value, M));
    }, z = () => {
      L((w, M = 1) => Math.max(u.value - M, 0));
    }, Y = () => {
      L((w = -1, M = 1, W = 0, R = 1) => Math.min(w + M, W - R));
    }, D = (w) => {
      d.value && A(), w === "right" ? Y() : w === "left" && z();
    }, O = (w, M, W) => w === M - W ? "right" : w <= 0 ? "left" : "";
    let E = !1;
    return Ae(() => {
      E = !0, S();
    }), vi(() => {
      A();
    }), (w, M) => (T(), U("div", N_, [
      Vb(F("div", j_, [
        F("div", {
          ref_key: "carouselItemRef",
          ref: o,
          class: K(["carousel-items", { "carousel-items--nogap": n.noGaps }])
        }, [
          ue(w.$slots, "carousel-items", {}, void 0, !0)
        ], 2),
        g.value > 1 ? (T(), U("div", K_, [
          se(v(Xe), {
            class: "scroll-button no-highlight",
            onClick: M[0] || (M[0] = (W) => D("left")),
            "icon-only": "",
            "aria-label": "Scroll carousel left",
            "icon-name": v(Z).caretLeft,
            variant: v(je).tertiary,
            size: v(Ue).xl,
            color: v(We).neutral,
            disabled: c.value === "left",
            animated: !1
          }, null, 8, ["icon-name", "variant", "size", "color", "disabled"]),
          se(v(Xe), {
            class: "scroll-button no-highlight",
            onClick: M[1] || (M[1] = (W) => D("right")),
            "icon-only": "",
            "aria-label": "Scroll carousel right",
            "icon-name": v(Z).caretRight,
            variant: v(je).tertiary,
            size: v(Ue).xl,
            color: v(We).neutral,
            disabled: c.value === "right",
            animated: !1
          }, null, 8, ["icon-name", "variant", "size", "color", "disabled"])
        ])) : ae("", !0)
      ], 512), [
        [Nb, v(E)]
      ])
    ]));
  }
}), rS = /* @__PURE__ */ _e(Y_, [["__scopeId", "data-v-ea51e48a"]]), Z_ = /* @__PURE__ */ Q({
  __name: "NavItem",
  props: {
    variant: {
      type: String,
      default: "link"
    },
    topSelected: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      required: !0
    },
    href: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    showItems: {
      type: Boolean,
      default: !1
    },
    theme: {
      type: String,
      default: "light"
    },
    highlight: {
      type: Boolean,
      default: !0
    },
    activeState: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "md"
    }
  },
  emits: ["gtmItemData", "itemSelected"],
  setup(n, { emit: i }) {
    Hn((D) => ({
      36001831: A[r.theme](r.highlight)
    }));
    const r = n, u = i, o = B(null), c = B(null), s = $(() => r.variant !== "drawer"), d = $(() => r.items.length > 0 ? "button" : "a"), g = $(() => r.showItems ? Z.caretUp : Z.caretDown), y = $(() => k[r.theme]), _ = $(() => ({
      md: [Ue.md, Ue.sm],
      lg: [Ue.xl, Ue.md]
    })[r.size ?? "md"]), m = {
      light: "bg-white",
      mid: "bg-neutral-15",
      dark: "bg-neutral-80"
    }, S = {
      light: "text-neutral-80",
      mid: "text-neutral-80",
      dark: "text-neutral-6"
    }, k = {
      light: We.neutral,
      mid: We.neutral,
      dark: We.white
    }, A = {
      light: (D) => D ? "#F20D33" : "#222324",
      mid: (D) => D ? "#F20D33" : "#FAFAFA",
      dark: (D) => D ? "#F20D33" : "#FFFFFF"
    };
    function L(D) {
      return D.id ? D.id.toString() : `${D.label.replace(/\s+/g, "")}-${Math.floor(Math.random() * 100)}`;
    }
    function z(D) {
      u("gtmItemData", D), u("itemSelected", D);
    }
    function Y() {
      const D = c.value, O = D == null ? void 0 : D.getBoundingClientRect(), E = window.innerWidth;
      D && (D.style.left = O.right > E ? `-${O.width - D.parentElement.clientWidth}px` : "0");
    }
    return jb(() => {
      Y();
    }), (D, O) => (T(), U("div", {
      class: K(
        [
          "nav-item bg-opacity-0",
          m[r.theme],
          S[r.theme],
          { "active-selected": r.activeState },
          { "top-selected": r.topSelected }
        ]
      ),
      ref_key: "navItem",
      ref: o
    }, [
      se(v(Xe), {
        class: "pt-3 pb-3.5 main-btn",
        variant: v(je).tertiary,
        color: y.value,
        size: _.value[0],
        "icon-name": g.value,
        "no-icon": s.value,
        href: r.href,
        "link-type": d.value
      }, {
        default: ne(() => [
          Ke(re(n.label), 1)
        ]),
        _: 1
      }, 8, ["variant", "color", "size", "icon-name", "no-icon", "href", "link-type"]),
      n.items.length > 0 ? (T(), U("div", {
        key: 0,
        class: K(["nav-item-drawer", m[r.theme], S[r.theme], { visible: r.showItems }]),
        ref_key: "itemDrawer",
        ref: c
      }, [
        se(v(al), {
          orientation: v(kr).vertical,
          size: v(Gt).sm,
          "border-style": v(Bt).noDivider
        }, {
          default: ne(() => [
            (T(!0), U(Be, null, Ye(n.items, (E) => (T(), ce(v(nr), {
              size: v(Gt).sm,
              "border-style": v(Bt).noDivider,
              key: L(E)
            }, {
              default: ne(() => [
                se(v(Xe), {
                  variant: v(je).tertiary,
                  color: y.value,
                  size: _.value[1],
                  "no-icon": !0,
                  href: E.href,
                  "link-type": "a",
                  onClick: (w) => z(E)
                }, {
                  default: ne(() => [
                    Ke(re(E.label), 1)
                  ]),
                  _: 2
                }, 1032, ["variant", "color", "size", "href", "onClick"])
              ]),
              _: 2
            }, 1032, ["size", "border-style"]))), 128))
          ]),
          _: 1
        }, 8, ["orientation", "size", "border-style"])
      ], 2)) : ae("", !0)
    ], 2));
  }
}), Xc = /* @__PURE__ */ _e(Z_, [["__scopeId", "data-v-bfcfface"]]);
var Tr = /* @__PURE__ */ ((n) => (n.light = "light", n.dark = "dark", n.mid = "mid", n))(Tr || {});
const X_ = { class: "nova-disclosure-wrapper" }, J_ = 1500, Q_ = /* @__PURE__ */ Q({
  __name: "Disclosure",
  props: {
    text: {
      type: String,
      required: !0
    },
    theme: {
      type: String,
      default: Tr.dark
    }
  },
  setup(n) {
    const i = n, r = B(!1), u = $(() => i.text.length > J_), o = $(
      () => Tr.dark === i.theme ? We.white : We.neutral
    );
    return (c, s) => (T(), U("div", {
      class: K({
        "nova-disclosure": !0,
        "nova-disclosure-collapsible": u.value,
        "nova-disclosure-collapsible--collapsed": r.value,
        "nova-disclosure--light": n.theme === v(Tr).light,
        "nova-disclosure--dark": n.theme === v(Tr).dark,
        "nova-disclosure--mid": n.theme === v(Tr).mid
      })
    }, [
      F("div", X_, [
        se(v(Or), {
          class: "nova-disclosure-text",
          "text-content": n.text
        }, null, 8, ["text-content"]),
        u.value ? (T(), ce(v(Xe), {
          key: 0,
          onClick: s[0] || (s[0] = (d) => r.value = !r.value),
          variant: v(je).secondary,
          size: v(Ue).sm,
          color: o.value,
          "link-type": "button",
          noIcon: !0,
          class: "nova-disclosure-toggle"
        }, {
          default: ne(() => [
            Ke(re(r.value ? "Show Less" : "Show More"), 1)
          ]),
          _: 1
        }, 8, ["variant", "size", "color"])) : ae("", !0)
      ])
    ], 2));
  }
}), lS = /* @__PURE__ */ _e(Q_, [["__scopeId", "data-v-4a944c0a"]]), ew = { class: "nova-quote" }, tw = { class: "nova-quote-wrapper" }, nw = { class: "nova-quote-text" }, rw = {
  key: 0,
  class: "nova-quote-info"
}, lw = {
  key: 1,
  class: "nova-quote-description"
}, iw = { key: 0 }, aw = { key: 1 }, ow = { key: 2 }, sw = /* @__PURE__ */ Q({
  __name: "Quote",
  props: {
    text: {},
    altText: {},
    image: {},
    name: {},
    jobTitle: {},
    company: {},
    isLazy: { type: Boolean }
  },
  setup(n) {
    const i = n, r = $(() => i.name || i.jobTitle || i.company), u = $(() => r.value || i.image);
    return (o, c) => (T(), U("div", ew, [
      F("div", tw, [
        F("blockquote", nw, re(o.text), 1)
      ]),
      u.value ? (T(), U("div", rw, [
        o.image ? (T(), ce(v(St), {
          key: 0,
          "no-scale": "",
          class: "nova-quote-avatar",
          "alt-text": o.altText,
          proportion: "aspect1_1",
          src: o.image,
          "is-lazy": o.isLazy
        }, null, 8, ["alt-text", "src", "is-lazy"])) : ae("", !0),
        r.value ? (T(), U("div", lw, [
          o.name ? (T(), U("p", iw, re(o.name), 1)) : ae("", !0),
          o.jobTitle ? (T(), U("p", aw, re(o.jobTitle), 1)) : ae("", !0),
          o.company ? (T(), U("p", ow, re(o.company), 1)) : ae("", !0)
        ])) : ae("", !0)
      ])) : ae("", !0)
    ]));
  }
}), iS = /* @__PURE__ */ _e(sw, [["__scopeId", "data-v-c83ffeb9"]]);
//! - support for any type of nav on primary
//! - add support for nested nav to handle any nav
const ac = {
  primary: ["cta"],
  secondary: ["cta"],
  "top-drawer": ["drawerCTA"],
  // TBD
  static: ["additionalContent"],
  nested: ["cta"],
  "item-list": ["cta"],
  // TBD
  "item-accordion": ["cta", "additionalContent"]
}, $r = {
  light: "bg-white",
  mid: "bg-neutral-15",
  dark: "bg-neutral-80"
}, ll = {
  light: "bg-white",
  mid: "bg-neutral-15",
  dark: "bg-neutral-80"
}, bt = {
  light: "text-neutral-80",
  mid: "text-neutral-80",
  dark: "text-neutral-6"
}, co = {
  light: "#DDDDDE",
  // neutral-10
  mid: "#EBEAEA",
  dark: "#555759"
};
oe(() => import("./index-CtoO_8Wu.mjs")), oe(() => import("./index-CtoO_8Wu.mjs")), oe(() => import("./index-DzbKhyiT.mjs")), oe(() => import("./index-C6BWhKa5.mjs")), oe(() => import("./index-Xld7kXia.mjs")), oe(
  () => import("./index-Cx7H9hW3.mjs").then((n) => n.ItemList)
), oe(
  () => import("./index-Cx7H9hW3.mjs").then((n) => n.ItemAccordion)
);
function fo(n, i) {
  if (!n)
    return;
  const r = (u) => {
    u.target !== n.value && u.composedPath().includes(n.value) || typeof i == "function" && i();
  };
  return Ae(() => {
    window.addEventListener("click", r);
  }), vi(() => {
    window.removeEventListener("click", r);
  }), { listener: r };
}
function uw(n, i = 0, r = null) {
  const u = {};
  function o(c, s, d) {
    const g = { ...c, depth: s, parentId: d };
    return u[s] || (u[s] = []), u[s].push(g), c.navItems && (g.navItems = c.navItems.map((y) => o(y, s + 1, c.id))), g;
  }
  return n.forEach((c) => o(c, i, r)), u;
}
function Jc(n) {
  return uw(n);
}
const cw = { class: "nav-wrapper" }, dw = { class: "main-nav-logo" }, fw = ["href"], vw = { key: 1 }, pw = { class: "main-nav-content flex items-center" }, hw = ["aria-label"], mw = /* @__PURE__ */ Q({
  __name: "PrimaryNav",
  props: {
    navType: {
      type: String,
      default: "primary"
    },
    content: {
      type: Object,
      required: !0
    },
    theme: {
      type: String,
      default: "light"
    },
    highlight: {
      type: Boolean,
      default: !0
    },
    activeItemId: {
      type: String || null,
      default: null
    }
  },
  emits: ["toggleDropdown", "gtmEvent"],
  setup(n, { emit: i }) {
    const r = n, u = i, o = B(null), c = B(), s = B(r.content), d = $(() => {
      var A;
      return (A = s.value) == null ? void 0 : A.logo;
    }), g = $(() => {
      var A, L;
      return (L = (A = s.value) == null ? void 0 : A.navSections) == null ? void 0 : L.simpleNav;
    }), y = $(() => ({
      "--nav-border-color": co[r.theme]
    }));
    fo(o, () => {
      u("toggleDropdown", !1), c.value && _(c.value, "NavDrawer.Close"), c.value = null;
    });
    function _(A, L = "") {
      const z = {
        event: "NavClick",
        category: L,
        label: A.label,
        action: "Click"
      };
      u("gtmEvent", z);
    }
    function m(A) {
      _(A, "Nav.Link");
    }
    function S(A) {
      return A.navItems && A.navItems.length > 0 ? "drawer" : "link";
    }
    function k(A, L) {
      var D, O, E;
      Array.from(A.composedPath()).some((w) => w.classList && w.classList.contains("nav-item-drawer")) || (c.value = L.id === ((D = c.value) == null ? void 0 : D.id) ? null : L, _(L, (O = c.value) != null && O.id ? "NavDrawer.Open" : "NavDrawer.Close"), u("toggleDropdown", !!((E = c.value) != null && E.id)));
    }
    return (A, L) => {
      var z, Y, D, O, E;
      return T(), U("div", {
        class: K(["main-nav", { "main-nav--with-border": r.navType === "primary" }, { "bg-opacity-80": r.navType === "secondary" }, v($r)[r.theme], v(bt)[r.theme]]),
        style: kn(y.value),
        ref_key: "mainNav",
        ref: o
      }, [
        F("div", cw, [
          F("div", dw, [
            F("a", {
              href: (z = s.value) == null ? void 0 : z.mainLink.href,
              class: K(v(bt)[r.theme])
            }, [
              d.value ? (T(), ce(v(St), {
                key: 0,
                "no-scale": "",
                class: "logo",
                src: ((Y = s.value) == null ? void 0 : Y.logo) || "",
                altText: ((D = s.value) == null ? void 0 : D.mainLink.label) || "",
                objectFit: v(Pt).contain
              }, null, 8, ["src", "altText", "objectFit"])) : (T(), U("span", vw, re((O = s.value) == null ? void 0 : O.mainLink.label), 1))
            ], 10, fw)
          ]),
          F("div", pw, [
            F("nav", {
              class: "items",
              "aria-label": `${(E = s.value) == null ? void 0 : E.mainLink.label} main menu`
            }, [
              (T(!0), U(Be, null, Ye(g.value, (w) => {
                var M;
                return T(), ce(v(Xc), {
                  class: "main-nav-content__item",
                  ref_for: !0,
                  ref: `navItem${w.id}`,
                  variant: S(w),
                  label: w.label,
                  href: w == null ? void 0 : w.href,
                  "show-items": w.id === ((M = c.value) == null ? void 0 : M.id),
                  items: w == null ? void 0 : w.navItems,
                  theme: r.theme,
                  highlight: r.highlight,
                  "active-state": w.id === r.activeItemId,
                  key: w.id,
                  onGtmItemData: m,
                  onClick: (W) => S(w) === "drawer" ? k(W, w) : _(w, "Nav.Link")
                }, null, 8, ["variant", "label", "href", "show-items", "items", "theme", "highlight", "active-state", "onClick"]);
              }), 128))
            ], 8, hw),
            ue(A.$slots, "cta", {}, void 0, !0)
          ])
        ])
      ], 6);
    };
  }
}), oc = /* @__PURE__ */ _e(mw, [["__scopeId", "data-v-b7f2814f"]]), gw = { class: "nav-wrapper" }, bw = { class: "nav-logo" }, yw = ["href"], _w = { key: 1 }, ww = { class: "col-span-8 flex justify-end w-full" }, xw = ["aria-label"], Sw = ["href", "onClick"], Tw = /* @__PURE__ */ Q({
  __name: "StaticNav",
  props: {
    navType: {
      type: String,
      default: "static"
    },
    content: {
      type: Object,
      required: !0
    },
    theme: {
      type: String,
      default: "light"
    }
  },
  emits: ["gtmEvent"],
  setup(n, { emit: i }) {
    Hn((k) => ({
      "1b6db56b": o[r.theme]
    }));
    const r = n, u = {
      light: We.neutral,
      mid: We.neutral,
      dark: We.white
    }, o = {
      light: "#DDDDDE",
      mid: "#222324",
      dark: "#555759"
    }, c = i, s = Cr(), d = B(r.content), g = B(!1), y = $(() => {
      var k;
      return (k = d.value) == null ? void 0 : k.logo;
    }), _ = $(() => {
      var k, A;
      return (A = (k = d.value) == null ? void 0 : k.navSections) == null ? void 0 : A.simpleNav;
    }), m = $(() => u[r.theme]);
    function S(k, A = "") {
      const L = {
        event: "NavClick",
        category: A,
        // selectedItemID.value ? 'SiteNav.Open' : 'SiteNav.close',
        label: k.label,
        action: "Click"
      };
      c("gtmEvent", L);
    }
    return Ae(() => {
      if (s.additionalContent) {
        const k = s.additionalContent({})[0].children;
        g.value = Array.isArray(k) && k.length > 0;
      }
    }), (k, A) => {
      var L, z, Y, D;
      return T(), U("div", {
        class: K(["static-nav", v($r)[r.theme], v(bt)[r.theme]])
      }, [
        F("div", gw, [
          F("div", {
            class: K(["static-nav-content", { "static-nav-content--with-slot": g.value }])
          }, [
            F("div", bw, [
              F("a", {
                class: K(["t-body-lg no-underline opacity-70", v(bt)[r.theme]]),
                href: (L = d.value) == null ? void 0 : L.mainLink.href,
                onClick: A[0] || (A[0] = (O) => {
                  var E;
                  return S((E = d.value) == null ? void 0 : E.mainLink, "Static.Link");
                })
              }, [
                y.value ? (T(), ce(v(St), {
                  key: 0,
                  "no-scale": "",
                  class: "nav-logo-image",
                  src: ((z = d.value) == null ? void 0 : z.logo) || "",
                  altText: ((Y = d.value) == null ? void 0 : Y.mainLink.label) || "",
                  objectPosition: v(Mt).left,
                  "is-lazy": !0
                }, null, 8, ["src", "altText", "objectPosition"])) : (T(), U("span", _w, re((D = d.value) == null ? void 0 : D.mainLink.label), 1))
              ], 10, yw)
            ]),
            F("div", ww, [
              (T(!0), U(Be, null, Ye(_.value, (O) => (T(), U("nav", {
                class: "nav-col w-1/4",
                key: O.id,
                "aria-label": `${O.label} menu`
              }, [
                se(v(al), {
                  orientation: v(kr).vertical,
                  size: v(Gt).xs,
                  "border-style": v(Bt).noDivider
                }, {
                  default: ne(() => [
                    se(v(nr), {
                      size: v(Gt).xs,
                      "border-style": v(Bt).noDivider
                    }, {
                      default: ne(() => [
                        O.href ? (T(), U("a", {
                          key: 0,
                          class: K(["col-title no-underline hover:opacity-60", v(bt)[r.theme]]),
                          href: O.href,
                          onClick: (E) => S(O, "Static.Link")
                        }, re(O.label), 11, Sw)) : (T(), U("span", {
                          key: 1,
                          class: K(["col-title", v(bt)[r.theme]])
                        }, re(O.label), 3))
                      ]),
                      _: 2
                    }, 1032, ["size", "border-style"]),
                    (T(!0), U(Be, null, Ye(O == null ? void 0 : O.navItems, (E) => (T(), ce(v(nr), {
                      size: v(Gt).xs,
                      "border-style": v(Bt).noDivider,
                      key: E == null ? void 0 : E.id
                    }, {
                      default: ne(() => [
                        se(v(Xe), {
                          class: "p-0",
                          variant: v(je).tertiary,
                          color: m.value,
                          size: v(Ue).xs,
                          "no-icon": !0,
                          href: E == null ? void 0 : E.href,
                          "link-type": "a",
                          onClick: (w) => S(E, "Static.Link")
                        }, {
                          default: ne(() => [
                            Ke(re(E.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["variant", "color", "size", "href", "onClick"])
                      ]),
                      _: 2
                    }, 1032, ["size", "border-style"]))), 128))
                  ]),
                  _: 2
                }, 1032, ["orientation", "size", "border-style"])
              ], 8, xw))), 128))
            ])
          ], 2),
          ue(k.$slots, "additionalContent", {}, void 0, !0)
        ])
      ], 2);
    };
  }
}), Iw = /* @__PURE__ */ _e(Tw, [["__scopeId", "data-v-5cad4d23"]]), $w = {
  class: "nav-wrapper",
  "aria-label": "tophat menu"
}, Cw = { class: "top-col" }, kw = { class: "top-col justify-end" }, Ow = ["aria-label"], Ew = /* @__PURE__ */ Q({
  __name: "TopDrawer",
  props: {
    navType: {
      type: String,
      default: "top-drawer"
    },
    content: {
      type: Object,
      required: !0
    },
    theme: {
      type: String,
      default: "light"
    },
    highlight: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["toggleDropdown", "gtmEvent"],
  setup(n, { emit: i }) {
    const r = n, u = {
      light: We.neutral,
      mid: We.neutral,
      dark: We.white
    }, o = {
      light: "#DDDDDE",
      mid: "#222324",
      dark: "#555759"
    }, c = {
      a: {
        light: "text-neutral-80",
        mid: "text-neutral-80",
        dark: "text-neutral-2"
      },
      span: {
        light: "text-neutral-60",
        mid: "text-neutral-70",
        dark: "text-neutral-15"
      }
    }, s = i, d = B(null), g = B(!1), y = B(r.content), _ = B(""), m = B(), S = B(), k = $(() => {
      const E = {
        left: [],
        right: []
      }, w = y.value.navSections.drawerNav || y.value.navSections.simpleNav;
      return w == null || w.forEach((M) => {
        var R;
        const W = (M == null ? void 0 : M.alignment) === "right" ? "right" : "left";
        (R = E[W]) == null || R.push(M);
      }), E;
    }), A = $(() => u[r.theme]), L = $(() => ({
      "--border-color": o[r.theme]
    }));
    function z(E, w = "") {
      const M = {
        event: "NavClick",
        category: w,
        // selectedItemID.value ? 'SiteNav.Open' : 'SiteNav.close',
        label: E.label,
        action: "Click"
      };
      s("gtmEvent", M);
    }
    function Y(E) {
      var w;
      return E.id === ((w = S.value) == null ? void 0 : w.id) ? Z.caretUp : Z.caretDown;
    }
    function D(E) {
      return E.navItems && E.navItems.length > 0;
    }
    function O(E) {
      var w;
      !E || E.id === ((w = S.value) == null ? void 0 : w.id) ? (g.value = !1, m.value = null, S.value = null) : (g.value = !0, m.value = E, S.value = E), _.value = `${E == null ? void 0 : E.label} menu open`, z(E, g.value ? "TopDrawer.Open" : "TopDrawer.Close"), s("toggleDropdown", !!S.value);
    }
    return fo(d, () => {
      s("toggleDropdown", !1), S.value && z(S.value, "TopDrawer.Close"), g.value = !1, m.value = null, S.value = null;
    }), (E, w) => {
      var M, W, R;
      return T(), U("div", {
        class: K(["top-nav", v($r)[r.theme], v(bt)[r.theme]]),
        style: kn(L.value),
        ref_key: "topNav",
        ref: d
      }, [
        F("nav", $w, [
          F("div", Cw, [
            (T(!0), U(Be, null, Ye(k.value.left, (q) => (T(), ce(v(Xe), {
              class: "nav-item",
              variant: v(je).tertiary,
              color: A.value,
              size: v(Ue).md,
              "icon-name": Y(q),
              "no-icon": !D(q),
              href: q.href,
              "link-type": D(q) ? "button" : "a",
              key: q.id,
              onClick: (G) => O(q)
            }, {
              default: ne(() => [
                Ke(re(q.label), 1)
              ]),
              _: 2
            }, 1032, ["variant", "color", "size", "icon-name", "no-icon", "href", "link-type", "onClick"]))), 128))
          ]),
          F("div", kw, [
            (T(!0), U(Be, null, Ye(k.value.right, (q) => (T(), ce(v(Xe), {
              class: "nav-item",
              variant: v(je).tertiary,
              color: A.value,
              size: v(Ue).md,
              "icon-name": Y(q),
              "no-icon": !D(q),
              href: q.href,
              "link-type": D(q) ? "button" : "a",
              key: q.id,
              onClick: (G) => O(q)
            }, {
              default: ne(() => [
                Ke(re(q.label), 1)
              ]),
              _: 2
            }, 1032, ["variant", "color", "size", "icon-name", "no-icon", "href", "link-type", "onClick"]))), 128))
          ])
        ]),
        (M = m.value) != null && M.navItems && ((W = m.value) == null ? void 0 : W.navItems.length) > 0 ? (T(), U("div", {
          key: 0,
          class: K(["top-nav-drawer", v($r)[r.theme], v(bt)[r.theme], { visible: g.value }]),
          ref: "itemDrawer"
        }, [
          F("nav", {
            class: "top-nav-drawer-wrapper",
            "aria-label": _.value
          }, [
            (T(!0), U(Be, null, Ye((R = m.value) == null ? void 0 : R.navItems, (q) => (T(), ce(v(al), {
              class: "drawer-col",
              orientation: v(kr).vertical,
              size: v(Gt).xs,
              "border-style": v(Bt).noDivider,
              key: q.id
            }, {
              default: ne(() => [
                se(v(nr), {
                  size: v(Gt).sm,
                  "border-style": v(Bt).noDivider
                }, {
                  default: ne(() => [
                    q.href ? (T(), ce(v(Xe), {
                      key: 0,
                      class: K("col-title-button"),
                      variant: v(je).tertiary,
                      color: v(We).red,
                      size: v(Ue).md,
                      href: q == null ? void 0 : q.href,
                      "link-type": "a",
                      animated: "",
                      onClick: (G) => z(q, "Nav.Link")
                    }, {
                      default: ne(() => [
                        Ke(re(q.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["variant", "color", "size", "href", "onClick"])) : (T(), U("span", {
                      key: 1,
                      class: K(["col-title", c.span[r.theme]])
                    }, re(q.label), 3))
                  ]),
                  _: 2
                }, 1032, ["size", "border-style"]),
                (T(!0), U(Be, null, Ye(q == null ? void 0 : q.navItems, (G) => (T(), ce(v(nr), {
                  size: v(Gt).xs,
                  "border-style": v(Bt).noDivider,
                  key: G == null ? void 0 : G.id
                }, {
                  default: ne(() => [
                    se(v(Xe), {
                      class: "p-0 hover:opacity-60",
                      variant: v(je).tertiary,
                      color: A.value,
                      size: v(Ue).md,
                      "no-icon": !0,
                      href: G == null ? void 0 : G.href,
                      "link-type": "a",
                      onClick: (X) => z(G, "Nav.Link")
                    }, {
                      default: ne(() => [
                        Ke(re(G.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["variant", "color", "size", "href", "onClick"])
                  ]),
                  _: 2
                }, 1032, ["size", "border-style"]))), 128))
              ]),
              _: 2
            }, 1032, ["orientation", "size", "border-style"]))), 128))
          ], 8, Ow)
        ], 2)) : ae("", !0)
      ], 6);
    };
  }
}), Aw = /* @__PURE__ */ _e(Ew, [["__scopeId", "data-v-db0a0138"]]), Lw = { class: "nav-wrapper" }, Rw = { class: "nested-nav-content" }, Dw = ["href"], Pw = { style: { visibility: "hidden", position: "absolute" } }, Bw = {
  key: 0,
  class: "breadcrumb flex"
}, Mw = {
  class: /* @__PURE__ */ K(["nested-nav-content-trigger"])
}, Fw = { class: "tab-wrapper" }, zw = { class: "nested-nav-tabs" }, Uw = { class: "nested-nav-tab-content" }, Ww = {
  key: 0,
  class: "parent-tablink"
}, Hw = {
  key: 0,
  class: "t-body-md pt-1.5"
}, qw = { class: "tablinks" }, Gw = {
  key: 0,
  class: "t-body-sm pt-0.5"
}, Vw = /* @__PURE__ */ Q({
  __name: "NestedNav",
  props: {
    navType: {
      type: String,
      default: "top-drawer"
    },
    content: {
      type: Object,
      required: !0
    },
    theme: {
      type: String,
      default: "light"
    },
    highlight: {
      type: Boolean,
      default: !0
    },
    activeItemId: {
      // this can provide the current holder for the page navigation's main trigger
      type: String || null,
      default: null
    }
  },
  emits: ["toggleDropdown", "gtmEvent"],
  setup(n, { emit: i }) {
    Hn((te) => ({
      c38b41e2: `${S.value}px`
    }));
    const r = n, u = i, o = B(null), c = B(!1), s = B(), d = B(), g = B([]), y = B(), _ = B(), m = B(!1), S = B(0), k = B(null), A = B([]), L = $(() => {
      const fe = ["simpleNav", "drawerNav", "navItems"].reduce((ke, tt) => {
        var Le, we;
        return ke || ((we = (Le = r.content) == null ? void 0 : Le.navSections) == null ? void 0 : we[tt]);
      }, null) || [];
      return Jc(fe);
    }), z = $(() => ({
      "--nav-border-color": co[r.theme]
    }));
    fo(o, () => {
      u("toggleDropdown", !1), c.value && Y(s.value, "NavDrawer.Close"), c.value = !1;
    });
    function Y(te, fe = "") {
      const ke = {
        event: "NavClick",
        category: fe,
        label: te.label,
        action: "Click"
      };
      u("gtmEvent", ke);
    }
    function D(te) {
      const fe = L.value;
      for (const ke in fe) {
        const tt = fe[ke].find((Le) => Le.id === te);
        if (tt)
          return tt;
      }
      return null;
    }
    function O(te) {
      return te != null && te.discardTabs ? [{
        id: `${te.id}-Tabs`,
        label: te.tabsTitleOverride || te.label,
        navItems: te.navItems
      }] : te.navItems;
    }
    const E = B(r.activeItemId ? D(r.activeItemId) : null), w = $(() => {
      let te = {
        id: "root",
        label: r.content.mainLink.label,
        navItems: r.content.navSections.navItems
      };
      return E.value && (te = {
        ...E.value,
        id: E.value.id,
        label: E.value.label,
        navItems: E.value.navItems
      }), te.navItems = O(te), te;
    });
    function M(te, fe) {
      return fe === 0 || !fe ? null : L.value[fe - 1].filter((tt) => tt.id === te)[0];
    }
    async function W() {
      const te = [];
      let fe = w.value;
      for (; fe; ) {
        const tt = M(fe.parentId, fe.depth);
        if (tt)
          tt.navItems = O(tt), te.push(tt), fe = tt;
        else {
          te.push({
            id: "root",
            label: r.content.mainLink.label,
            navItems: r.content.navSections.navItems
          });
          break;
        }
      }
      const ke = te.reverse();
      A.value = ke, await xt(), ve();
    }
    function R(te) {
      const fe = !c.value || d.value !== te.id;
      fe && (g.value = (te == null ? void 0 : te.navItems) || [], q(G(g.value, r.activeItemId))), d.value = fe ? te.id : "", c.value = fe, Y(te, fe ? "NestedNav.Open" : "NestedNav.close"), u("toggleDropdown", c.value);
    }
    function q(te) {
      y.value = te, _.value = te == null ? void 0 : te.navItems;
    }
    function G(te, fe) {
      return te.find((ke) => (ke == null ? void 0 : ke.id) === fe) || te[0];
    }
    function X(te) {
      return c.value && te === d.value ? Z.caretUp : Z.caretDown;
    }
    function ve() {
      if (k.value) {
        const te = k.value.querySelectorAll(".nested-nav-trigger");
        S.value = Array.from(te).reduce((fe, ke) => fe + ke.offsetWidth, 0);
      }
    }
    function pe() {
      m.value = !m.value, A.value.find((fe) => fe.id === d.value) && !m.value && (c.value = !1, u("toggleDropdown", !1)), k.value && (k.value.style.width = m.value ? `${S.value}px` : "0px");
    }
    const Ce = {
      light: We.neutral,
      mid: We.neutral,
      dark: We.white
    }, de = $(() => Ce[r.theme]);
    return vc(() => {
      E.value = r.activeItemId ? D(r.activeItemId) : null, s.value = E.value || w.value, d.value = w.value.id, r.activeItemId && W();
    }), Ae(() => {
      r.activeItemId && ve();
    }), (te, fe) => {
      var ke, tt;
      return T(), U("div", {
        class: K(["nested-nav", { "breadcrumbs-open": m.value }, v($r)[r.theme], v(bt)[r.theme], { "crumbs-open": m.value }]),
        style: kn(z.value),
        ref_key: "nestedNav",
        ref: o
      }, [
        F("div", Lw, [
          F("div", Rw, [
            F("a", {
              class: "logo",
              href: r.content.mainLink.href
            }, [
              se(v(St), {
                "no-scale": "",
                src: r.content.logo,
                objectFit: v(Pt).contain,
                "alt-text": r.content.mainLink.label
              }, null, 8, ["src", "objectFit", "alt-text"]),
              F("span", Pw, re(r.content.mainLink.label), 1)
            ], 8, Dw),
            A.value.length > 0 ? (T(), U("div", Bw, [
              F("div", {
                class: K(["crumbs", { open: m.value }]),
                ref_key: "crumbs",
                ref: k
              }, [
                (T(!0), U(Be, null, Ye(A.value, (Le) => (T(), ce(v(Xe), {
                  class: K(["nested-nav-trigger", "hover-state", { active: Le.id === d.value && c.value }]),
                  variant: v(je).tertiary,
                  color: de.value,
                  size: v(Ue).md,
                  "icon-name": X(Le.id || ""),
                  "no-icon": !1,
                  "link-type": "button",
                  key: Le.id,
                  onClick: (we) => R(Le)
                }, {
                  default: ne(() => [
                    Ke(re(Le.label), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "variant", "color", "size", "icon-name", "onClick"]))), 128))
              ], 2),
              se(v(Xe), {
                variant: v(je).tertiary,
                color: de.value,
                size: v(Ue).md,
                "icon-name": m.value ? v(Z).close : v(Z).dots,
                "no-icon": !1,
                "link-type": "button",
                onClick: pe
              }, null, 8, ["variant", "color", "size", "icon-name"])
            ])) : ae("", !0),
            F("div", Mw, [
              se(v(Xe), {
                class: K(["nested-nav-trigger", "main-trigger", "hover-state", { active: ((ke = w.value) == null ? void 0 : ke.id) === d.value && c.value }]),
                variant: v(je).tertiary,
                color: de.value,
                size: v(Ue).md,
                "icon-name": X(((tt = w.value) == null ? void 0 : tt.id) || ""),
                "no-icon": !1,
                "link-type": "button",
                onClick: fe[0] || (fe[0] = (Le) => R(w.value))
              }, {
                default: ne(() => {
                  var Le;
                  return [
                    Ke(re((Le = w.value) == null ? void 0 : Le.label), 1)
                  ];
                }),
                _: 1
              }, 8, ["class", "variant", "color", "size", "icon-name"])
            ])
          ]),
          ue(te.$slots, "cta")
        ]),
        c.value ? (T(), U("div", {
          key: 0,
          class: K(["nested-nav-drawer", v($r)[r.theme], v(bt)[r.theme]])
        }, [
          F("div", Fw, [
            F("div", zw, [
              (T(!0), U(Be, null, Ye(g.value, (Le) => (T(), ce(v(Xe), {
                class: K(["hover-state", { active: y.value.id === Le.id }]),
                variant: v(je).tertiary,
                color: de.value,
                size: v(Ue).md,
                "link-type": "button",
                "no-icon": !0,
                key: Le.id,
                onClick: (we) => q(Le)
              }, {
                default: ne(() => [
                  Ke(re(Le.label), 1)
                ]),
                _: 2
              }, 1032, ["class", "variant", "color", "size", "onClick"]))), 128))
            ]),
            F("div", Uw, [
              y.value && y.value.href ? (T(), U("div", Ww, [
                se(v(Xe), {
                  class: "animated-icon",
                  variant: v(je).tertiary,
                  color: de.value,
                  size: v(Ue).xl,
                  "link-type": "a",
                  href: y.value.href
                }, {
                  default: ne(() => [
                    Ke(re(y.value.label), 1)
                  ]),
                  _: 1
                }, 8, ["variant", "color", "size", "href"]),
                y.value && y.value.description ? (T(), U("p", Hw, re(y.value.description), 1)) : ae("", !0)
              ])) : ae("", !0),
              F("div", qw, [
                (T(!0), U(Be, null, Ye(_.value, (Le) => (T(), U("div", {
                  class: "tablink",
                  key: Le.id
                }, [
                  se(v(Xe), {
                    class: "animated-icon",
                    variant: v(je).tertiary,
                    color: de.value,
                    size: v(Ue).md,
                    "link-type": "a",
                    href: Le.href
                  }, {
                    default: ne(() => [
                      Ke(re(Le.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["variant", "color", "size", "href"]),
                  Le.description ? (T(), U("p", Gw, re(Le.description), 1)) : ae("", !0)
                ]))), 128))
              ])
            ])
          ])
        ], 2)) : ae("", !0)
      ], 6);
    };
  }
}), Nw = /* @__PURE__ */ _e(Vw, [["__scopeId", "data-v-4dcbea80"]]), jw = {
  class: /* @__PURE__ */ K(["item-list-nav-bar"])
}, Kw = ["aria-label"], Yw = ["aria-label"], Zw = {
  key: 0,
  class: "parent-link"
}, Xw = {
  key: 1,
  class: "head-label"
}, Jw = /* @__PURE__ */ Q({
  __name: "ItemList",
  props: {
    navType: {
      type: String,
      default: "primary"
    },
    content: {
      type: Object,
      required: !0
    },
    theme: {
      type: String,
      default: "light"
    },
    alwaysShowMobileMenu: {
      type: Boolean,
      default: !1
    },
    activeItemId: {
      // this can provide the current holder for the page navigation's main trigger
      type: String || null,
      default: null
    }
  },
  emits: ["gtmEvent", "slideStatus"],
  setup(n, { emit: i }) {
    const r = n, u = {
      light: We.neutral,
      mid: We.neutral,
      dark: We.white
    }, o = i, c = B(!1), s = B(), d = B(null), g = B(), y = B(), _ = B(Z.menu), m = r.content, S = $(() => !!(m != null && m.logo)), k = $(() => {
      const R = ["simpleNav", "drawerNav", "navItems"].reduce((q, G) => {
        var X;
        return q || ((X = m == null ? void 0 : m.navSections) == null ? void 0 : X[G]);
      }, null) || [];
      return Jc(R);
    }), A = $(() => u[r.theme]), L = $(() => ({
      "--nav-border-color": co[r.theme]
    }));
    function z(W, R = "") {
      const q = {
        event: "NavClick",
        category: R,
        label: W.label,
        action: "Click"
      };
      o("gtmEvent", q);
    }
    function Y() {
      const W = r.activeItemId ? M(r.activeItemId) : null;
      W && O(W), c.value = !c.value, _.value = c.value ? Z.close : Z.menu, o("slideStatus", c.value), z({ label: "CompactList Menu Trigger" }, c.value ? "CompactList.Open" : "CompactList.Close"), c.value || (d.value = null, g.value = void 0, s.value = k.value[0]);
    }
    function D(W, R) {
      return k.value[R - 1].filter((G) => G.id === W)[0];
    }
    function O(W) {
      var R;
      if (!W.navItems || ((R = W.navItems) == null ? void 0 : R.length) === 0) {
        z(W, "CompactList.Link");
        return;
      }
      y.value = W, z(W, "CompactListMenu.Open"), g.value = W.parentId ? D(W.parentId, W.depth) : {
        depth: -1,
        id: "root",
        label: "Back to main menu",
        parentId: null
      }, d.value = W != null && W.discardTabs ? W.tabsTitleOverride : W.label, s.value = W.navItems;
    }
    function E(W) {
      W.depth === -1 ? (y.value = void 0, d.value = null, g.value = void 0, s.value = k.value[0]) : O(W);
    }
    function w(W) {
      return W.navItems && W.navItems.length > 0 ? "button" : "a";
    }
    function M(W) {
      const R = k.value;
      for (const q in R) {
        const G = R[q].find((X) => X.id === W);
        if (G)
          return G;
      }
      return null;
    }
    return vc(() => {
      s.value = k.value[0];
    }), (W, R) => {
      var q, G, X, ve, pe, Ce;
      return T(), U("div", {
        class: K(["item-list-nav", v(ll)[r.theme], v(bt)[r.theme], `nav-border-${r.theme}`]),
        style: kn(L.value)
      }, [
        F("div", jw, [
          g.value ? d.value ? (T(), ce(v(Xe), {
            key: 1,
            variant: v(je).tertiary,
            color: A.value,
            size: v(Ue).lg,
            "icon-name": v(Z).caretLeft,
            "icon-left": "",
            "link-type": "button",
            onClick: R[0] || (R[0] = (de) => E(g.value))
          }, {
            default: ne(() => {
              var de;
              return [
                Ke(re(g.value.depth === 0 && ((de = y.value) == null ? void 0 : de.depth) === 0 ? "Back to main menu" : g.value.label), 1)
              ];
            }),
            _: 1
          }, 8, ["variant", "color", "size", "icon-name"])) : ae("", !0) : (T(), ce(en((q = v(m)) != null && q.mainLink.href ? "a" : "div"), {
            key: 0,
            class: K(["no-underline", v(bt)[r.theme]]),
            href: (G = v(m)) == null ? void 0 : G.mainLink.href
          }, {
            default: ne(() => {
              var de, te, fe;
              return [
                S.value && !d.value ? (T(), ce(v(St), {
                  key: 0,
                  "no-scale": "",
                  class: "logo",
                  src: ((de = v(m)) == null ? void 0 : de.logo) || "",
                  altText: ((te = v(m)) == null ? void 0 : te.mainLink.label) || "",
                  objectFit: v(Pt).contain,
                  objectPosition: v(Mt).left
                }, null, 8, ["src", "altText", "objectFit", "objectPosition"])) : !S.value && !d.value ? (T(), U("span", {
                  key: 1,
                  class: K(["default-title", { invisible: c.value }])
                }, re(((fe = v(m)) == null ? void 0 : fe.mainLink.label) || "Explore"), 3)) : ae("", !0)
              ];
            }),
            _: 1
          }, 8, ["href", "class"])),
          se(v(Xe), {
            class: "menu-toggle",
            variant: v(je).tertiary,
            color: A.value,
            size: v(Ue).lg,
            "icon-name": _.value,
            "icon-only": "",
            "link-type": "button",
            "aria-label": `${((X = v(m)) == null ? void 0 : X.mainLink.label) || "Explore"} menu toggle`,
            onClick: Y
          }, null, 8, ["variant", "color", "size", "icon-name", "aria-label"])
        ]),
        F("nav", {
          "aria-label": `${((ve = v(m)) == null ? void 0 : ve.mainLink.label) || "Explore"} mobile menu`,
          class: K(["nav-mobile-content", { visible: c.value }, v(ll)[r.theme], v(bt)[r.theme]])
        }, [
          F("nav", {
            class: "current-menu",
            "aria-label": `${g.value ? g.value.label : "main"} mobile menu`
          }, [
            (pe = y.value) != null && pe.href ? (T(), U("div", Zw, [
              se(v(Xe), {
                variant: v(je).tertiary,
                color: A.value,
                size: v(Ue).xl,
                "no-icon": "",
                href: (Ce = y.value) == null ? void 0 : Ce.href,
                "link-type": "a",
                "space-variant": v(di).spaced
              }, {
                default: ne(() => {
                  var de;
                  return [
                    Ke(re((de = y.value) == null ? void 0 : de.label) + " Overview ", 1)
                  ];
                }),
                _: 1
              }, 8, ["variant", "color", "size", "href", "space-variant"])
            ])) : ae("", !0),
            g.value ? (T(), U("span", Xw, re(d.value), 1)) : ae("", !0),
            se(v(al), {
              orientation: v(kr).vertical,
              size: v(Gt).xl,
              "border-style": v(Bt).noDivider
            }, {
              default: ne(() => [
                (T(!0), U(Be, null, Ye(s.value, (de) => (T(), ce(v(nr), {
                  size: v(Gt).xl,
                  "border-style": v(Bt).noDivider,
                  key: de.id
                }, {
                  default: ne(() => [
                    se(v(Xe), {
                      class: "p-0",
                      variant: v(je).tertiary,
                      color: A.value,
                      size: v(Ue).xl,
                      "no-icon": w(de) === "a",
                      href: de.href,
                      "icon-name": v(Z).caretRight,
                      "link-type": w(de),
                      "space-variant": v(di).spaced,
                      onClick: (te) => O(de)
                    }, {
                      default: ne(() => [
                        Ke(re(de.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["variant", "color", "size", "no-icon", "href", "icon-name", "link-type", "space-variant", "onClick"])
                  ]),
                  _: 2
                }, 1032, ["size", "border-style"]))), 128))
              ]),
              _: 1
            }, 8, ["orientation", "size", "border-style"])
          ], 8, Yw)
        ], 10, Kw)
      ], 6);
    };
  }
}), Qw = /* @__PURE__ */ _e(Jw, [["__scopeId", "data-v-4b4d68b5"]]), ex = ["href"], tx = ["aria-label"], nx = {
  key: 0,
  class: "pt-2 pb-4"
}, rx = {
  key: 0,
  class: "additional-content"
}, lx = /* @__PURE__ */ Q({
  __name: "ItemAccordion",
  props: {
    content: {
      type: Object,
      required: !0
    },
    theme: {
      type: String,
      default: "light"
    },
    showMobileBorder: {
      type: Boolean,
      default: !1
    },
    alwaysShowMobileMenu: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["gtmEvent", "slideStatus"],
  setup(n, { emit: i }) {
    var O;
    Hn((E) => ({
      "83b90602": o[r.theme]
    }));
    const r = n, u = {
      light: We.neutral,
      mid: We.neutral,
      dark: We.white
    }, o = {
      light: "#DDDDDE",
      mid: "#222324",
      dark: "#555759"
    }, c = i, s = Cr(), d = B(r.content), g = B(!1), y = B(!1), _ = $(() => {
      var E, w;
      return (w = (E = d.value) == null ? void 0 : E.navSections) == null ? void 0 : w.simpleNav;
    }), m = $(() => {
      var E;
      return (E = d.value) == null ? void 0 : E.logo;
    }), S = $(() => u[r.theme]);
    function k(E, w = "") {
      const M = {
        event: "NavClick",
        category: w,
        label: E.label,
        action: "Click"
      };
      c("gtmEvent", M);
    }
    function A(E) {
      const w = E.event && E.event.split(".")[1];
      k(E, `CompactNavMenu.${w}`);
    }
    const L = (O = _.value) == null ? void 0 : O.map((E, w) => ({ ...E, order: w.toString(), is_open: !1 })), z = B(L), Y = (E) => {
      var w;
      if (!E)
        return null;
      z.value = (w = z.value) == null ? void 0 : w.map((M) => M.order === E ? { ...M, is_open: !M.is_open } : M.is_open ? { ...M, is_open: !1 } : M);
    };
    function D() {
      g.value = !g.value, c("slideStatus", g.value), k({ label: "CompactNav Menu Trigger" }, g.value ? "CompactNav.Open" : "CompactNav.Close");
    }
    return Ae(() => {
      if (s.additionalContent) {
        const E = s.additionalContent({})[0].children;
        y.value = Array.isArray(E) && E.length > 0;
      }
    }), (E, w) => {
      var M, W, R;
      return T(), U("div", {
        class: K(["item-accordion-nav", v(ll)[r.theme], v(bt)[r.theme]])
      }, [
        F("div", {
          class: K(["item-accordion-nav-bar", v(ll)[r.theme], v(bt)[r.theme]])
        }, [
          m.value ? (T(), U("a", {
            key: 0,
            href: (M = d.value) == null ? void 0 : M.mainLink.href,
            class: K(v(bt)[r.theme])
          }, [
            se(v(St), {
              class: "logo",
              "no-scale": "",
              src: ((W = d.value) == null ? void 0 : W.logo) || "",
              altText: ((R = d.value) == null ? void 0 : R.mainLink.label) || "",
              objectPosition: v(Mt).left
            }, {
              default: ne(() => {
                var q;
                return [
                  Ke(re((q = d.value) == null ? void 0 : q.mainLink.label), 1)
                ];
              }),
              _: 1
            }, 8, ["src", "altText", "objectPosition"])
          ], 10, ex)) : (T(), ce(v(Xe), {
            key: 1,
            class: "item-accordion-nav-bar-trigger",
            variant: v(je).tertiary,
            color: S.value,
            size: v(Ue).md,
            "icon-name": g.value ? v(Z).caretUp : v(Z).caretDown,
            "no-icon": n.alwaysShowMobileMenu,
            "link-type": "button",
            onClick: D
          }, {
            default: ne(() => [
              Ke(re(d.value.mainLink.label), 1)
            ]),
            _: 1
          }, 8, ["variant", "color", "size", "icon-name", "no-icon"])),
          ue(E.$slots, "cta", {}, void 0, !0)
        ], 2),
        F("nav", {
          "aria-label": `${d.value.mainLink.label} mobile menu`,
          class: K(["nav-mobile-content", { visible: g.value && !n.alwaysShowMobileMenu }, { "static-visible": n.alwaysShowMobileMenu }, v(ll)[r.theme], v(bt)[r.theme]])
        }, [
          F("ul", null, [
            (T(!0), U(Be, null, Ye(z.value, (q, G) => (T(), U(Be, {
              key: q.id
            }, [
              !(q != null && q.navItems) || (q == null ? void 0 : q.navItems.length) === 0 ? (T(), U("div", nx, [
                se(v(Xe), {
                  variant: v(je).tertiary,
                  color: S.value,
                  size: v(Ue).md,
                  "no-icon": "",
                  href: q == null ? void 0 : q.href,
                  "space-variant": v(di).spaced,
                  "link-type": "a",
                  onClick: (X) => k(q, "CompactNav.Link")
                }, {
                  default: ne(() => [
                    Ke(re(q.label), 1)
                  ]),
                  _: 2
                }, 1032, ["variant", "color", "size", "href", "space-variant", "onClick"])
              ])) : (T(), ce(v(Wy), {
                key: 1,
                class: "nav-mobile-content__accordion",
                id: G.toString(),
                "item-title": q.label,
                "accordion-size": v(to).small,
                "show-accordion": q == null ? void 0 : q.is_open,
                "show-border": r.showMobileBorder,
                theme: r.theme,
                onGtmEvent: A,
                onToggleAccordion: Y
              }, {
                accCta: ne(() => [
                  se(v(al), {
                    orientation: v(kr).vertical,
                    size: v(Gt).lg,
                    "border-style": v(Bt).noDivider
                  }, {
                    default: ne(() => [
                      (T(!0), U(Be, null, Ye(q == null ? void 0 : q.navItems, (X) => (T(), ce(v(nr), {
                        size: v(Gt).lg,
                        "border-style": v(Bt).noDivider,
                        key: X == null ? void 0 : X.id
                      }, {
                        default: ne(() => [
                          se(v(Xe), {
                            class: "p-0",
                            variant: v(je).tertiary,
                            color: S.value,
                            size: v(Ue).sm,
                            "no-icon": !0,
                            href: X == null ? void 0 : X.href,
                            "link-type": "a",
                            onClick: (ve) => k(X, "CompactNav.Link")
                          }, {
                            default: ne(() => [
                              Ke(re(X.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["variant", "color", "size", "href", "onClick"])
                        ]),
                        _: 2
                      }, 1032, ["size", "border-style"]))), 128))
                    ]),
                    _: 2
                  }, 1032, ["orientation", "size", "border-style"])
                ]),
                _: 2
              }, 1032, ["id", "item-title", "accordion-size", "show-accordion", "show-border", "theme"]))
            ], 64))), 128)),
            y.value ? (T(), U("li", rx, [
              ue(E.$slots, "additionalContent", {}, void 0, !0)
            ])) : ae("", !0)
          ])
        ], 10, tx)
      ], 2);
    };
  }
}), ix = /* @__PURE__ */ _e(lx, [["__scopeId", "data-v-a17896ee"]]), ax = { class: "nav-container-desk" }, ox = { class: "nav-container-mobile" }, sx = /* @__PURE__ */ Q({
  __name: "NavBuilder",
  props: {
    navType: {
      type: String,
      default: "primary"
    },
    mobileNavType: {
      type: String,
      default: "item-list"
    },
    alwaysShowMobileMenu: {
      type: Boolean,
      default: !1
    },
    showMobileBorder: {
      type: Boolean,
      default: !1
    },
    content: {
      type: Object,
      required: !0
    },
    theme: {
      type: String,
      default: "light"
    },
    highlight: {
      type: Boolean,
      default: !0
    },
    activeItemId: {
      type: String || null,
      default: null
    }
  },
  emits: ["gtmEvent"],
  setup(n, { emit: i }) {
    const r = {
      primary: oc,
      secondary: oc,
      "top-drawer": Aw,
      static: Iw,
      nested: Nw
    }, u = {
      "item-list": Qw,
      "item-accordion": ix
    }, o = n, c = i, s = B(null), d = B(null);
    let g = { top: 0, left: 0 };
    const y = B(!1), _ = $(() => r[o.navType]), m = $(() => u[o.mobileNavType]);
    function S() {
      g = {
        top: window.scrollY,
        left: window.scrollX
      }, window.addEventListener("scroll", A, { passive: !1 }), window.addEventListener("wheel", A, { passive: !1 }), window.addEventListener("touchmove", A, { passive: !1 });
    }
    function k() {
      window.removeEventListener("scroll", A), window.removeEventListener("wheel", A), window.removeEventListener("touchmove", A), window.scrollTo(g.left, g.top);
    }
    function A(O) {
      O.stopPropagation(), O.preventDefault(), window.scrollTo(g.left, g.top);
    }
    function L(O) {
      O ? S() : k();
    }
    function z(O) {
      y.value = O;
    }
    function Y() {
      const O = s == null ? void 0 : s.value, E = d == null ? void 0 : d.value, { top: w } = O.getBoundingClientRect();
      E.style.top = `${w + 48}px`;
    }
    function D(O) {
      c("gtmEvent", O);
    }
    return vt(y, (O) => {
      O ? (Y(), setTimeout(() => {
        S();
      }, 100)) : k();
    }, { flush: "post" }), (O, E) => (T(), U("div", {
      class: K(["nav-container"]),
      ref_key: "navContainer",
      ref: s
    }, [
      F("div", ax, [
        (T(), ce(en(_.value), hn({ navType: n.navType, content: n.content, theme: n.theme, highlight: n.highlight, activeItemId: n.activeItemId }, {
          onToggleDropdown: z,
          onGtmEvent: D
        }), ci({ _: 2 }, [
          Ye(v(ac)[o.navType], (w, M) => ({
            name: w,
            fn: ne(() => [
              ue(O.$slots, w, { key: w }, void 0, !0)
            ])
          }))
        ]), 1040))
      ]),
      F("div", ox, [
        (T(), ce(en(m.value), hn({ content: n.content, theme: n.theme, alwaysShowMobileMenu: n.alwaysShowMobileMenu, showMobileBorder: n.showMobileBorder, navType: n.navType, activeItemId: n.activeItemId }, {
          onGtmEvent: D,
          onSlideStatus: L
        }), ci({ _: 2 }, [
          Ye(v(ac)[o.navType], (w, M) => ({
            name: w,
            fn: ne(() => [
              ue(O.$slots, w, { key: w }, void 0, !0)
            ])
          }))
        ]), 1040))
      ]),
      y.value ? (T(), U("div", {
        key: 0,
        class: K(["nav-overlay"]),
        ref_key: "overlay",
        ref: d
      }, null, 512)) : ae("", !0)
    ], 512));
  }
}), aS = /* @__PURE__ */ _e(sx, [["__scopeId", "data-v-ecf62dd6"]]);
var vn = /* @__PURE__ */ ((n) => (n.light = "light", n.dark = "dark", n))(vn || {});
const ux = { class: "modal" }, cx = { class: "modal__wrapper" }, dx = { class: "modal__panel__header" }, fx = {
  key: 0,
  class: "modal__panel__header__symbol"
}, vx = { class: "modal__panel__header__symbol__heading" }, px = {
  key: 1,
  class: "modal__panel__header__no-symbol"
}, hx = {
  key: 0,
  class: "modal__panel__body"
}, mx = {
  key: 1,
  class: "modal__panel__cta-group"
}, gx = /* @__PURE__ */ Q({
  __name: "Modal",
  props: {
    title: {
      type: String,
      default: ""
    },
    symbol: {
      type: Boolean,
      default: !1
    },
    isOpen: {
      type: Boolean,
      default: !1
    },
    theme: {
      type: String,
      default: vn.light
    },
    size: {
      type: String,
      default: "md"
    }
  },
  emits: ["close"],
  setup(n, { emit: i }) {
    const r = i, u = {
      md: "max-w-[640px]",
      lg: "max-w-[740px]",
      xl: "max-w-[1024px]"
    }, o = () => {
      r("close");
    };
    return (c, s) => (T(), ce(v(Yc), {
      appear: "",
      show: n.isOpen,
      as: "template"
    }, {
      default: ne(() => [
        se(v(Q1), {
          as: "div",
          open: n.isOpen,
          onClose: o
        }, {
          default: ne(() => [
            F("div", ux, [
              se(v(Kc), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: ne(() => [
                  F("div", {
                    class: K(["modal__background", { "modal__background--dark": n.theme === v(vn).dark, "modal__background--light": n.theme === v(vn).light }])
                  }, null, 2)
                ]),
                _: 1
              }),
              F("div", cx, [
                se(v(e_), {
                  class: K(["modal__panel", [u[n.size], n.theme === v(vn).dark && "modal__panel--dark", n.theme === v(vn).light && "modal__panel--light"]])
                }, {
                  default: ne(() => [
                    F("section", dx, [
                      n.symbol ? (T(), U("div", fx, [
                        F("div", vx, [
                          ue(c.$slots, "symbol", {}, void 0, !0),
                          F("button", {
                            class: K(["modal__panel__header__close", { "modal__panel__header__close--dark": n.theme === v(vn).dark, "modal__panel__header__close--light": n.theme === v(vn).light }]),
                            onClick: Nu(o, ["prevent"])
                          }, [
                            se(v(kt), {
                              "icon-name": v(Z).close,
                              size: v(ft).lg
                            }, null, 8, ["icon-name", "size"])
                          ], 2)
                        ]),
                        se(v(nc), {
                          as: "h3",
                          class: "modal__panel__body__title"
                        }, {
                          default: ne(() => [
                            Ke(re(n.title), 1)
                          ]),
                          _: 1
                        })
                      ])) : (T(), U("div", px, [
                        se(v(nc), {
                          as: "h3",
                          class: "modal__panel__body__title"
                        }, {
                          default: ne(() => [
                            Ke(re(n.title), 1)
                          ]),
                          _: 1
                        }),
                        F("button", {
                          class: K(["modal__panel__header__close", { "modal__panel__header__close--dark": n.theme === v(vn).dark, "modal__panel__header__close--light": n.theme === v(vn).light }]),
                          onClick: Nu(o, ["prevent"])
                        }, [
                          se(v(kt), {
                            "icon-name": v(Z).close,
                            size: v(ft).lg
                          }, null, 8, ["icon-name", "size"])
                        ], 2)
                      ])),
                      se(v(t_), {
                        as: "div",
                        class: "modal__panel__body__description"
                      }, {
                        default: ne(() => [
                          ue(c.$slots, "description", {}, void 0, !0)
                        ]),
                        _: 3
                      })
                    ]),
                    c.$slots["modal-content"] ? (T(), U("section", hx, [
                      ue(c.$slots, "modal-content", {}, void 0, !0)
                    ])) : ae("", !0),
                    c.$slots["cta-group"] ? (T(), U("section", mx, [
                      ue(c.$slots, "cta-group", {}, void 0, !0)
                    ])) : ae("", !0)
                  ]),
                  _: 3
                }, 8, ["class"])
              ])
            ])
          ]),
          _: 3
        }, 8, ["open"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), oS = /* @__PURE__ */ _e(gx, [["__scopeId", "data-v-2ba0f366"]]);
var tl = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, fi = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
fi.exports;
(function(n, i) {
  (function() {
    var r, u = "4.17.21", o = 200, c = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", s = "Expected a function", d = "Invalid `variable` option passed into `_.template`", g = "__lodash_hash_undefined__", y = 500, _ = "__lodash_placeholder__", m = 1, S = 2, k = 4, A = 1, L = 2, z = 1, Y = 2, D = 4, O = 8, E = 16, w = 32, M = 64, W = 128, R = 256, q = 512, G = 30, X = "...", ve = 800, pe = 16, Ce = 1, de = 2, te = 3, fe = 1 / 0, ke = 9007199254740991, tt = 17976931348623157e292, Le = NaN, we = 4294967295, Qe = we - 1, Ot = we >>> 1, Et = [
      ["ary", W],
      ["bind", z],
      ["bindKey", Y],
      ["curry", O],
      ["curryRight", E],
      ["flip", q],
      ["partial", w],
      ["partialRight", M],
      ["rearg", R]
    ], un = "[object Arguments]", mn = "[object Array]", td = "[object AsyncFunction]", Er = "[object Boolean]", Ar = "[object Date]", nd = "[object DOMException]", fl = "[object Error]", vl = "[object Function]", vo = "[object GeneratorFunction]", nn = "[object Map]", Lr = "[object Number]", rd = "[object Null]", gn = "[object Object]", po = "[object Promise]", ld = "[object Proxy]", Rr = "[object RegExp]", rn = "[object Set]", Dr = "[object String]", pl = "[object Symbol]", id = "[object Undefined]", Pr = "[object WeakMap]", ad = "[object WeakSet]", Br = "[object ArrayBuffer]", sr = "[object DataView]", gi = "[object Float32Array]", bi = "[object Float64Array]", yi = "[object Int8Array]", _i = "[object Int16Array]", wi = "[object Int32Array]", xi = "[object Uint8Array]", Si = "[object Uint8ClampedArray]", Ti = "[object Uint16Array]", Ii = "[object Uint32Array]", od = /\b__p \+= '';/g, sd = /\b(__p \+=) '' \+/g, ud = /(__e\(.*?\)|\b__t\)) \+\n'';/g, ho = /&(?:amp|lt|gt|quot|#39);/g, mo = /[&<>"']/g, cd = RegExp(ho.source), dd = RegExp(mo.source), fd = /<%-([\s\S]+?)%>/g, vd = /<%([\s\S]+?)%>/g, go = /<%=([\s\S]+?)%>/g, pd = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, hd = /^\w*$/, md = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, $i = /[\\^$.*+?()[\]{}|]/g, gd = RegExp($i.source), Ci = /^\s+/, bd = /\s/, yd = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, _d = /\{\n\/\* \[wrapped with (.+)\] \*/, wd = /,? & /, xd = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Sd = /[()=,{}\[\]\/\s]/, Td = /\\(\\)?/g, Id = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, bo = /\w*$/, $d = /^[-+]0x[0-9a-f]+$/i, Cd = /^0b[01]+$/i, kd = /^\[object .+?Constructor\]$/, Od = /^0o[0-7]+$/i, Ed = /^(?:0|[1-9]\d*)$/, Ad = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, hl = /($^)/, Ld = /['\n\r\u2028\u2029\\]/g, ml = "\\ud800-\\udfff", Rd = "\\u0300-\\u036f", Dd = "\\ufe20-\\ufe2f", Pd = "\\u20d0-\\u20ff", yo = Rd + Dd + Pd, _o = "\\u2700-\\u27bf", wo = "a-z\\xdf-\\xf6\\xf8-\\xff", Bd = "\\xac\\xb1\\xd7\\xf7", Md = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Fd = "\\u2000-\\u206f", zd = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", xo = "A-Z\\xc0-\\xd6\\xd8-\\xde", So = "\\ufe0e\\ufe0f", To = Bd + Md + Fd + zd, ki = "['’]", Ud = "[" + ml + "]", Io = "[" + To + "]", gl = "[" + yo + "]", $o = "\\d+", Wd = "[" + _o + "]", Co = "[" + wo + "]", ko = "[^" + ml + To + $o + _o + wo + xo + "]", Oi = "\\ud83c[\\udffb-\\udfff]", Hd = "(?:" + gl + "|" + Oi + ")", Oo = "[^" + ml + "]", Ei = "(?:\\ud83c[\\udde6-\\uddff]){2}", Ai = "[\\ud800-\\udbff][\\udc00-\\udfff]", ur = "[" + xo + "]", Eo = "\\u200d", Ao = "(?:" + Co + "|" + ko + ")", qd = "(?:" + ur + "|" + ko + ")", Lo = "(?:" + ki + "(?:d|ll|m|re|s|t|ve))?", Ro = "(?:" + ki + "(?:D|LL|M|RE|S|T|VE))?", Do = Hd + "?", Po = "[" + So + "]?", Gd = "(?:" + Eo + "(?:" + [Oo, Ei, Ai].join("|") + ")" + Po + Do + ")*", Vd = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Nd = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Bo = Po + Do + Gd, jd = "(?:" + [Wd, Ei, Ai].join("|") + ")" + Bo, Kd = "(?:" + [Oo + gl + "?", gl, Ei, Ai, Ud].join("|") + ")", Yd = RegExp(ki, "g"), Zd = RegExp(gl, "g"), Li = RegExp(Oi + "(?=" + Oi + ")|" + Kd + Bo, "g"), Xd = RegExp([
      ur + "?" + Co + "+" + Lo + "(?=" + [Io, ur, "$"].join("|") + ")",
      qd + "+" + Ro + "(?=" + [Io, ur + Ao, "$"].join("|") + ")",
      ur + "?" + Ao + "+" + Lo,
      ur + "+" + Ro,
      Nd,
      Vd,
      $o,
      jd
    ].join("|"), "g"), Jd = RegExp("[" + Eo + ml + yo + So + "]"), Qd = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, ef = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], tf = -1, Ze = {};
    Ze[gi] = Ze[bi] = Ze[yi] = Ze[_i] = Ze[wi] = Ze[xi] = Ze[Si] = Ze[Ti] = Ze[Ii] = !0, Ze[un] = Ze[mn] = Ze[Br] = Ze[Er] = Ze[sr] = Ze[Ar] = Ze[fl] = Ze[vl] = Ze[nn] = Ze[Lr] = Ze[gn] = Ze[Rr] = Ze[rn] = Ze[Dr] = Ze[Pr] = !1;
    var Ve = {};
    Ve[un] = Ve[mn] = Ve[Br] = Ve[sr] = Ve[Er] = Ve[Ar] = Ve[gi] = Ve[bi] = Ve[yi] = Ve[_i] = Ve[wi] = Ve[nn] = Ve[Lr] = Ve[gn] = Ve[Rr] = Ve[rn] = Ve[Dr] = Ve[pl] = Ve[xi] = Ve[Si] = Ve[Ti] = Ve[Ii] = !0, Ve[fl] = Ve[vl] = Ve[Pr] = !1;
    var nf = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, rf = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, lf = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, af = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, of = parseFloat, sf = parseInt, Mo = typeof tl == "object" && tl && tl.Object === Object && tl, uf = typeof self == "object" && self && self.Object === Object && self, mt = Mo || uf || Function("return this")(), Ri = i && !i.nodeType && i, qn = Ri && !0 && n && !n.nodeType && n, Fo = qn && qn.exports === Ri, Di = Fo && Mo.process, Vt = function() {
      try {
        var I = qn && qn.require && qn.require("util").types;
        return I || Di && Di.binding && Di.binding("util");
      } catch {
      }
    }(), zo = Vt && Vt.isArrayBuffer, Uo = Vt && Vt.isDate, Wo = Vt && Vt.isMap, Ho = Vt && Vt.isRegExp, qo = Vt && Vt.isSet, Go = Vt && Vt.isTypedArray;
    function Ft(I, H, P) {
      switch (P.length) {
        case 0:
          return I.call(H);
        case 1:
          return I.call(H, P[0]);
        case 2:
          return I.call(H, P[0], P[1]);
        case 3:
          return I.call(H, P[0], P[1], P[2]);
      }
      return I.apply(H, P);
    }
    function cf(I, H, P, le) {
      for (var be = -1, Re = I == null ? 0 : I.length; ++be < Re; ) {
        var at = I[be];
        H(le, at, P(at), I);
      }
      return le;
    }
    function Nt(I, H) {
      for (var P = -1, le = I == null ? 0 : I.length; ++P < le && H(I[P], P, I) !== !1; )
        ;
      return I;
    }
    function df(I, H) {
      for (var P = I == null ? 0 : I.length; P-- && H(I[P], P, I) !== !1; )
        ;
      return I;
    }
    function Vo(I, H) {
      for (var P = -1, le = I == null ? 0 : I.length; ++P < le; )
        if (!H(I[P], P, I))
          return !1;
      return !0;
    }
    function En(I, H) {
      for (var P = -1, le = I == null ? 0 : I.length, be = 0, Re = []; ++P < le; ) {
        var at = I[P];
        H(at, P, I) && (Re[be++] = at);
      }
      return Re;
    }
    function bl(I, H) {
      var P = I == null ? 0 : I.length;
      return !!P && cr(I, H, 0) > -1;
    }
    function Pi(I, H, P) {
      for (var le = -1, be = I == null ? 0 : I.length; ++le < be; )
        if (P(H, I[le]))
          return !0;
      return !1;
    }
    function Je(I, H) {
      for (var P = -1, le = I == null ? 0 : I.length, be = Array(le); ++P < le; )
        be[P] = H(I[P], P, I);
      return be;
    }
    function An(I, H) {
      for (var P = -1, le = H.length, be = I.length; ++P < le; )
        I[be + P] = H[P];
      return I;
    }
    function Bi(I, H, P, le) {
      var be = -1, Re = I == null ? 0 : I.length;
      for (le && Re && (P = I[++be]); ++be < Re; )
        P = H(P, I[be], be, I);
      return P;
    }
    function ff(I, H, P, le) {
      var be = I == null ? 0 : I.length;
      for (le && be && (P = I[--be]); be--; )
        P = H(P, I[be], be, I);
      return P;
    }
    function Mi(I, H) {
      for (var P = -1, le = I == null ? 0 : I.length; ++P < le; )
        if (H(I[P], P, I))
          return !0;
      return !1;
    }
    var vf = Fi("length");
    function pf(I) {
      return I.split("");
    }
    function hf(I) {
      return I.match(xd) || [];
    }
    function No(I, H, P) {
      var le;
      return P(I, function(be, Re, at) {
        if (H(be, Re, at))
          return le = Re, !1;
      }), le;
    }
    function yl(I, H, P, le) {
      for (var be = I.length, Re = P + (le ? 1 : -1); le ? Re-- : ++Re < be; )
        if (H(I[Re], Re, I))
          return Re;
      return -1;
    }
    function cr(I, H, P) {
      return H === H ? Cf(I, H, P) : yl(I, jo, P);
    }
    function mf(I, H, P, le) {
      for (var be = P - 1, Re = I.length; ++be < Re; )
        if (le(I[be], H))
          return be;
      return -1;
    }
    function jo(I) {
      return I !== I;
    }
    function Ko(I, H) {
      var P = I == null ? 0 : I.length;
      return P ? Ui(I, H) / P : Le;
    }
    function Fi(I) {
      return function(H) {
        return H == null ? r : H[I];
      };
    }
    function zi(I) {
      return function(H) {
        return I == null ? r : I[H];
      };
    }
    function Yo(I, H, P, le, be) {
      return be(I, function(Re, at, qe) {
        P = le ? (le = !1, Re) : H(P, Re, at, qe);
      }), P;
    }
    function gf(I, H) {
      var P = I.length;
      for (I.sort(H); P--; )
        I[P] = I[P].value;
      return I;
    }
    function Ui(I, H) {
      for (var P, le = -1, be = I.length; ++le < be; ) {
        var Re = H(I[le]);
        Re !== r && (P = P === r ? Re : P + Re);
      }
      return P;
    }
    function Wi(I, H) {
      for (var P = -1, le = Array(I); ++P < I; )
        le[P] = H(P);
      return le;
    }
    function bf(I, H) {
      return Je(H, function(P) {
        return [P, I[P]];
      });
    }
    function Zo(I) {
      return I && I.slice(0, es(I) + 1).replace(Ci, "");
    }
    function zt(I) {
      return function(H) {
        return I(H);
      };
    }
    function Hi(I, H) {
      return Je(H, function(P) {
        return I[P];
      });
    }
    function Mr(I, H) {
      return I.has(H);
    }
    function Xo(I, H) {
      for (var P = -1, le = I.length; ++P < le && cr(H, I[P], 0) > -1; )
        ;
      return P;
    }
    function Jo(I, H) {
      for (var P = I.length; P-- && cr(H, I[P], 0) > -1; )
        ;
      return P;
    }
    function yf(I, H) {
      for (var P = I.length, le = 0; P--; )
        I[P] === H && ++le;
      return le;
    }
    var _f = zi(nf), wf = zi(rf);
    function xf(I) {
      return "\\" + af[I];
    }
    function Sf(I, H) {
      return I == null ? r : I[H];
    }
    function dr(I) {
      return Jd.test(I);
    }
    function Tf(I) {
      return Qd.test(I);
    }
    function If(I) {
      for (var H, P = []; !(H = I.next()).done; )
        P.push(H.value);
      return P;
    }
    function qi(I) {
      var H = -1, P = Array(I.size);
      return I.forEach(function(le, be) {
        P[++H] = [be, le];
      }), P;
    }
    function Qo(I, H) {
      return function(P) {
        return I(H(P));
      };
    }
    function Ln(I, H) {
      for (var P = -1, le = I.length, be = 0, Re = []; ++P < le; ) {
        var at = I[P];
        (at === H || at === _) && (I[P] = _, Re[be++] = P);
      }
      return Re;
    }
    function _l(I) {
      var H = -1, P = Array(I.size);
      return I.forEach(function(le) {
        P[++H] = le;
      }), P;
    }
    function $f(I) {
      var H = -1, P = Array(I.size);
      return I.forEach(function(le) {
        P[++H] = [le, le];
      }), P;
    }
    function Cf(I, H, P) {
      for (var le = P - 1, be = I.length; ++le < be; )
        if (I[le] === H)
          return le;
      return -1;
    }
    function kf(I, H, P) {
      for (var le = P + 1; le--; )
        if (I[le] === H)
          return le;
      return le;
    }
    function fr(I) {
      return dr(I) ? Ef(I) : vf(I);
    }
    function ln(I) {
      return dr(I) ? Af(I) : pf(I);
    }
    function es(I) {
      for (var H = I.length; H-- && bd.test(I.charAt(H)); )
        ;
      return H;
    }
    var Of = zi(lf);
    function Ef(I) {
      for (var H = Li.lastIndex = 0; Li.test(I); )
        ++H;
      return H;
    }
    function Af(I) {
      return I.match(Li) || [];
    }
    function Lf(I) {
      return I.match(Xd) || [];
    }
    var Rf = function I(H) {
      H = H == null ? mt : vr.defaults(mt.Object(), H, vr.pick(mt, ef));
      var P = H.Array, le = H.Date, be = H.Error, Re = H.Function, at = H.Math, qe = H.Object, Gi = H.RegExp, Df = H.String, jt = H.TypeError, wl = P.prototype, Pf = Re.prototype, pr = qe.prototype, xl = H["__core-js_shared__"], Sl = Pf.toString, Me = pr.hasOwnProperty, Bf = 0, ts = function() {
        var e = /[^.]+$/.exec(xl && xl.keys && xl.keys.IE_PROTO || "");
        return e ? "Symbol(src)_1." + e : "";
      }(), Tl = pr.toString, Mf = Sl.call(qe), Ff = mt._, zf = Gi(
        "^" + Sl.call(Me).replace($i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Il = Fo ? H.Buffer : r, Rn = H.Symbol, $l = H.Uint8Array, ns = Il ? Il.allocUnsafe : r, Cl = Qo(qe.getPrototypeOf, qe), rs = qe.create, ls = pr.propertyIsEnumerable, kl = wl.splice, is = Rn ? Rn.isConcatSpreadable : r, Fr = Rn ? Rn.iterator : r, Gn = Rn ? Rn.toStringTag : r, Ol = function() {
        try {
          var e = Yn(qe, "defineProperty");
          return e({}, "", {}), e;
        } catch {
        }
      }(), Uf = H.clearTimeout !== mt.clearTimeout && H.clearTimeout, Wf = le && le.now !== mt.Date.now && le.now, Hf = H.setTimeout !== mt.setTimeout && H.setTimeout, El = at.ceil, Al = at.floor, Vi = qe.getOwnPropertySymbols, qf = Il ? Il.isBuffer : r, as = H.isFinite, Gf = wl.join, Vf = Qo(qe.keys, qe), ot = at.max, _t = at.min, Nf = le.now, jf = H.parseInt, os = at.random, Kf = wl.reverse, Ni = Yn(H, "DataView"), zr = Yn(H, "Map"), ji = Yn(H, "Promise"), hr = Yn(H, "Set"), Ur = Yn(H, "WeakMap"), Wr = Yn(qe, "create"), Ll = Ur && new Ur(), mr = {}, Yf = Zn(Ni), Zf = Zn(zr), Xf = Zn(ji), Jf = Zn(hr), Qf = Zn(Ur), Rl = Rn ? Rn.prototype : r, Hr = Rl ? Rl.valueOf : r, ss = Rl ? Rl.toString : r;
      function p(e) {
        if (nt(e) && !ye(e) && !(e instanceof Oe)) {
          if (e instanceof Kt)
            return e;
          if (Me.call(e, "__wrapped__"))
            return uu(e);
        }
        return new Kt(e);
      }
      var gr = /* @__PURE__ */ function() {
        function e() {
        }
        return function(t) {
          if (!et(t))
            return {};
          if (rs)
            return rs(t);
          e.prototype = t;
          var l = new e();
          return e.prototype = r, l;
        };
      }();
      function Dl() {
      }
      function Kt(e, t) {
        this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = r;
      }
      p.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: fd,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: vd,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: go,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: p
        }
      }, p.prototype = Dl.prototype, p.prototype.constructor = p, Kt.prototype = gr(Dl.prototype), Kt.prototype.constructor = Kt;
      function Oe(e) {
        this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = we, this.__views__ = [];
      }
      function ev() {
        var e = new Oe(this.__wrapped__);
        return e.__actions__ = At(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = At(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = At(this.__views__), e;
      }
      function tv() {
        if (this.__filtered__) {
          var e = new Oe(this);
          e.__dir__ = -1, e.__filtered__ = !0;
        } else
          e = this.clone(), e.__dir__ *= -1;
        return e;
      }
      function nv() {
        var e = this.__wrapped__.value(), t = this.__dir__, l = ye(e), a = t < 0, f = l ? e.length : 0, h = pp(0, f, this.__views__), b = h.start, x = h.end, C = x - b, V = a ? x : b - 1, N = this.__iteratees__, j = N.length, ee = 0, ie = _t(C, this.__takeCount__);
        if (!l || !a && f == C && ie == C)
          return Ls(e, this.__actions__);
        var me = [];
        e:
          for (; C-- && ee < ie; ) {
            V += t;
            for (var Te = -1, ge = e[V]; ++Te < j; ) {
              var $e = N[Te], Ee = $e.iteratee, Ht = $e.type, $t = Ee(ge);
              if (Ht == de)
                ge = $t;
              else if (!$t) {
                if (Ht == Ce)
                  continue e;
                break e;
              }
            }
            me[ee++] = ge;
          }
        return me;
      }
      Oe.prototype = gr(Dl.prototype), Oe.prototype.constructor = Oe;
      function Vn(e) {
        var t = -1, l = e == null ? 0 : e.length;
        for (this.clear(); ++t < l; ) {
          var a = e[t];
          this.set(a[0], a[1]);
        }
      }
      function rv() {
        this.__data__ = Wr ? Wr(null) : {}, this.size = 0;
      }
      function lv(e) {
        var t = this.has(e) && delete this.__data__[e];
        return this.size -= t ? 1 : 0, t;
      }
      function iv(e) {
        var t = this.__data__;
        if (Wr) {
          var l = t[e];
          return l === g ? r : l;
        }
        return Me.call(t, e) ? t[e] : r;
      }
      function av(e) {
        var t = this.__data__;
        return Wr ? t[e] !== r : Me.call(t, e);
      }
      function ov(e, t) {
        var l = this.__data__;
        return this.size += this.has(e) ? 0 : 1, l[e] = Wr && t === r ? g : t, this;
      }
      Vn.prototype.clear = rv, Vn.prototype.delete = lv, Vn.prototype.get = iv, Vn.prototype.has = av, Vn.prototype.set = ov;
      function bn(e) {
        var t = -1, l = e == null ? 0 : e.length;
        for (this.clear(); ++t < l; ) {
          var a = e[t];
          this.set(a[0], a[1]);
        }
      }
      function sv() {
        this.__data__ = [], this.size = 0;
      }
      function uv(e) {
        var t = this.__data__, l = Pl(t, e);
        if (l < 0)
          return !1;
        var a = t.length - 1;
        return l == a ? t.pop() : kl.call(t, l, 1), --this.size, !0;
      }
      function cv(e) {
        var t = this.__data__, l = Pl(t, e);
        return l < 0 ? r : t[l][1];
      }
      function dv(e) {
        return Pl(this.__data__, e) > -1;
      }
      function fv(e, t) {
        var l = this.__data__, a = Pl(l, e);
        return a < 0 ? (++this.size, l.push([e, t])) : l[a][1] = t, this;
      }
      bn.prototype.clear = sv, bn.prototype.delete = uv, bn.prototype.get = cv, bn.prototype.has = dv, bn.prototype.set = fv;
      function yn(e) {
        var t = -1, l = e == null ? 0 : e.length;
        for (this.clear(); ++t < l; ) {
          var a = e[t];
          this.set(a[0], a[1]);
        }
      }
      function vv() {
        this.size = 0, this.__data__ = {
          hash: new Vn(),
          map: new (zr || bn)(),
          string: new Vn()
        };
      }
      function pv(e) {
        var t = jl(this, e).delete(e);
        return this.size -= t ? 1 : 0, t;
      }
      function hv(e) {
        return jl(this, e).get(e);
      }
      function mv(e) {
        return jl(this, e).has(e);
      }
      function gv(e, t) {
        var l = jl(this, e), a = l.size;
        return l.set(e, t), this.size += l.size == a ? 0 : 1, this;
      }
      yn.prototype.clear = vv, yn.prototype.delete = pv, yn.prototype.get = hv, yn.prototype.has = mv, yn.prototype.set = gv;
      function Nn(e) {
        var t = -1, l = e == null ? 0 : e.length;
        for (this.__data__ = new yn(); ++t < l; )
          this.add(e[t]);
      }
      function bv(e) {
        return this.__data__.set(e, g), this;
      }
      function yv(e) {
        return this.__data__.has(e);
      }
      Nn.prototype.add = Nn.prototype.push = bv, Nn.prototype.has = yv;
      function an(e) {
        var t = this.__data__ = new bn(e);
        this.size = t.size;
      }
      function _v() {
        this.__data__ = new bn(), this.size = 0;
      }
      function wv(e) {
        var t = this.__data__, l = t.delete(e);
        return this.size = t.size, l;
      }
      function xv(e) {
        return this.__data__.get(e);
      }
      function Sv(e) {
        return this.__data__.has(e);
      }
      function Tv(e, t) {
        var l = this.__data__;
        if (l instanceof bn) {
          var a = l.__data__;
          if (!zr || a.length < o - 1)
            return a.push([e, t]), this.size = ++l.size, this;
          l = this.__data__ = new yn(a);
        }
        return l.set(e, t), this.size = l.size, this;
      }
      an.prototype.clear = _v, an.prototype.delete = wv, an.prototype.get = xv, an.prototype.has = Sv, an.prototype.set = Tv;
      function us(e, t) {
        var l = ye(e), a = !l && Xn(e), f = !l && !a && Fn(e), h = !l && !a && !f && wr(e), b = l || a || f || h, x = b ? Wi(e.length, Df) : [], C = x.length;
        for (var V in e)
          (t || Me.call(e, V)) && !(b && // Safari 9 has enumerable `arguments.length` in strict mode.
          (V == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          f && (V == "offset" || V == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          h && (V == "buffer" || V == "byteLength" || V == "byteOffset") || // Skip index properties.
          Sn(V, C))) && x.push(V);
        return x;
      }
      function cs(e) {
        var t = e.length;
        return t ? e[la(0, t - 1)] : r;
      }
      function Iv(e, t) {
        return Kl(At(e), jn(t, 0, e.length));
      }
      function $v(e) {
        return Kl(At(e));
      }
      function Ki(e, t, l) {
        (l !== r && !on(e[t], l) || l === r && !(t in e)) && _n(e, t, l);
      }
      function qr(e, t, l) {
        var a = e[t];
        (!(Me.call(e, t) && on(a, l)) || l === r && !(t in e)) && _n(e, t, l);
      }
      function Pl(e, t) {
        for (var l = e.length; l--; )
          if (on(e[l][0], t))
            return l;
        return -1;
      }
      function Cv(e, t, l, a) {
        return Dn(e, function(f, h, b) {
          t(a, f, l(f), b);
        }), a;
      }
      function ds(e, t) {
        return e && dn(t, ct(t), e);
      }
      function kv(e, t) {
        return e && dn(t, Rt(t), e);
      }
      function _n(e, t, l) {
        t == "__proto__" && Ol ? Ol(e, t, {
          configurable: !0,
          enumerable: !0,
          value: l,
          writable: !0
        }) : e[t] = l;
      }
      function Yi(e, t) {
        for (var l = -1, a = t.length, f = P(a), h = e == null; ++l < a; )
          f[l] = h ? r : Oa(e, t[l]);
        return f;
      }
      function jn(e, t, l) {
        return e === e && (l !== r && (e = e <= l ? e : l), t !== r && (e = e >= t ? e : t)), e;
      }
      function Yt(e, t, l, a, f, h) {
        var b, x = t & m, C = t & S, V = t & k;
        if (l && (b = f ? l(e, a, f, h) : l(e)), b !== r)
          return b;
        if (!et(e))
          return e;
        var N = ye(e);
        if (N) {
          if (b = mp(e), !x)
            return At(e, b);
        } else {
          var j = wt(e), ee = j == vl || j == vo;
          if (Fn(e))
            return Ps(e, x);
          if (j == gn || j == un || ee && !f) {
            if (b = C || ee ? {} : eu(e), !x)
              return C ? ip(e, kv(b, e)) : lp(e, ds(b, e));
          } else {
            if (!Ve[j])
              return f ? e : {};
            b = gp(e, j, x);
          }
        }
        h || (h = new an());
        var ie = h.get(e);
        if (ie)
          return ie;
        h.set(e, b), Ou(e) ? e.forEach(function(ge) {
          b.add(Yt(ge, t, l, ge, e, h));
        }) : Cu(e) && e.forEach(function(ge, $e) {
          b.set($e, Yt(ge, t, l, $e, e, h));
        });
        var me = V ? C ? ha : pa : C ? Rt : ct, Te = N ? r : me(e);
        return Nt(Te || e, function(ge, $e) {
          Te && ($e = ge, ge = e[$e]), qr(b, $e, Yt(ge, t, l, $e, e, h));
        }), b;
      }
      function Ov(e) {
        var t = ct(e);
        return function(l) {
          return fs(l, e, t);
        };
      }
      function fs(e, t, l) {
        var a = l.length;
        if (e == null)
          return !a;
        for (e = qe(e); a--; ) {
          var f = l[a], h = t[f], b = e[f];
          if (b === r && !(f in e) || !h(b))
            return !1;
        }
        return !0;
      }
      function vs(e, t, l) {
        if (typeof e != "function")
          throw new jt(s);
        return Zr(function() {
          e.apply(r, l);
        }, t);
      }
      function Gr(e, t, l, a) {
        var f = -1, h = bl, b = !0, x = e.length, C = [], V = t.length;
        if (!x)
          return C;
        l && (t = Je(t, zt(l))), a ? (h = Pi, b = !1) : t.length >= o && (h = Mr, b = !1, t = new Nn(t));
        e:
          for (; ++f < x; ) {
            var N = e[f], j = l == null ? N : l(N);
            if (N = a || N !== 0 ? N : 0, b && j === j) {
              for (var ee = V; ee--; )
                if (t[ee] === j)
                  continue e;
              C.push(N);
            } else
              h(t, j, a) || C.push(N);
          }
        return C;
      }
      var Dn = Us(cn), ps = Us(Xi, !0);
      function Ev(e, t) {
        var l = !0;
        return Dn(e, function(a, f, h) {
          return l = !!t(a, f, h), l;
        }), l;
      }
      function Bl(e, t, l) {
        for (var a = -1, f = e.length; ++a < f; ) {
          var h = e[a], b = t(h);
          if (b != null && (x === r ? b === b && !Wt(b) : l(b, x)))
            var x = b, C = h;
        }
        return C;
      }
      function Av(e, t, l, a) {
        var f = e.length;
        for (l = xe(l), l < 0 && (l = -l > f ? 0 : f + l), a = a === r || a > f ? f : xe(a), a < 0 && (a += f), a = l > a ? 0 : Au(a); l < a; )
          e[l++] = t;
        return e;
      }
      function hs(e, t) {
        var l = [];
        return Dn(e, function(a, f, h) {
          t(a, f, h) && l.push(a);
        }), l;
      }
      function gt(e, t, l, a, f) {
        var h = -1, b = e.length;
        for (l || (l = yp), f || (f = []); ++h < b; ) {
          var x = e[h];
          t > 0 && l(x) ? t > 1 ? gt(x, t - 1, l, a, f) : An(f, x) : a || (f[f.length] = x);
        }
        return f;
      }
      var Zi = Ws(), ms = Ws(!0);
      function cn(e, t) {
        return e && Zi(e, t, ct);
      }
      function Xi(e, t) {
        return e && ms(e, t, ct);
      }
      function Ml(e, t) {
        return En(t, function(l) {
          return Tn(e[l]);
        });
      }
      function Kn(e, t) {
        t = Bn(t, e);
        for (var l = 0, a = t.length; e != null && l < a; )
          e = e[fn(t[l++])];
        return l && l == a ? e : r;
      }
      function gs(e, t, l) {
        var a = t(e);
        return ye(e) ? a : An(a, l(e));
      }
      function Tt(e) {
        return e == null ? e === r ? id : rd : Gn && Gn in qe(e) ? vp(e) : $p(e);
      }
      function Ji(e, t) {
        return e > t;
      }
      function Lv(e, t) {
        return e != null && Me.call(e, t);
      }
      function Rv(e, t) {
        return e != null && t in qe(e);
      }
      function Dv(e, t, l) {
        return e >= _t(t, l) && e < ot(t, l);
      }
      function Qi(e, t, l) {
        for (var a = l ? Pi : bl, f = e[0].length, h = e.length, b = h, x = P(h), C = 1 / 0, V = []; b--; ) {
          var N = e[b];
          b && t && (N = Je(N, zt(t))), C = _t(N.length, C), x[b] = !l && (t || f >= 120 && N.length >= 120) ? new Nn(b && N) : r;
        }
        N = e[0];
        var j = -1, ee = x[0];
        e:
          for (; ++j < f && V.length < C; ) {
            var ie = N[j], me = t ? t(ie) : ie;
            if (ie = l || ie !== 0 ? ie : 0, !(ee ? Mr(ee, me) : a(V, me, l))) {
              for (b = h; --b; ) {
                var Te = x[b];
                if (!(Te ? Mr(Te, me) : a(e[b], me, l)))
                  continue e;
              }
              ee && ee.push(me), V.push(ie);
            }
          }
        return V;
      }
      function Pv(e, t, l, a) {
        return cn(e, function(f, h, b) {
          t(a, l(f), h, b);
        }), a;
      }
      function Vr(e, t, l) {
        t = Bn(t, e), e = lu(e, t);
        var a = e == null ? e : e[fn(Xt(t))];
        return a == null ? r : Ft(a, e, l);
      }
      function bs(e) {
        return nt(e) && Tt(e) == un;
      }
      function Bv(e) {
        return nt(e) && Tt(e) == Br;
      }
      function Mv(e) {
        return nt(e) && Tt(e) == Ar;
      }
      function Nr(e, t, l, a, f) {
        return e === t ? !0 : e == null || t == null || !nt(e) && !nt(t) ? e !== e && t !== t : Fv(e, t, l, a, Nr, f);
      }
      function Fv(e, t, l, a, f, h) {
        var b = ye(e), x = ye(t), C = b ? mn : wt(e), V = x ? mn : wt(t);
        C = C == un ? gn : C, V = V == un ? gn : V;
        var N = C == gn, j = V == gn, ee = C == V;
        if (ee && Fn(e)) {
          if (!Fn(t))
            return !1;
          b = !0, N = !1;
        }
        if (ee && !N)
          return h || (h = new an()), b || wr(e) ? Xs(e, t, l, a, f, h) : dp(e, t, C, l, a, f, h);
        if (!(l & A)) {
          var ie = N && Me.call(e, "__wrapped__"), me = j && Me.call(t, "__wrapped__");
          if (ie || me) {
            var Te = ie ? e.value() : e, ge = me ? t.value() : t;
            return h || (h = new an()), f(Te, ge, l, a, h);
          }
        }
        return ee ? (h || (h = new an()), fp(e, t, l, a, f, h)) : !1;
      }
      function zv(e) {
        return nt(e) && wt(e) == nn;
      }
      function ea(e, t, l, a) {
        var f = l.length, h = f, b = !a;
        if (e == null)
          return !h;
        for (e = qe(e); f--; ) {
          var x = l[f];
          if (b && x[2] ? x[1] !== e[x[0]] : !(x[0] in e))
            return !1;
        }
        for (; ++f < h; ) {
          x = l[f];
          var C = x[0], V = e[C], N = x[1];
          if (b && x[2]) {
            if (V === r && !(C in e))
              return !1;
          } else {
            var j = new an();
            if (a)
              var ee = a(V, N, C, e, t, j);
            if (!(ee === r ? Nr(N, V, A | L, a, j) : ee))
              return !1;
          }
        }
        return !0;
      }
      function ys(e) {
        if (!et(e) || wp(e))
          return !1;
        var t = Tn(e) ? zf : kd;
        return t.test(Zn(e));
      }
      function Uv(e) {
        return nt(e) && Tt(e) == Rr;
      }
      function Wv(e) {
        return nt(e) && wt(e) == rn;
      }
      function Hv(e) {
        return nt(e) && ei(e.length) && !!Ze[Tt(e)];
      }
      function _s(e) {
        return typeof e == "function" ? e : e == null ? Dt : typeof e == "object" ? ye(e) ? Ss(e[0], e[1]) : xs(e) : Hu(e);
      }
      function ta(e) {
        if (!Yr(e))
          return Vf(e);
        var t = [];
        for (var l in qe(e))
          Me.call(e, l) && l != "constructor" && t.push(l);
        return t;
      }
      function qv(e) {
        if (!et(e))
          return Ip(e);
        var t = Yr(e), l = [];
        for (var a in e)
          a == "constructor" && (t || !Me.call(e, a)) || l.push(a);
        return l;
      }
      function na(e, t) {
        return e < t;
      }
      function ws(e, t) {
        var l = -1, a = Lt(e) ? P(e.length) : [];
        return Dn(e, function(f, h, b) {
          a[++l] = t(f, h, b);
        }), a;
      }
      function xs(e) {
        var t = ga(e);
        return t.length == 1 && t[0][2] ? nu(t[0][0], t[0][1]) : function(l) {
          return l === e || ea(l, e, t);
        };
      }
      function Ss(e, t) {
        return ya(e) && tu(t) ? nu(fn(e), t) : function(l) {
          var a = Oa(l, e);
          return a === r && a === t ? Ea(l, e) : Nr(t, a, A | L);
        };
      }
      function Fl(e, t, l, a, f) {
        e !== t && Zi(t, function(h, b) {
          if (f || (f = new an()), et(h))
            Gv(e, t, b, l, Fl, a, f);
          else {
            var x = a ? a(wa(e, b), h, b + "", e, t, f) : r;
            x === r && (x = h), Ki(e, b, x);
          }
        }, Rt);
      }
      function Gv(e, t, l, a, f, h, b) {
        var x = wa(e, l), C = wa(t, l), V = b.get(C);
        if (V) {
          Ki(e, l, V);
          return;
        }
        var N = h ? h(x, C, l + "", e, t, b) : r, j = N === r;
        if (j) {
          var ee = ye(C), ie = !ee && Fn(C), me = !ee && !ie && wr(C);
          N = C, ee || ie || me ? ye(x) ? N = x : rt(x) ? N = At(x) : ie ? (j = !1, N = Ps(C, !0)) : me ? (j = !1, N = Bs(C, !0)) : N = [] : Xr(C) || Xn(C) ? (N = x, Xn(x) ? N = Lu(x) : (!et(x) || Tn(x)) && (N = eu(C))) : j = !1;
        }
        j && (b.set(C, N), f(N, C, a, h, b), b.delete(C)), Ki(e, l, N);
      }
      function Ts(e, t) {
        var l = e.length;
        if (l)
          return t += t < 0 ? l : 0, Sn(t, l) ? e[t] : r;
      }
      function Is(e, t, l) {
        t.length ? t = Je(t, function(h) {
          return ye(h) ? function(b) {
            return Kn(b, h.length === 1 ? h[0] : h);
          } : h;
        }) : t = [Dt];
        var a = -1;
        t = Je(t, zt(he()));
        var f = ws(e, function(h, b, x) {
          var C = Je(t, function(V) {
            return V(h);
          });
          return { criteria: C, index: ++a, value: h };
        });
        return gf(f, function(h, b) {
          return rp(h, b, l);
        });
      }
      function Vv(e, t) {
        return $s(e, t, function(l, a) {
          return Ea(e, a);
        });
      }
      function $s(e, t, l) {
        for (var a = -1, f = t.length, h = {}; ++a < f; ) {
          var b = t[a], x = Kn(e, b);
          l(x, b) && jr(h, Bn(b, e), x);
        }
        return h;
      }
      function Nv(e) {
        return function(t) {
          return Kn(t, e);
        };
      }
      function ra(e, t, l, a) {
        var f = a ? mf : cr, h = -1, b = t.length, x = e;
        for (e === t && (t = At(t)), l && (x = Je(e, zt(l))); ++h < b; )
          for (var C = 0, V = t[h], N = l ? l(V) : V; (C = f(x, N, C, a)) > -1; )
            x !== e && kl.call(x, C, 1), kl.call(e, C, 1);
        return e;
      }
      function Cs(e, t) {
        for (var l = e ? t.length : 0, a = l - 1; l--; ) {
          var f = t[l];
          if (l == a || f !== h) {
            var h = f;
            Sn(f) ? kl.call(e, f, 1) : oa(e, f);
          }
        }
        return e;
      }
      function la(e, t) {
        return e + Al(os() * (t - e + 1));
      }
      function jv(e, t, l, a) {
        for (var f = -1, h = ot(El((t - e) / (l || 1)), 0), b = P(h); h--; )
          b[a ? h : ++f] = e, e += l;
        return b;
      }
      function ia(e, t) {
        var l = "";
        if (!e || t < 1 || t > ke)
          return l;
        do
          t % 2 && (l += e), t = Al(t / 2), t && (e += e);
        while (t);
        return l;
      }
      function Ie(e, t) {
        return xa(ru(e, t, Dt), e + "");
      }
      function Kv(e) {
        return cs(xr(e));
      }
      function Yv(e, t) {
        var l = xr(e);
        return Kl(l, jn(t, 0, l.length));
      }
      function jr(e, t, l, a) {
        if (!et(e))
          return e;
        t = Bn(t, e);
        for (var f = -1, h = t.length, b = h - 1, x = e; x != null && ++f < h; ) {
          var C = fn(t[f]), V = l;
          if (C === "__proto__" || C === "constructor" || C === "prototype")
            return e;
          if (f != b) {
            var N = x[C];
            V = a ? a(N, C, x) : r, V === r && (V = et(N) ? N : Sn(t[f + 1]) ? [] : {});
          }
          qr(x, C, V), x = x[C];
        }
        return e;
      }
      var ks = Ll ? function(e, t) {
        return Ll.set(e, t), e;
      } : Dt, Zv = Ol ? function(e, t) {
        return Ol(e, "toString", {
          configurable: !0,
          enumerable: !1,
          value: La(t),
          writable: !0
        });
      } : Dt;
      function Xv(e) {
        return Kl(xr(e));
      }
      function Zt(e, t, l) {
        var a = -1, f = e.length;
        t < 0 && (t = -t > f ? 0 : f + t), l = l > f ? f : l, l < 0 && (l += f), f = t > l ? 0 : l - t >>> 0, t >>>= 0;
        for (var h = P(f); ++a < f; )
          h[a] = e[a + t];
        return h;
      }
      function Jv(e, t) {
        var l;
        return Dn(e, function(a, f, h) {
          return l = t(a, f, h), !l;
        }), !!l;
      }
      function zl(e, t, l) {
        var a = 0, f = e == null ? a : e.length;
        if (typeof t == "number" && t === t && f <= Ot) {
          for (; a < f; ) {
            var h = a + f >>> 1, b = e[h];
            b !== null && !Wt(b) && (l ? b <= t : b < t) ? a = h + 1 : f = h;
          }
          return f;
        }
        return aa(e, t, Dt, l);
      }
      function aa(e, t, l, a) {
        var f = 0, h = e == null ? 0 : e.length;
        if (h === 0)
          return 0;
        t = l(t);
        for (var b = t !== t, x = t === null, C = Wt(t), V = t === r; f < h; ) {
          var N = Al((f + h) / 2), j = l(e[N]), ee = j !== r, ie = j === null, me = j === j, Te = Wt(j);
          if (b)
            var ge = a || me;
          else
            V ? ge = me && (a || ee) : x ? ge = me && ee && (a || !ie) : C ? ge = me && ee && !ie && (a || !Te) : ie || Te ? ge = !1 : ge = a ? j <= t : j < t;
          ge ? f = N + 1 : h = N;
        }
        return _t(h, Qe);
      }
      function Os(e, t) {
        for (var l = -1, a = e.length, f = 0, h = []; ++l < a; ) {
          var b = e[l], x = t ? t(b) : b;
          if (!l || !on(x, C)) {
            var C = x;
            h[f++] = b === 0 ? 0 : b;
          }
        }
        return h;
      }
      function Es(e) {
        return typeof e == "number" ? e : Wt(e) ? Le : +e;
      }
      function Ut(e) {
        if (typeof e == "string")
          return e;
        if (ye(e))
          return Je(e, Ut) + "";
        if (Wt(e))
          return ss ? ss.call(e) : "";
        var t = e + "";
        return t == "0" && 1 / e == -fe ? "-0" : t;
      }
      function Pn(e, t, l) {
        var a = -1, f = bl, h = e.length, b = !0, x = [], C = x;
        if (l)
          b = !1, f = Pi;
        else if (h >= o) {
          var V = t ? null : up(e);
          if (V)
            return _l(V);
          b = !1, f = Mr, C = new Nn();
        } else
          C = t ? [] : x;
        e:
          for (; ++a < h; ) {
            var N = e[a], j = t ? t(N) : N;
            if (N = l || N !== 0 ? N : 0, b && j === j) {
              for (var ee = C.length; ee--; )
                if (C[ee] === j)
                  continue e;
              t && C.push(j), x.push(N);
            } else
              f(C, j, l) || (C !== x && C.push(j), x.push(N));
          }
        return x;
      }
      function oa(e, t) {
        return t = Bn(t, e), e = lu(e, t), e == null || delete e[fn(Xt(t))];
      }
      function As(e, t, l, a) {
        return jr(e, t, l(Kn(e, t)), a);
      }
      function Ul(e, t, l, a) {
        for (var f = e.length, h = a ? f : -1; (a ? h-- : ++h < f) && t(e[h], h, e); )
          ;
        return l ? Zt(e, a ? 0 : h, a ? h + 1 : f) : Zt(e, a ? h + 1 : 0, a ? f : h);
      }
      function Ls(e, t) {
        var l = e;
        return l instanceof Oe && (l = l.value()), Bi(t, function(a, f) {
          return f.func.apply(f.thisArg, An([a], f.args));
        }, l);
      }
      function sa(e, t, l) {
        var a = e.length;
        if (a < 2)
          return a ? Pn(e[0]) : [];
        for (var f = -1, h = P(a); ++f < a; )
          for (var b = e[f], x = -1; ++x < a; )
            x != f && (h[f] = Gr(h[f] || b, e[x], t, l));
        return Pn(gt(h, 1), t, l);
      }
      function Rs(e, t, l) {
        for (var a = -1, f = e.length, h = t.length, b = {}; ++a < f; ) {
          var x = a < h ? t[a] : r;
          l(b, e[a], x);
        }
        return b;
      }
      function ua(e) {
        return rt(e) ? e : [];
      }
      function ca(e) {
        return typeof e == "function" ? e : Dt;
      }
      function Bn(e, t) {
        return ye(e) ? e : ya(e, t) ? [e] : su(Pe(e));
      }
      var Qv = Ie;
      function Mn(e, t, l) {
        var a = e.length;
        return l = l === r ? a : l, !t && l >= a ? e : Zt(e, t, l);
      }
      var Ds = Uf || function(e) {
        return mt.clearTimeout(e);
      };
      function Ps(e, t) {
        if (t)
          return e.slice();
        var l = e.length, a = ns ? ns(l) : new e.constructor(l);
        return e.copy(a), a;
      }
      function da(e) {
        var t = new e.constructor(e.byteLength);
        return new $l(t).set(new $l(e)), t;
      }
      function ep(e, t) {
        var l = t ? da(e.buffer) : e.buffer;
        return new e.constructor(l, e.byteOffset, e.byteLength);
      }
      function tp(e) {
        var t = new e.constructor(e.source, bo.exec(e));
        return t.lastIndex = e.lastIndex, t;
      }
      function np(e) {
        return Hr ? qe(Hr.call(e)) : {};
      }
      function Bs(e, t) {
        var l = t ? da(e.buffer) : e.buffer;
        return new e.constructor(l, e.byteOffset, e.length);
      }
      function Ms(e, t) {
        if (e !== t) {
          var l = e !== r, a = e === null, f = e === e, h = Wt(e), b = t !== r, x = t === null, C = t === t, V = Wt(t);
          if (!x && !V && !h && e > t || h && b && C && !x && !V || a && b && C || !l && C || !f)
            return 1;
          if (!a && !h && !V && e < t || V && l && f && !a && !h || x && l && f || !b && f || !C)
            return -1;
        }
        return 0;
      }
      function rp(e, t, l) {
        for (var a = -1, f = e.criteria, h = t.criteria, b = f.length, x = l.length; ++a < b; ) {
          var C = Ms(f[a], h[a]);
          if (C) {
            if (a >= x)
              return C;
            var V = l[a];
            return C * (V == "desc" ? -1 : 1);
          }
        }
        return e.index - t.index;
      }
      function Fs(e, t, l, a) {
        for (var f = -1, h = e.length, b = l.length, x = -1, C = t.length, V = ot(h - b, 0), N = P(C + V), j = !a; ++x < C; )
          N[x] = t[x];
        for (; ++f < b; )
          (j || f < h) && (N[l[f]] = e[f]);
        for (; V--; )
          N[x++] = e[f++];
        return N;
      }
      function zs(e, t, l, a) {
        for (var f = -1, h = e.length, b = -1, x = l.length, C = -1, V = t.length, N = ot(h - x, 0), j = P(N + V), ee = !a; ++f < N; )
          j[f] = e[f];
        for (var ie = f; ++C < V; )
          j[ie + C] = t[C];
        for (; ++b < x; )
          (ee || f < h) && (j[ie + l[b]] = e[f++]);
        return j;
      }
      function At(e, t) {
        var l = -1, a = e.length;
        for (t || (t = P(a)); ++l < a; )
          t[l] = e[l];
        return t;
      }
      function dn(e, t, l, a) {
        var f = !l;
        l || (l = {});
        for (var h = -1, b = t.length; ++h < b; ) {
          var x = t[h], C = a ? a(l[x], e[x], x, l, e) : r;
          C === r && (C = e[x]), f ? _n(l, x, C) : qr(l, x, C);
        }
        return l;
      }
      function lp(e, t) {
        return dn(e, ba(e), t);
      }
      function ip(e, t) {
        return dn(e, Js(e), t);
      }
      function Wl(e, t) {
        return function(l, a) {
          var f = ye(l) ? cf : Cv, h = t ? t() : {};
          return f(l, e, he(a, 2), h);
        };
      }
      function br(e) {
        return Ie(function(t, l) {
          var a = -1, f = l.length, h = f > 1 ? l[f - 1] : r, b = f > 2 ? l[2] : r;
          for (h = e.length > 3 && typeof h == "function" ? (f--, h) : r, b && It(l[0], l[1], b) && (h = f < 3 ? r : h, f = 1), t = qe(t); ++a < f; ) {
            var x = l[a];
            x && e(t, x, a, h);
          }
          return t;
        });
      }
      function Us(e, t) {
        return function(l, a) {
          if (l == null)
            return l;
          if (!Lt(l))
            return e(l, a);
          for (var f = l.length, h = t ? f : -1, b = qe(l); (t ? h-- : ++h < f) && a(b[h], h, b) !== !1; )
            ;
          return l;
        };
      }
      function Ws(e) {
        return function(t, l, a) {
          for (var f = -1, h = qe(t), b = a(t), x = b.length; x--; ) {
            var C = b[e ? x : ++f];
            if (l(h[C], C, h) === !1)
              break;
          }
          return t;
        };
      }
      function ap(e, t, l) {
        var a = t & z, f = Kr(e);
        function h() {
          var b = this && this !== mt && this instanceof h ? f : e;
          return b.apply(a ? l : this, arguments);
        }
        return h;
      }
      function Hs(e) {
        return function(t) {
          t = Pe(t);
          var l = dr(t) ? ln(t) : r, a = l ? l[0] : t.charAt(0), f = l ? Mn(l, 1).join("") : t.slice(1);
          return a[e]() + f;
        };
      }
      function yr(e) {
        return function(t) {
          return Bi(Uu(zu(t).replace(Yd, "")), e, "");
        };
      }
      function Kr(e) {
        return function() {
          var t = arguments;
          switch (t.length) {
            case 0:
              return new e();
            case 1:
              return new e(t[0]);
            case 2:
              return new e(t[0], t[1]);
            case 3:
              return new e(t[0], t[1], t[2]);
            case 4:
              return new e(t[0], t[1], t[2], t[3]);
            case 5:
              return new e(t[0], t[1], t[2], t[3], t[4]);
            case 6:
              return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
            case 7:
              return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
          }
          var l = gr(e.prototype), a = e.apply(l, t);
          return et(a) ? a : l;
        };
      }
      function op(e, t, l) {
        var a = Kr(e);
        function f() {
          for (var h = arguments.length, b = P(h), x = h, C = _r(f); x--; )
            b[x] = arguments[x];
          var V = h < 3 && b[0] !== C && b[h - 1] !== C ? [] : Ln(b, C);
          if (h -= V.length, h < l)
            return js(
              e,
              t,
              Hl,
              f.placeholder,
              r,
              b,
              V,
              r,
              r,
              l - h
            );
          var N = this && this !== mt && this instanceof f ? a : e;
          return Ft(N, this, b);
        }
        return f;
      }
      function qs(e) {
        return function(t, l, a) {
          var f = qe(t);
          if (!Lt(t)) {
            var h = he(l, 3);
            t = ct(t), l = function(x) {
              return h(f[x], x, f);
            };
          }
          var b = e(t, l, a);
          return b > -1 ? f[h ? t[b] : b] : r;
        };
      }
      function Gs(e) {
        return xn(function(t) {
          var l = t.length, a = l, f = Kt.prototype.thru;
          for (e && t.reverse(); a--; ) {
            var h = t[a];
            if (typeof h != "function")
              throw new jt(s);
            if (f && !b && Nl(h) == "wrapper")
              var b = new Kt([], !0);
          }
          for (a = b ? a : l; ++a < l; ) {
            h = t[a];
            var x = Nl(h), C = x == "wrapper" ? ma(h) : r;
            C && _a(C[0]) && C[1] == (W | O | w | R) && !C[4].length && C[9] == 1 ? b = b[Nl(C[0])].apply(b, C[3]) : b = h.length == 1 && _a(h) ? b[x]() : b.thru(h);
          }
          return function() {
            var V = arguments, N = V[0];
            if (b && V.length == 1 && ye(N))
              return b.plant(N).value();
            for (var j = 0, ee = l ? t[j].apply(this, V) : N; ++j < l; )
              ee = t[j].call(this, ee);
            return ee;
          };
        });
      }
      function Hl(e, t, l, a, f, h, b, x, C, V) {
        var N = t & W, j = t & z, ee = t & Y, ie = t & (O | E), me = t & q, Te = ee ? r : Kr(e);
        function ge() {
          for (var $e = arguments.length, Ee = P($e), Ht = $e; Ht--; )
            Ee[Ht] = arguments[Ht];
          if (ie)
            var $t = _r(ge), qt = yf(Ee, $t);
          if (a && (Ee = Fs(Ee, a, f, ie)), h && (Ee = zs(Ee, h, b, ie)), $e -= qt, ie && $e < V) {
            var lt = Ln(Ee, $t);
            return js(
              e,
              t,
              Hl,
              ge.placeholder,
              l,
              Ee,
              lt,
              x,
              C,
              V - $e
            );
          }
          var sn = j ? l : this, $n = ee ? sn[e] : e;
          return $e = Ee.length, x ? Ee = Cp(Ee, x) : me && $e > 1 && Ee.reverse(), N && C < $e && (Ee.length = C), this && this !== mt && this instanceof ge && ($n = Te || Kr($n)), $n.apply(sn, Ee);
        }
        return ge;
      }
      function Vs(e, t) {
        return function(l, a) {
          return Pv(l, e, t(a), {});
        };
      }
      function ql(e, t) {
        return function(l, a) {
          var f;
          if (l === r && a === r)
            return t;
          if (l !== r && (f = l), a !== r) {
            if (f === r)
              return a;
            typeof l == "string" || typeof a == "string" ? (l = Ut(l), a = Ut(a)) : (l = Es(l), a = Es(a)), f = e(l, a);
          }
          return f;
        };
      }
      function fa(e) {
        return xn(function(t) {
          return t = Je(t, zt(he())), Ie(function(l) {
            var a = this;
            return e(t, function(f) {
              return Ft(f, a, l);
            });
          });
        });
      }
      function Gl(e, t) {
        t = t === r ? " " : Ut(t);
        var l = t.length;
        if (l < 2)
          return l ? ia(t, e) : t;
        var a = ia(t, El(e / fr(t)));
        return dr(t) ? Mn(ln(a), 0, e).join("") : a.slice(0, e);
      }
      function sp(e, t, l, a) {
        var f = t & z, h = Kr(e);
        function b() {
          for (var x = -1, C = arguments.length, V = -1, N = a.length, j = P(N + C), ee = this && this !== mt && this instanceof b ? h : e; ++V < N; )
            j[V] = a[V];
          for (; C--; )
            j[V++] = arguments[++x];
          return Ft(ee, f ? l : this, j);
        }
        return b;
      }
      function Ns(e) {
        return function(t, l, a) {
          return a && typeof a != "number" && It(t, l, a) && (l = a = r), t = In(t), l === r ? (l = t, t = 0) : l = In(l), a = a === r ? t < l ? 1 : -1 : In(a), jv(t, l, a, e);
        };
      }
      function Vl(e) {
        return function(t, l) {
          return typeof t == "string" && typeof l == "string" || (t = Jt(t), l = Jt(l)), e(t, l);
        };
      }
      function js(e, t, l, a, f, h, b, x, C, V) {
        var N = t & O, j = N ? b : r, ee = N ? r : b, ie = N ? h : r, me = N ? r : h;
        t |= N ? w : M, t &= ~(N ? M : w), t & D || (t &= ~(z | Y));
        var Te = [
          e,
          t,
          f,
          ie,
          j,
          me,
          ee,
          x,
          C,
          V
        ], ge = l.apply(r, Te);
        return _a(e) && iu(ge, Te), ge.placeholder = a, au(ge, e, t);
      }
      function va(e) {
        var t = at[e];
        return function(l, a) {
          if (l = Jt(l), a = a == null ? 0 : _t(xe(a), 292), a && as(l)) {
            var f = (Pe(l) + "e").split("e"), h = t(f[0] + "e" + (+f[1] + a));
            return f = (Pe(h) + "e").split("e"), +(f[0] + "e" + (+f[1] - a));
          }
          return t(l);
        };
      }
      var up = hr && 1 / _l(new hr([, -0]))[1] == fe ? function(e) {
        return new hr(e);
      } : Pa;
      function Ks(e) {
        return function(t) {
          var l = wt(t);
          return l == nn ? qi(t) : l == rn ? $f(t) : bf(t, e(t));
        };
      }
      function wn(e, t, l, a, f, h, b, x) {
        var C = t & Y;
        if (!C && typeof e != "function")
          throw new jt(s);
        var V = a ? a.length : 0;
        if (V || (t &= ~(w | M), a = f = r), b = b === r ? b : ot(xe(b), 0), x = x === r ? x : xe(x), V -= f ? f.length : 0, t & M) {
          var N = a, j = f;
          a = f = r;
        }
        var ee = C ? r : ma(e), ie = [
          e,
          t,
          l,
          a,
          f,
          N,
          j,
          h,
          b,
          x
        ];
        if (ee && Tp(ie, ee), e = ie[0], t = ie[1], l = ie[2], a = ie[3], f = ie[4], x = ie[9] = ie[9] === r ? C ? 0 : e.length : ot(ie[9] - V, 0), !x && t & (O | E) && (t &= ~(O | E)), !t || t == z)
          var me = ap(e, t, l);
        else
          t == O || t == E ? me = op(e, t, x) : (t == w || t == (z | w)) && !f.length ? me = sp(e, t, l, a) : me = Hl.apply(r, ie);
        var Te = ee ? ks : iu;
        return au(Te(me, ie), e, t);
      }
      function Ys(e, t, l, a) {
        return e === r || on(e, pr[l]) && !Me.call(a, l) ? t : e;
      }
      function Zs(e, t, l, a, f, h) {
        return et(e) && et(t) && (h.set(t, e), Fl(e, t, r, Zs, h), h.delete(t)), e;
      }
      function cp(e) {
        return Xr(e) ? r : e;
      }
      function Xs(e, t, l, a, f, h) {
        var b = l & A, x = e.length, C = t.length;
        if (x != C && !(b && C > x))
          return !1;
        var V = h.get(e), N = h.get(t);
        if (V && N)
          return V == t && N == e;
        var j = -1, ee = !0, ie = l & L ? new Nn() : r;
        for (h.set(e, t), h.set(t, e); ++j < x; ) {
          var me = e[j], Te = t[j];
          if (a)
            var ge = b ? a(Te, me, j, t, e, h) : a(me, Te, j, e, t, h);
          if (ge !== r) {
            if (ge)
              continue;
            ee = !1;
            break;
          }
          if (ie) {
            if (!Mi(t, function($e, Ee) {
              if (!Mr(ie, Ee) && (me === $e || f(me, $e, l, a, h)))
                return ie.push(Ee);
            })) {
              ee = !1;
              break;
            }
          } else if (!(me === Te || f(me, Te, l, a, h))) {
            ee = !1;
            break;
          }
        }
        return h.delete(e), h.delete(t), ee;
      }
      function dp(e, t, l, a, f, h, b) {
        switch (l) {
          case sr:
            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
              return !1;
            e = e.buffer, t = t.buffer;
          case Br:
            return !(e.byteLength != t.byteLength || !h(new $l(e), new $l(t)));
          case Er:
          case Ar:
          case Lr:
            return on(+e, +t);
          case fl:
            return e.name == t.name && e.message == t.message;
          case Rr:
          case Dr:
            return e == t + "";
          case nn:
            var x = qi;
          case rn:
            var C = a & A;
            if (x || (x = _l), e.size != t.size && !C)
              return !1;
            var V = b.get(e);
            if (V)
              return V == t;
            a |= L, b.set(e, t);
            var N = Xs(x(e), x(t), a, f, h, b);
            return b.delete(e), N;
          case pl:
            if (Hr)
              return Hr.call(e) == Hr.call(t);
        }
        return !1;
      }
      function fp(e, t, l, a, f, h) {
        var b = l & A, x = pa(e), C = x.length, V = pa(t), N = V.length;
        if (C != N && !b)
          return !1;
        for (var j = C; j--; ) {
          var ee = x[j];
          if (!(b ? ee in t : Me.call(t, ee)))
            return !1;
        }
        var ie = h.get(e), me = h.get(t);
        if (ie && me)
          return ie == t && me == e;
        var Te = !0;
        h.set(e, t), h.set(t, e);
        for (var ge = b; ++j < C; ) {
          ee = x[j];
          var $e = e[ee], Ee = t[ee];
          if (a)
            var Ht = b ? a(Ee, $e, ee, t, e, h) : a($e, Ee, ee, e, t, h);
          if (!(Ht === r ? $e === Ee || f($e, Ee, l, a, h) : Ht)) {
            Te = !1;
            break;
          }
          ge || (ge = ee == "constructor");
        }
        if (Te && !ge) {
          var $t = e.constructor, qt = t.constructor;
          $t != qt && "constructor" in e && "constructor" in t && !(typeof $t == "function" && $t instanceof $t && typeof qt == "function" && qt instanceof qt) && (Te = !1);
        }
        return h.delete(e), h.delete(t), Te;
      }
      function xn(e) {
        return xa(ru(e, r, fu), e + "");
      }
      function pa(e) {
        return gs(e, ct, ba);
      }
      function ha(e) {
        return gs(e, Rt, Js);
      }
      var ma = Ll ? function(e) {
        return Ll.get(e);
      } : Pa;
      function Nl(e) {
        for (var t = e.name + "", l = mr[t], a = Me.call(mr, t) ? l.length : 0; a--; ) {
          var f = l[a], h = f.func;
          if (h == null || h == e)
            return f.name;
        }
        return t;
      }
      function _r(e) {
        var t = Me.call(p, "placeholder") ? p : e;
        return t.placeholder;
      }
      function he() {
        var e = p.iteratee || Ra;
        return e = e === Ra ? _s : e, arguments.length ? e(arguments[0], arguments[1]) : e;
      }
      function jl(e, t) {
        var l = e.__data__;
        return _p(t) ? l[typeof t == "string" ? "string" : "hash"] : l.map;
      }
      function ga(e) {
        for (var t = ct(e), l = t.length; l--; ) {
          var a = t[l], f = e[a];
          t[l] = [a, f, tu(f)];
        }
        return t;
      }
      function Yn(e, t) {
        var l = Sf(e, t);
        return ys(l) ? l : r;
      }
      function vp(e) {
        var t = Me.call(e, Gn), l = e[Gn];
        try {
          e[Gn] = r;
          var a = !0;
        } catch {
        }
        var f = Tl.call(e);
        return a && (t ? e[Gn] = l : delete e[Gn]), f;
      }
      var ba = Vi ? function(e) {
        return e == null ? [] : (e = qe(e), En(Vi(e), function(t) {
          return ls.call(e, t);
        }));
      } : Ba, Js = Vi ? function(e) {
        for (var t = []; e; )
          An(t, ba(e)), e = Cl(e);
        return t;
      } : Ba, wt = Tt;
      (Ni && wt(new Ni(new ArrayBuffer(1))) != sr || zr && wt(new zr()) != nn || ji && wt(ji.resolve()) != po || hr && wt(new hr()) != rn || Ur && wt(new Ur()) != Pr) && (wt = function(e) {
        var t = Tt(e), l = t == gn ? e.constructor : r, a = l ? Zn(l) : "";
        if (a)
          switch (a) {
            case Yf:
              return sr;
            case Zf:
              return nn;
            case Xf:
              return po;
            case Jf:
              return rn;
            case Qf:
              return Pr;
          }
        return t;
      });
      function pp(e, t, l) {
        for (var a = -1, f = l.length; ++a < f; ) {
          var h = l[a], b = h.size;
          switch (h.type) {
            case "drop":
              e += b;
              break;
            case "dropRight":
              t -= b;
              break;
            case "take":
              t = _t(t, e + b);
              break;
            case "takeRight":
              e = ot(e, t - b);
              break;
          }
        }
        return { start: e, end: t };
      }
      function hp(e) {
        var t = e.match(_d);
        return t ? t[1].split(wd) : [];
      }
      function Qs(e, t, l) {
        t = Bn(t, e);
        for (var a = -1, f = t.length, h = !1; ++a < f; ) {
          var b = fn(t[a]);
          if (!(h = e != null && l(e, b)))
            break;
          e = e[b];
        }
        return h || ++a != f ? h : (f = e == null ? 0 : e.length, !!f && ei(f) && Sn(b, f) && (ye(e) || Xn(e)));
      }
      function mp(e) {
        var t = e.length, l = new e.constructor(t);
        return t && typeof e[0] == "string" && Me.call(e, "index") && (l.index = e.index, l.input = e.input), l;
      }
      function eu(e) {
        return typeof e.constructor == "function" && !Yr(e) ? gr(Cl(e)) : {};
      }
      function gp(e, t, l) {
        var a = e.constructor;
        switch (t) {
          case Br:
            return da(e);
          case Er:
          case Ar:
            return new a(+e);
          case sr:
            return ep(e, l);
          case gi:
          case bi:
          case yi:
          case _i:
          case wi:
          case xi:
          case Si:
          case Ti:
          case Ii:
            return Bs(e, l);
          case nn:
            return new a();
          case Lr:
          case Dr:
            return new a(e);
          case Rr:
            return tp(e);
          case rn:
            return new a();
          case pl:
            return np(e);
        }
      }
      function bp(e, t) {
        var l = t.length;
        if (!l)
          return e;
        var a = l - 1;
        return t[a] = (l > 1 ? "& " : "") + t[a], t = t.join(l > 2 ? ", " : " "), e.replace(yd, `{
/* [wrapped with ` + t + `] */
`);
      }
      function yp(e) {
        return ye(e) || Xn(e) || !!(is && e && e[is]);
      }
      function Sn(e, t) {
        var l = typeof e;
        return t = t ?? ke, !!t && (l == "number" || l != "symbol" && Ed.test(e)) && e > -1 && e % 1 == 0 && e < t;
      }
      function It(e, t, l) {
        if (!et(l))
          return !1;
        var a = typeof t;
        return (a == "number" ? Lt(l) && Sn(t, l.length) : a == "string" && t in l) ? on(l[t], e) : !1;
      }
      function ya(e, t) {
        if (ye(e))
          return !1;
        var l = typeof e;
        return l == "number" || l == "symbol" || l == "boolean" || e == null || Wt(e) ? !0 : hd.test(e) || !pd.test(e) || t != null && e in qe(t);
      }
      function _p(e) {
        var t = typeof e;
        return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
      }
      function _a(e) {
        var t = Nl(e), l = p[t];
        if (typeof l != "function" || !(t in Oe.prototype))
          return !1;
        if (e === l)
          return !0;
        var a = ma(l);
        return !!a && e === a[0];
      }
      function wp(e) {
        return !!ts && ts in e;
      }
      var xp = xl ? Tn : Ma;
      function Yr(e) {
        var t = e && e.constructor, l = typeof t == "function" && t.prototype || pr;
        return e === l;
      }
      function tu(e) {
        return e === e && !et(e);
      }
      function nu(e, t) {
        return function(l) {
          return l == null ? !1 : l[e] === t && (t !== r || e in qe(l));
        };
      }
      function Sp(e) {
        var t = Jl(e, function(a) {
          return l.size === y && l.clear(), a;
        }), l = t.cache;
        return t;
      }
      function Tp(e, t) {
        var l = e[1], a = t[1], f = l | a, h = f < (z | Y | W), b = a == W && l == O || a == W && l == R && e[7].length <= t[8] || a == (W | R) && t[7].length <= t[8] && l == O;
        if (!(h || b))
          return e;
        a & z && (e[2] = t[2], f |= l & z ? 0 : D);
        var x = t[3];
        if (x) {
          var C = e[3];
          e[3] = C ? Fs(C, x, t[4]) : x, e[4] = C ? Ln(e[3], _) : t[4];
        }
        return x = t[5], x && (C = e[5], e[5] = C ? zs(C, x, t[6]) : x, e[6] = C ? Ln(e[5], _) : t[6]), x = t[7], x && (e[7] = x), a & W && (e[8] = e[8] == null ? t[8] : _t(e[8], t[8])), e[9] == null && (e[9] = t[9]), e[0] = t[0], e[1] = f, e;
      }
      function Ip(e) {
        var t = [];
        if (e != null)
          for (var l in qe(e))
            t.push(l);
        return t;
      }
      function $p(e) {
        return Tl.call(e);
      }
      function ru(e, t, l) {
        return t = ot(t === r ? e.length - 1 : t, 0), function() {
          for (var a = arguments, f = -1, h = ot(a.length - t, 0), b = P(h); ++f < h; )
            b[f] = a[t + f];
          f = -1;
          for (var x = P(t + 1); ++f < t; )
            x[f] = a[f];
          return x[t] = l(b), Ft(e, this, x);
        };
      }
      function lu(e, t) {
        return t.length < 2 ? e : Kn(e, Zt(t, 0, -1));
      }
      function Cp(e, t) {
        for (var l = e.length, a = _t(t.length, l), f = At(e); a--; ) {
          var h = t[a];
          e[a] = Sn(h, l) ? f[h] : r;
        }
        return e;
      }
      function wa(e, t) {
        if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
          return e[t];
      }
      var iu = ou(ks), Zr = Hf || function(e, t) {
        return mt.setTimeout(e, t);
      }, xa = ou(Zv);
      function au(e, t, l) {
        var a = t + "";
        return xa(e, bp(a, kp(hp(a), l)));
      }
      function ou(e) {
        var t = 0, l = 0;
        return function() {
          var a = Nf(), f = pe - (a - l);
          if (l = a, f > 0) {
            if (++t >= ve)
              return arguments[0];
          } else
            t = 0;
          return e.apply(r, arguments);
        };
      }
      function Kl(e, t) {
        var l = -1, a = e.length, f = a - 1;
        for (t = t === r ? a : t; ++l < t; ) {
          var h = la(l, f), b = e[h];
          e[h] = e[l], e[l] = b;
        }
        return e.length = t, e;
      }
      var su = Sp(function(e) {
        var t = [];
        return e.charCodeAt(0) === 46 && t.push(""), e.replace(md, function(l, a, f, h) {
          t.push(f ? h.replace(Td, "$1") : a || l);
        }), t;
      });
      function fn(e) {
        if (typeof e == "string" || Wt(e))
          return e;
        var t = e + "";
        return t == "0" && 1 / e == -fe ? "-0" : t;
      }
      function Zn(e) {
        if (e != null) {
          try {
            return Sl.call(e);
          } catch {
          }
          try {
            return e + "";
          } catch {
          }
        }
        return "";
      }
      function kp(e, t) {
        return Nt(Et, function(l) {
          var a = "_." + l[0];
          t & l[1] && !bl(e, a) && e.push(a);
        }), e.sort();
      }
      function uu(e) {
        if (e instanceof Oe)
          return e.clone();
        var t = new Kt(e.__wrapped__, e.__chain__);
        return t.__actions__ = At(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
      }
      function Op(e, t, l) {
        (l ? It(e, t, l) : t === r) ? t = 1 : t = ot(xe(t), 0);
        var a = e == null ? 0 : e.length;
        if (!a || t < 1)
          return [];
        for (var f = 0, h = 0, b = P(El(a / t)); f < a; )
          b[h++] = Zt(e, f, f += t);
        return b;
      }
      function Ep(e) {
        for (var t = -1, l = e == null ? 0 : e.length, a = 0, f = []; ++t < l; ) {
          var h = e[t];
          h && (f[a++] = h);
        }
        return f;
      }
      function Ap() {
        var e = arguments.length;
        if (!e)
          return [];
        for (var t = P(e - 1), l = arguments[0], a = e; a--; )
          t[a - 1] = arguments[a];
        return An(ye(l) ? At(l) : [l], gt(t, 1));
      }
      var Lp = Ie(function(e, t) {
        return rt(e) ? Gr(e, gt(t, 1, rt, !0)) : [];
      }), Rp = Ie(function(e, t) {
        var l = Xt(t);
        return rt(l) && (l = r), rt(e) ? Gr(e, gt(t, 1, rt, !0), he(l, 2)) : [];
      }), Dp = Ie(function(e, t) {
        var l = Xt(t);
        return rt(l) && (l = r), rt(e) ? Gr(e, gt(t, 1, rt, !0), r, l) : [];
      });
      function Pp(e, t, l) {
        var a = e == null ? 0 : e.length;
        return a ? (t = l || t === r ? 1 : xe(t), Zt(e, t < 0 ? 0 : t, a)) : [];
      }
      function Bp(e, t, l) {
        var a = e == null ? 0 : e.length;
        return a ? (t = l || t === r ? 1 : xe(t), t = a - t, Zt(e, 0, t < 0 ? 0 : t)) : [];
      }
      function Mp(e, t) {
        return e && e.length ? Ul(e, he(t, 3), !0, !0) : [];
      }
      function Fp(e, t) {
        return e && e.length ? Ul(e, he(t, 3), !0) : [];
      }
      function zp(e, t, l, a) {
        var f = e == null ? 0 : e.length;
        return f ? (l && typeof l != "number" && It(e, t, l) && (l = 0, a = f), Av(e, t, l, a)) : [];
      }
      function cu(e, t, l) {
        var a = e == null ? 0 : e.length;
        if (!a)
          return -1;
        var f = l == null ? 0 : xe(l);
        return f < 0 && (f = ot(a + f, 0)), yl(e, he(t, 3), f);
      }
      function du(e, t, l) {
        var a = e == null ? 0 : e.length;
        if (!a)
          return -1;
        var f = a - 1;
        return l !== r && (f = xe(l), f = l < 0 ? ot(a + f, 0) : _t(f, a - 1)), yl(e, he(t, 3), f, !0);
      }
      function fu(e) {
        var t = e == null ? 0 : e.length;
        return t ? gt(e, 1) : [];
      }
      function Up(e) {
        var t = e == null ? 0 : e.length;
        return t ? gt(e, fe) : [];
      }
      function Wp(e, t) {
        var l = e == null ? 0 : e.length;
        return l ? (t = t === r ? 1 : xe(t), gt(e, t)) : [];
      }
      function Hp(e) {
        for (var t = -1, l = e == null ? 0 : e.length, a = {}; ++t < l; ) {
          var f = e[t];
          a[f[0]] = f[1];
        }
        return a;
      }
      function vu(e) {
        return e && e.length ? e[0] : r;
      }
      function qp(e, t, l) {
        var a = e == null ? 0 : e.length;
        if (!a)
          return -1;
        var f = l == null ? 0 : xe(l);
        return f < 0 && (f = ot(a + f, 0)), cr(e, t, f);
      }
      function Gp(e) {
        var t = e == null ? 0 : e.length;
        return t ? Zt(e, 0, -1) : [];
      }
      var Vp = Ie(function(e) {
        var t = Je(e, ua);
        return t.length && t[0] === e[0] ? Qi(t) : [];
      }), Np = Ie(function(e) {
        var t = Xt(e), l = Je(e, ua);
        return t === Xt(l) ? t = r : l.pop(), l.length && l[0] === e[0] ? Qi(l, he(t, 2)) : [];
      }), jp = Ie(function(e) {
        var t = Xt(e), l = Je(e, ua);
        return t = typeof t == "function" ? t : r, t && l.pop(), l.length && l[0] === e[0] ? Qi(l, r, t) : [];
      });
      function Kp(e, t) {
        return e == null ? "" : Gf.call(e, t);
      }
      function Xt(e) {
        var t = e == null ? 0 : e.length;
        return t ? e[t - 1] : r;
      }
      function Yp(e, t, l) {
        var a = e == null ? 0 : e.length;
        if (!a)
          return -1;
        var f = a;
        return l !== r && (f = xe(l), f = f < 0 ? ot(a + f, 0) : _t(f, a - 1)), t === t ? kf(e, t, f) : yl(e, jo, f, !0);
      }
      function Zp(e, t) {
        return e && e.length ? Ts(e, xe(t)) : r;
      }
      var Xp = Ie(pu);
      function pu(e, t) {
        return e && e.length && t && t.length ? ra(e, t) : e;
      }
      function Jp(e, t, l) {
        return e && e.length && t && t.length ? ra(e, t, he(l, 2)) : e;
      }
      function Qp(e, t, l) {
        return e && e.length && t && t.length ? ra(e, t, r, l) : e;
      }
      var eh = xn(function(e, t) {
        var l = e == null ? 0 : e.length, a = Yi(e, t);
        return Cs(e, Je(t, function(f) {
          return Sn(f, l) ? +f : f;
        }).sort(Ms)), a;
      });
      function th(e, t) {
        var l = [];
        if (!(e && e.length))
          return l;
        var a = -1, f = [], h = e.length;
        for (t = he(t, 3); ++a < h; ) {
          var b = e[a];
          t(b, a, e) && (l.push(b), f.push(a));
        }
        return Cs(e, f), l;
      }
      function Sa(e) {
        return e == null ? e : Kf.call(e);
      }
      function nh(e, t, l) {
        var a = e == null ? 0 : e.length;
        return a ? (l && typeof l != "number" && It(e, t, l) ? (t = 0, l = a) : (t = t == null ? 0 : xe(t), l = l === r ? a : xe(l)), Zt(e, t, l)) : [];
      }
      function rh(e, t) {
        return zl(e, t);
      }
      function lh(e, t, l) {
        return aa(e, t, he(l, 2));
      }
      function ih(e, t) {
        var l = e == null ? 0 : e.length;
        if (l) {
          var a = zl(e, t);
          if (a < l && on(e[a], t))
            return a;
        }
        return -1;
      }
      function ah(e, t) {
        return zl(e, t, !0);
      }
      function oh(e, t, l) {
        return aa(e, t, he(l, 2), !0);
      }
      function sh(e, t) {
        var l = e == null ? 0 : e.length;
        if (l) {
          var a = zl(e, t, !0) - 1;
          if (on(e[a], t))
            return a;
        }
        return -1;
      }
      function uh(e) {
        return e && e.length ? Os(e) : [];
      }
      function ch(e, t) {
        return e && e.length ? Os(e, he(t, 2)) : [];
      }
      function dh(e) {
        var t = e == null ? 0 : e.length;
        return t ? Zt(e, 1, t) : [];
      }
      function fh(e, t, l) {
        return e && e.length ? (t = l || t === r ? 1 : xe(t), Zt(e, 0, t < 0 ? 0 : t)) : [];
      }
      function vh(e, t, l) {
        var a = e == null ? 0 : e.length;
        return a ? (t = l || t === r ? 1 : xe(t), t = a - t, Zt(e, t < 0 ? 0 : t, a)) : [];
      }
      function ph(e, t) {
        return e && e.length ? Ul(e, he(t, 3), !1, !0) : [];
      }
      function hh(e, t) {
        return e && e.length ? Ul(e, he(t, 3)) : [];
      }
      var mh = Ie(function(e) {
        return Pn(gt(e, 1, rt, !0));
      }), gh = Ie(function(e) {
        var t = Xt(e);
        return rt(t) && (t = r), Pn(gt(e, 1, rt, !0), he(t, 2));
      }), bh = Ie(function(e) {
        var t = Xt(e);
        return t = typeof t == "function" ? t : r, Pn(gt(e, 1, rt, !0), r, t);
      });
      function yh(e) {
        return e && e.length ? Pn(e) : [];
      }
      function _h(e, t) {
        return e && e.length ? Pn(e, he(t, 2)) : [];
      }
      function wh(e, t) {
        return t = typeof t == "function" ? t : r, e && e.length ? Pn(e, r, t) : [];
      }
      function Ta(e) {
        if (!(e && e.length))
          return [];
        var t = 0;
        return e = En(e, function(l) {
          if (rt(l))
            return t = ot(l.length, t), !0;
        }), Wi(t, function(l) {
          return Je(e, Fi(l));
        });
      }
      function hu(e, t) {
        if (!(e && e.length))
          return [];
        var l = Ta(e);
        return t == null ? l : Je(l, function(a) {
          return Ft(t, r, a);
        });
      }
      var xh = Ie(function(e, t) {
        return rt(e) ? Gr(e, t) : [];
      }), Sh = Ie(function(e) {
        return sa(En(e, rt));
      }), Th = Ie(function(e) {
        var t = Xt(e);
        return rt(t) && (t = r), sa(En(e, rt), he(t, 2));
      }), Ih = Ie(function(e) {
        var t = Xt(e);
        return t = typeof t == "function" ? t : r, sa(En(e, rt), r, t);
      }), $h = Ie(Ta);
      function Ch(e, t) {
        return Rs(e || [], t || [], qr);
      }
      function kh(e, t) {
        return Rs(e || [], t || [], jr);
      }
      var Oh = Ie(function(e) {
        var t = e.length, l = t > 1 ? e[t - 1] : r;
        return l = typeof l == "function" ? (e.pop(), l) : r, hu(e, l);
      });
      function mu(e) {
        var t = p(e);
        return t.__chain__ = !0, t;
      }
      function Eh(e, t) {
        return t(e), e;
      }
      function Yl(e, t) {
        return t(e);
      }
      var Ah = xn(function(e) {
        var t = e.length, l = t ? e[0] : 0, a = this.__wrapped__, f = function(h) {
          return Yi(h, e);
        };
        return t > 1 || this.__actions__.length || !(a instanceof Oe) || !Sn(l) ? this.thru(f) : (a = a.slice(l, +l + (t ? 1 : 0)), a.__actions__.push({
          func: Yl,
          args: [f],
          thisArg: r
        }), new Kt(a, this.__chain__).thru(function(h) {
          return t && !h.length && h.push(r), h;
        }));
      });
      function Lh() {
        return mu(this);
      }
      function Rh() {
        return new Kt(this.value(), this.__chain__);
      }
      function Dh() {
        this.__values__ === r && (this.__values__ = Eu(this.value()));
        var e = this.__index__ >= this.__values__.length, t = e ? r : this.__values__[this.__index__++];
        return { done: e, value: t };
      }
      function Ph() {
        return this;
      }
      function Bh(e) {
        for (var t, l = this; l instanceof Dl; ) {
          var a = uu(l);
          a.__index__ = 0, a.__values__ = r, t ? f.__wrapped__ = a : t = a;
          var f = a;
          l = l.__wrapped__;
        }
        return f.__wrapped__ = e, t;
      }
      function Mh() {
        var e = this.__wrapped__;
        if (e instanceof Oe) {
          var t = e;
          return this.__actions__.length && (t = new Oe(this)), t = t.reverse(), t.__actions__.push({
            func: Yl,
            args: [Sa],
            thisArg: r
          }), new Kt(t, this.__chain__);
        }
        return this.thru(Sa);
      }
      function Fh() {
        return Ls(this.__wrapped__, this.__actions__);
      }
      var zh = Wl(function(e, t, l) {
        Me.call(e, l) ? ++e[l] : _n(e, l, 1);
      });
      function Uh(e, t, l) {
        var a = ye(e) ? Vo : Ev;
        return l && It(e, t, l) && (t = r), a(e, he(t, 3));
      }
      function Wh(e, t) {
        var l = ye(e) ? En : hs;
        return l(e, he(t, 3));
      }
      var Hh = qs(cu), qh = qs(du);
      function Gh(e, t) {
        return gt(Zl(e, t), 1);
      }
      function Vh(e, t) {
        return gt(Zl(e, t), fe);
      }
      function Nh(e, t, l) {
        return l = l === r ? 1 : xe(l), gt(Zl(e, t), l);
      }
      function gu(e, t) {
        var l = ye(e) ? Nt : Dn;
        return l(e, he(t, 3));
      }
      function bu(e, t) {
        var l = ye(e) ? df : ps;
        return l(e, he(t, 3));
      }
      var jh = Wl(function(e, t, l) {
        Me.call(e, l) ? e[l].push(t) : _n(e, l, [t]);
      });
      function Kh(e, t, l, a) {
        e = Lt(e) ? e : xr(e), l = l && !a ? xe(l) : 0;
        var f = e.length;
        return l < 0 && (l = ot(f + l, 0)), ti(e) ? l <= f && e.indexOf(t, l) > -1 : !!f && cr(e, t, l) > -1;
      }
      var Yh = Ie(function(e, t, l) {
        var a = -1, f = typeof t == "function", h = Lt(e) ? P(e.length) : [];
        return Dn(e, function(b) {
          h[++a] = f ? Ft(t, b, l) : Vr(b, t, l);
        }), h;
      }), Zh = Wl(function(e, t, l) {
        _n(e, l, t);
      });
      function Zl(e, t) {
        var l = ye(e) ? Je : ws;
        return l(e, he(t, 3));
      }
      function Xh(e, t, l, a) {
        return e == null ? [] : (ye(t) || (t = t == null ? [] : [t]), l = a ? r : l, ye(l) || (l = l == null ? [] : [l]), Is(e, t, l));
      }
      var Jh = Wl(function(e, t, l) {
        e[l ? 0 : 1].push(t);
      }, function() {
        return [[], []];
      });
      function Qh(e, t, l) {
        var a = ye(e) ? Bi : Yo, f = arguments.length < 3;
        return a(e, he(t, 4), l, f, Dn);
      }
      function em(e, t, l) {
        var a = ye(e) ? ff : Yo, f = arguments.length < 3;
        return a(e, he(t, 4), l, f, ps);
      }
      function tm(e, t) {
        var l = ye(e) ? En : hs;
        return l(e, Ql(he(t, 3)));
      }
      function nm(e) {
        var t = ye(e) ? cs : Kv;
        return t(e);
      }
      function rm(e, t, l) {
        (l ? It(e, t, l) : t === r) ? t = 1 : t = xe(t);
        var a = ye(e) ? Iv : Yv;
        return a(e, t);
      }
      function lm(e) {
        var t = ye(e) ? $v : Xv;
        return t(e);
      }
      function im(e) {
        if (e == null)
          return 0;
        if (Lt(e))
          return ti(e) ? fr(e) : e.length;
        var t = wt(e);
        return t == nn || t == rn ? e.size : ta(e).length;
      }
      function am(e, t, l) {
        var a = ye(e) ? Mi : Jv;
        return l && It(e, t, l) && (t = r), a(e, he(t, 3));
      }
      var om = Ie(function(e, t) {
        if (e == null)
          return [];
        var l = t.length;
        return l > 1 && It(e, t[0], t[1]) ? t = [] : l > 2 && It(t[0], t[1], t[2]) && (t = [t[0]]), Is(e, gt(t, 1), []);
      }), Xl = Wf || function() {
        return mt.Date.now();
      };
      function sm(e, t) {
        if (typeof t != "function")
          throw new jt(s);
        return e = xe(e), function() {
          if (--e < 1)
            return t.apply(this, arguments);
        };
      }
      function yu(e, t, l) {
        return t = l ? r : t, t = e && t == null ? e.length : t, wn(e, W, r, r, r, r, t);
      }
      function _u(e, t) {
        var l;
        if (typeof t != "function")
          throw new jt(s);
        return e = xe(e), function() {
          return --e > 0 && (l = t.apply(this, arguments)), e <= 1 && (t = r), l;
        };
      }
      var Ia = Ie(function(e, t, l) {
        var a = z;
        if (l.length) {
          var f = Ln(l, _r(Ia));
          a |= w;
        }
        return wn(e, a, t, l, f);
      }), wu = Ie(function(e, t, l) {
        var a = z | Y;
        if (l.length) {
          var f = Ln(l, _r(wu));
          a |= w;
        }
        return wn(t, a, e, l, f);
      });
      function xu(e, t, l) {
        t = l ? r : t;
        var a = wn(e, O, r, r, r, r, r, t);
        return a.placeholder = xu.placeholder, a;
      }
      function Su(e, t, l) {
        t = l ? r : t;
        var a = wn(e, E, r, r, r, r, r, t);
        return a.placeholder = Su.placeholder, a;
      }
      function Tu(e, t, l) {
        var a, f, h, b, x, C, V = 0, N = !1, j = !1, ee = !0;
        if (typeof e != "function")
          throw new jt(s);
        t = Jt(t) || 0, et(l) && (N = !!l.leading, j = "maxWait" in l, h = j ? ot(Jt(l.maxWait) || 0, t) : h, ee = "trailing" in l ? !!l.trailing : ee);
        function ie(lt) {
          var sn = a, $n = f;
          return a = f = r, V = lt, b = e.apply($n, sn), b;
        }
        function me(lt) {
          return V = lt, x = Zr($e, t), N ? ie(lt) : b;
        }
        function Te(lt) {
          var sn = lt - C, $n = lt - V, qu = t - sn;
          return j ? _t(qu, h - $n) : qu;
        }
        function ge(lt) {
          var sn = lt - C, $n = lt - V;
          return C === r || sn >= t || sn < 0 || j && $n >= h;
        }
        function $e() {
          var lt = Xl();
          if (ge(lt))
            return Ee(lt);
          x = Zr($e, Te(lt));
        }
        function Ee(lt) {
          return x = r, ee && a ? ie(lt) : (a = f = r, b);
        }
        function Ht() {
          x !== r && Ds(x), V = 0, a = C = f = x = r;
        }
        function $t() {
          return x === r ? b : Ee(Xl());
        }
        function qt() {
          var lt = Xl(), sn = ge(lt);
          if (a = arguments, f = this, C = lt, sn) {
            if (x === r)
              return me(C);
            if (j)
              return Ds(x), x = Zr($e, t), ie(C);
          }
          return x === r && (x = Zr($e, t)), b;
        }
        return qt.cancel = Ht, qt.flush = $t, qt;
      }
      var um = Ie(function(e, t) {
        return vs(e, 1, t);
      }), cm = Ie(function(e, t, l) {
        return vs(e, Jt(t) || 0, l);
      });
      function dm(e) {
        return wn(e, q);
      }
      function Jl(e, t) {
        if (typeof e != "function" || t != null && typeof t != "function")
          throw new jt(s);
        var l = function() {
          var a = arguments, f = t ? t.apply(this, a) : a[0], h = l.cache;
          if (h.has(f))
            return h.get(f);
          var b = e.apply(this, a);
          return l.cache = h.set(f, b) || h, b;
        };
        return l.cache = new (Jl.Cache || yn)(), l;
      }
      Jl.Cache = yn;
      function Ql(e) {
        if (typeof e != "function")
          throw new jt(s);
        return function() {
          var t = arguments;
          switch (t.length) {
            case 0:
              return !e.call(this);
            case 1:
              return !e.call(this, t[0]);
            case 2:
              return !e.call(this, t[0], t[1]);
            case 3:
              return !e.call(this, t[0], t[1], t[2]);
          }
          return !e.apply(this, t);
        };
      }
      function fm(e) {
        return _u(2, e);
      }
      var vm = Qv(function(e, t) {
        t = t.length == 1 && ye(t[0]) ? Je(t[0], zt(he())) : Je(gt(t, 1), zt(he()));
        var l = t.length;
        return Ie(function(a) {
          for (var f = -1, h = _t(a.length, l); ++f < h; )
            a[f] = t[f].call(this, a[f]);
          return Ft(e, this, a);
        });
      }), $a = Ie(function(e, t) {
        var l = Ln(t, _r($a));
        return wn(e, w, r, t, l);
      }), Iu = Ie(function(e, t) {
        var l = Ln(t, _r(Iu));
        return wn(e, M, r, t, l);
      }), pm = xn(function(e, t) {
        return wn(e, R, r, r, r, t);
      });
      function hm(e, t) {
        if (typeof e != "function")
          throw new jt(s);
        return t = t === r ? t : xe(t), Ie(e, t);
      }
      function mm(e, t) {
        if (typeof e != "function")
          throw new jt(s);
        return t = t == null ? 0 : ot(xe(t), 0), Ie(function(l) {
          var a = l[t], f = Mn(l, 0, t);
          return a && An(f, a), Ft(e, this, f);
        });
      }
      function gm(e, t, l) {
        var a = !0, f = !0;
        if (typeof e != "function")
          throw new jt(s);
        return et(l) && (a = "leading" in l ? !!l.leading : a, f = "trailing" in l ? !!l.trailing : f), Tu(e, t, {
          leading: a,
          maxWait: t,
          trailing: f
        });
      }
      function bm(e) {
        return yu(e, 1);
      }
      function ym(e, t) {
        return $a(ca(t), e);
      }
      function _m() {
        if (!arguments.length)
          return [];
        var e = arguments[0];
        return ye(e) ? e : [e];
      }
      function wm(e) {
        return Yt(e, k);
      }
      function xm(e, t) {
        return t = typeof t == "function" ? t : r, Yt(e, k, t);
      }
      function Sm(e) {
        return Yt(e, m | k);
      }
      function Tm(e, t) {
        return t = typeof t == "function" ? t : r, Yt(e, m | k, t);
      }
      function Im(e, t) {
        return t == null || fs(e, t, ct(t));
      }
      function on(e, t) {
        return e === t || e !== e && t !== t;
      }
      var $m = Vl(Ji), Cm = Vl(function(e, t) {
        return e >= t;
      }), Xn = bs(/* @__PURE__ */ function() {
        return arguments;
      }()) ? bs : function(e) {
        return nt(e) && Me.call(e, "callee") && !ls.call(e, "callee");
      }, ye = P.isArray, km = zo ? zt(zo) : Bv;
      function Lt(e) {
        return e != null && ei(e.length) && !Tn(e);
      }
      function rt(e) {
        return nt(e) && Lt(e);
      }
      function Om(e) {
        return e === !0 || e === !1 || nt(e) && Tt(e) == Er;
      }
      var Fn = qf || Ma, Em = Uo ? zt(Uo) : Mv;
      function Am(e) {
        return nt(e) && e.nodeType === 1 && !Xr(e);
      }
      function Lm(e) {
        if (e == null)
          return !0;
        if (Lt(e) && (ye(e) || typeof e == "string" || typeof e.splice == "function" || Fn(e) || wr(e) || Xn(e)))
          return !e.length;
        var t = wt(e);
        if (t == nn || t == rn)
          return !e.size;
        if (Yr(e))
          return !ta(e).length;
        for (var l in e)
          if (Me.call(e, l))
            return !1;
        return !0;
      }
      function Rm(e, t) {
        return Nr(e, t);
      }
      function Dm(e, t, l) {
        l = typeof l == "function" ? l : r;
        var a = l ? l(e, t) : r;
        return a === r ? Nr(e, t, r, l) : !!a;
      }
      function Ca(e) {
        if (!nt(e))
          return !1;
        var t = Tt(e);
        return t == fl || t == nd || typeof e.message == "string" && typeof e.name == "string" && !Xr(e);
      }
      function Pm(e) {
        return typeof e == "number" && as(e);
      }
      function Tn(e) {
        if (!et(e))
          return !1;
        var t = Tt(e);
        return t == vl || t == vo || t == td || t == ld;
      }
      function $u(e) {
        return typeof e == "number" && e == xe(e);
      }
      function ei(e) {
        return typeof e == "number" && e > -1 && e % 1 == 0 && e <= ke;
      }
      function et(e) {
        var t = typeof e;
        return e != null && (t == "object" || t == "function");
      }
      function nt(e) {
        return e != null && typeof e == "object";
      }
      var Cu = Wo ? zt(Wo) : zv;
      function Bm(e, t) {
        return e === t || ea(e, t, ga(t));
      }
      function Mm(e, t, l) {
        return l = typeof l == "function" ? l : r, ea(e, t, ga(t), l);
      }
      function Fm(e) {
        return ku(e) && e != +e;
      }
      function zm(e) {
        if (xp(e))
          throw new be(c);
        return ys(e);
      }
      function Um(e) {
        return e === null;
      }
      function Wm(e) {
        return e == null;
      }
      function ku(e) {
        return typeof e == "number" || nt(e) && Tt(e) == Lr;
      }
      function Xr(e) {
        if (!nt(e) || Tt(e) != gn)
          return !1;
        var t = Cl(e);
        if (t === null)
          return !0;
        var l = Me.call(t, "constructor") && t.constructor;
        return typeof l == "function" && l instanceof l && Sl.call(l) == Mf;
      }
      var ka = Ho ? zt(Ho) : Uv;
      function Hm(e) {
        return $u(e) && e >= -ke && e <= ke;
      }
      var Ou = qo ? zt(qo) : Wv;
      function ti(e) {
        return typeof e == "string" || !ye(e) && nt(e) && Tt(e) == Dr;
      }
      function Wt(e) {
        return typeof e == "symbol" || nt(e) && Tt(e) == pl;
      }
      var wr = Go ? zt(Go) : Hv;
      function qm(e) {
        return e === r;
      }
      function Gm(e) {
        return nt(e) && wt(e) == Pr;
      }
      function Vm(e) {
        return nt(e) && Tt(e) == ad;
      }
      var Nm = Vl(na), jm = Vl(function(e, t) {
        return e <= t;
      });
      function Eu(e) {
        if (!e)
          return [];
        if (Lt(e))
          return ti(e) ? ln(e) : At(e);
        if (Fr && e[Fr])
          return If(e[Fr]());
        var t = wt(e), l = t == nn ? qi : t == rn ? _l : xr;
        return l(e);
      }
      function In(e) {
        if (!e)
          return e === 0 ? e : 0;
        if (e = Jt(e), e === fe || e === -fe) {
          var t = e < 0 ? -1 : 1;
          return t * tt;
        }
        return e === e ? e : 0;
      }
      function xe(e) {
        var t = In(e), l = t % 1;
        return t === t ? l ? t - l : t : 0;
      }
      function Au(e) {
        return e ? jn(xe(e), 0, we) : 0;
      }
      function Jt(e) {
        if (typeof e == "number")
          return e;
        if (Wt(e))
          return Le;
        if (et(e)) {
          var t = typeof e.valueOf == "function" ? e.valueOf() : e;
          e = et(t) ? t + "" : t;
        }
        if (typeof e != "string")
          return e === 0 ? e : +e;
        e = Zo(e);
        var l = Cd.test(e);
        return l || Od.test(e) ? sf(e.slice(2), l ? 2 : 8) : $d.test(e) ? Le : +e;
      }
      function Lu(e) {
        return dn(e, Rt(e));
      }
      function Km(e) {
        return e ? jn(xe(e), -ke, ke) : e === 0 ? e : 0;
      }
      function Pe(e) {
        return e == null ? "" : Ut(e);
      }
      var Ym = br(function(e, t) {
        if (Yr(t) || Lt(t)) {
          dn(t, ct(t), e);
          return;
        }
        for (var l in t)
          Me.call(t, l) && qr(e, l, t[l]);
      }), Ru = br(function(e, t) {
        dn(t, Rt(t), e);
      }), ni = br(function(e, t, l, a) {
        dn(t, Rt(t), e, a);
      }), Zm = br(function(e, t, l, a) {
        dn(t, ct(t), e, a);
      }), Xm = xn(Yi);
      function Jm(e, t) {
        var l = gr(e);
        return t == null ? l : ds(l, t);
      }
      var Qm = Ie(function(e, t) {
        e = qe(e);
        var l = -1, a = t.length, f = a > 2 ? t[2] : r;
        for (f && It(t[0], t[1], f) && (a = 1); ++l < a; )
          for (var h = t[l], b = Rt(h), x = -1, C = b.length; ++x < C; ) {
            var V = b[x], N = e[V];
            (N === r || on(N, pr[V]) && !Me.call(e, V)) && (e[V] = h[V]);
          }
        return e;
      }), eg = Ie(function(e) {
        return e.push(r, Zs), Ft(Du, r, e);
      });
      function tg(e, t) {
        return No(e, he(t, 3), cn);
      }
      function ng(e, t) {
        return No(e, he(t, 3), Xi);
      }
      function rg(e, t) {
        return e == null ? e : Zi(e, he(t, 3), Rt);
      }
      function lg(e, t) {
        return e == null ? e : ms(e, he(t, 3), Rt);
      }
      function ig(e, t) {
        return e && cn(e, he(t, 3));
      }
      function ag(e, t) {
        return e && Xi(e, he(t, 3));
      }
      function og(e) {
        return e == null ? [] : Ml(e, ct(e));
      }
      function sg(e) {
        return e == null ? [] : Ml(e, Rt(e));
      }
      function Oa(e, t, l) {
        var a = e == null ? r : Kn(e, t);
        return a === r ? l : a;
      }
      function ug(e, t) {
        return e != null && Qs(e, t, Lv);
      }
      function Ea(e, t) {
        return e != null && Qs(e, t, Rv);
      }
      var cg = Vs(function(e, t, l) {
        t != null && typeof t.toString != "function" && (t = Tl.call(t)), e[t] = l;
      }, La(Dt)), dg = Vs(function(e, t, l) {
        t != null && typeof t.toString != "function" && (t = Tl.call(t)), Me.call(e, t) ? e[t].push(l) : e[t] = [l];
      }, he), fg = Ie(Vr);
      function ct(e) {
        return Lt(e) ? us(e) : ta(e);
      }
      function Rt(e) {
        return Lt(e) ? us(e, !0) : qv(e);
      }
      function vg(e, t) {
        var l = {};
        return t = he(t, 3), cn(e, function(a, f, h) {
          _n(l, t(a, f, h), a);
        }), l;
      }
      function pg(e, t) {
        var l = {};
        return t = he(t, 3), cn(e, function(a, f, h) {
          _n(l, f, t(a, f, h));
        }), l;
      }
      var hg = br(function(e, t, l) {
        Fl(e, t, l);
      }), Du = br(function(e, t, l, a) {
        Fl(e, t, l, a);
      }), mg = xn(function(e, t) {
        var l = {};
        if (e == null)
          return l;
        var a = !1;
        t = Je(t, function(h) {
          return h = Bn(h, e), a || (a = h.length > 1), h;
        }), dn(e, ha(e), l), a && (l = Yt(l, m | S | k, cp));
        for (var f = t.length; f--; )
          oa(l, t[f]);
        return l;
      });
      function gg(e, t) {
        return Pu(e, Ql(he(t)));
      }
      var bg = xn(function(e, t) {
        return e == null ? {} : Vv(e, t);
      });
      function Pu(e, t) {
        if (e == null)
          return {};
        var l = Je(ha(e), function(a) {
          return [a];
        });
        return t = he(t), $s(e, l, function(a, f) {
          return t(a, f[0]);
        });
      }
      function yg(e, t, l) {
        t = Bn(t, e);
        var a = -1, f = t.length;
        for (f || (f = 1, e = r); ++a < f; ) {
          var h = e == null ? r : e[fn(t[a])];
          h === r && (a = f, h = l), e = Tn(h) ? h.call(e) : h;
        }
        return e;
      }
      function _g(e, t, l) {
        return e == null ? e : jr(e, t, l);
      }
      function wg(e, t, l, a) {
        return a = typeof a == "function" ? a : r, e == null ? e : jr(e, t, l, a);
      }
      var Bu = Ks(ct), Mu = Ks(Rt);
      function xg(e, t, l) {
        var a = ye(e), f = a || Fn(e) || wr(e);
        if (t = he(t, 4), l == null) {
          var h = e && e.constructor;
          f ? l = a ? new h() : [] : et(e) ? l = Tn(h) ? gr(Cl(e)) : {} : l = {};
        }
        return (f ? Nt : cn)(e, function(b, x, C) {
          return t(l, b, x, C);
        }), l;
      }
      function Sg(e, t) {
        return e == null ? !0 : oa(e, t);
      }
      function Tg(e, t, l) {
        return e == null ? e : As(e, t, ca(l));
      }
      function Ig(e, t, l, a) {
        return a = typeof a == "function" ? a : r, e == null ? e : As(e, t, ca(l), a);
      }
      function xr(e) {
        return e == null ? [] : Hi(e, ct(e));
      }
      function $g(e) {
        return e == null ? [] : Hi(e, Rt(e));
      }
      function Cg(e, t, l) {
        return l === r && (l = t, t = r), l !== r && (l = Jt(l), l = l === l ? l : 0), t !== r && (t = Jt(t), t = t === t ? t : 0), jn(Jt(e), t, l);
      }
      function kg(e, t, l) {
        return t = In(t), l === r ? (l = t, t = 0) : l = In(l), e = Jt(e), Dv(e, t, l);
      }
      function Og(e, t, l) {
        if (l && typeof l != "boolean" && It(e, t, l) && (t = l = r), l === r && (typeof t == "boolean" ? (l = t, t = r) : typeof e == "boolean" && (l = e, e = r)), e === r && t === r ? (e = 0, t = 1) : (e = In(e), t === r ? (t = e, e = 0) : t = In(t)), e > t) {
          var a = e;
          e = t, t = a;
        }
        if (l || e % 1 || t % 1) {
          var f = os();
          return _t(e + f * (t - e + of("1e-" + ((f + "").length - 1))), t);
        }
        return la(e, t);
      }
      var Eg = yr(function(e, t, l) {
        return t = t.toLowerCase(), e + (l ? Fu(t) : t);
      });
      function Fu(e) {
        return Aa(Pe(e).toLowerCase());
      }
      function zu(e) {
        return e = Pe(e), e && e.replace(Ad, _f).replace(Zd, "");
      }
      function Ag(e, t, l) {
        e = Pe(e), t = Ut(t);
        var a = e.length;
        l = l === r ? a : jn(xe(l), 0, a);
        var f = l;
        return l -= t.length, l >= 0 && e.slice(l, f) == t;
      }
      function Lg(e) {
        return e = Pe(e), e && dd.test(e) ? e.replace(mo, wf) : e;
      }
      function Rg(e) {
        return e = Pe(e), e && gd.test(e) ? e.replace($i, "\\$&") : e;
      }
      var Dg = yr(function(e, t, l) {
        return e + (l ? "-" : "") + t.toLowerCase();
      }), Pg = yr(function(e, t, l) {
        return e + (l ? " " : "") + t.toLowerCase();
      }), Bg = Hs("toLowerCase");
      function Mg(e, t, l) {
        e = Pe(e), t = xe(t);
        var a = t ? fr(e) : 0;
        if (!t || a >= t)
          return e;
        var f = (t - a) / 2;
        return Gl(Al(f), l) + e + Gl(El(f), l);
      }
      function Fg(e, t, l) {
        e = Pe(e), t = xe(t);
        var a = t ? fr(e) : 0;
        return t && a < t ? e + Gl(t - a, l) : e;
      }
      function zg(e, t, l) {
        e = Pe(e), t = xe(t);
        var a = t ? fr(e) : 0;
        return t && a < t ? Gl(t - a, l) + e : e;
      }
      function Ug(e, t, l) {
        return l || t == null ? t = 0 : t && (t = +t), jf(Pe(e).replace(Ci, ""), t || 0);
      }
      function Wg(e, t, l) {
        return (l ? It(e, t, l) : t === r) ? t = 1 : t = xe(t), ia(Pe(e), t);
      }
      function Hg() {
        var e = arguments, t = Pe(e[0]);
        return e.length < 3 ? t : t.replace(e[1], e[2]);
      }
      var qg = yr(function(e, t, l) {
        return e + (l ? "_" : "") + t.toLowerCase();
      });
      function Gg(e, t, l) {
        return l && typeof l != "number" && It(e, t, l) && (t = l = r), l = l === r ? we : l >>> 0, l ? (e = Pe(e), e && (typeof t == "string" || t != null && !ka(t)) && (t = Ut(t), !t && dr(e)) ? Mn(ln(e), 0, l) : e.split(t, l)) : [];
      }
      var Vg = yr(function(e, t, l) {
        return e + (l ? " " : "") + Aa(t);
      });
      function Ng(e, t, l) {
        return e = Pe(e), l = l == null ? 0 : jn(xe(l), 0, e.length), t = Ut(t), e.slice(l, l + t.length) == t;
      }
      function jg(e, t, l) {
        var a = p.templateSettings;
        l && It(e, t, l) && (t = r), e = Pe(e), t = ni({}, t, a, Ys);
        var f = ni({}, t.imports, a.imports, Ys), h = ct(f), b = Hi(f, h), x, C, V = 0, N = t.interpolate || hl, j = "__p += '", ee = Gi(
          (t.escape || hl).source + "|" + N.source + "|" + (N === go ? Id : hl).source + "|" + (t.evaluate || hl).source + "|$",
          "g"
        ), ie = "//# sourceURL=" + (Me.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++tf + "]") + `
`;
        e.replace(ee, function(ge, $e, Ee, Ht, $t, qt) {
          return Ee || (Ee = Ht), j += e.slice(V, qt).replace(Ld, xf), $e && (x = !0, j += `' +
__e(` + $e + `) +
'`), $t && (C = !0, j += `';
` + $t + `;
__p += '`), Ee && (j += `' +
((__t = (` + Ee + `)) == null ? '' : __t) +
'`), V = qt + ge.length, ge;
        }), j += `';
`;
        var me = Me.call(t, "variable") && t.variable;
        if (!me)
          j = `with (obj) {
` + j + `
}
`;
        else if (Sd.test(me))
          throw new be(d);
        j = (C ? j.replace(od, "") : j).replace(sd, "$1").replace(ud, "$1;"), j = "function(" + (me || "obj") + `) {
` + (me ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (x ? ", __e = _.escape" : "") + (C ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + j + `return __p
}`;
        var Te = Wu(function() {
          return Re(h, ie + "return " + j).apply(r, b);
        });
        if (Te.source = j, Ca(Te))
          throw Te;
        return Te;
      }
      function Kg(e) {
        return Pe(e).toLowerCase();
      }
      function Yg(e) {
        return Pe(e).toUpperCase();
      }
      function Zg(e, t, l) {
        if (e = Pe(e), e && (l || t === r))
          return Zo(e);
        if (!e || !(t = Ut(t)))
          return e;
        var a = ln(e), f = ln(t), h = Xo(a, f), b = Jo(a, f) + 1;
        return Mn(a, h, b).join("");
      }
      function Xg(e, t, l) {
        if (e = Pe(e), e && (l || t === r))
          return e.slice(0, es(e) + 1);
        if (!e || !(t = Ut(t)))
          return e;
        var a = ln(e), f = Jo(a, ln(t)) + 1;
        return Mn(a, 0, f).join("");
      }
      function Jg(e, t, l) {
        if (e = Pe(e), e && (l || t === r))
          return e.replace(Ci, "");
        if (!e || !(t = Ut(t)))
          return e;
        var a = ln(e), f = Xo(a, ln(t));
        return Mn(a, f).join("");
      }
      function Qg(e, t) {
        var l = G, a = X;
        if (et(t)) {
          var f = "separator" in t ? t.separator : f;
          l = "length" in t ? xe(t.length) : l, a = "omission" in t ? Ut(t.omission) : a;
        }
        e = Pe(e);
        var h = e.length;
        if (dr(e)) {
          var b = ln(e);
          h = b.length;
        }
        if (l >= h)
          return e;
        var x = l - fr(a);
        if (x < 1)
          return a;
        var C = b ? Mn(b, 0, x).join("") : e.slice(0, x);
        if (f === r)
          return C + a;
        if (b && (x += C.length - x), ka(f)) {
          if (e.slice(x).search(f)) {
            var V, N = C;
            for (f.global || (f = Gi(f.source, Pe(bo.exec(f)) + "g")), f.lastIndex = 0; V = f.exec(N); )
              var j = V.index;
            C = C.slice(0, j === r ? x : j);
          }
        } else if (e.indexOf(Ut(f), x) != x) {
          var ee = C.lastIndexOf(f);
          ee > -1 && (C = C.slice(0, ee));
        }
        return C + a;
      }
      function eb(e) {
        return e = Pe(e), e && cd.test(e) ? e.replace(ho, Of) : e;
      }
      var tb = yr(function(e, t, l) {
        return e + (l ? " " : "") + t.toUpperCase();
      }), Aa = Hs("toUpperCase");
      function Uu(e, t, l) {
        return e = Pe(e), t = l ? r : t, t === r ? Tf(e) ? Lf(e) : hf(e) : e.match(t) || [];
      }
      var Wu = Ie(function(e, t) {
        try {
          return Ft(e, r, t);
        } catch (l) {
          return Ca(l) ? l : new be(l);
        }
      }), nb = xn(function(e, t) {
        return Nt(t, function(l) {
          l = fn(l), _n(e, l, Ia(e[l], e));
        }), e;
      });
      function rb(e) {
        var t = e == null ? 0 : e.length, l = he();
        return e = t ? Je(e, function(a) {
          if (typeof a[1] != "function")
            throw new jt(s);
          return [l(a[0]), a[1]];
        }) : [], Ie(function(a) {
          for (var f = -1; ++f < t; ) {
            var h = e[f];
            if (Ft(h[0], this, a))
              return Ft(h[1], this, a);
          }
        });
      }
      function lb(e) {
        return Ov(Yt(e, m));
      }
      function La(e) {
        return function() {
          return e;
        };
      }
      function ib(e, t) {
        return e == null || e !== e ? t : e;
      }
      var ab = Gs(), ob = Gs(!0);
      function Dt(e) {
        return e;
      }
      function Ra(e) {
        return _s(typeof e == "function" ? e : Yt(e, m));
      }
      function sb(e) {
        return xs(Yt(e, m));
      }
      function ub(e, t) {
        return Ss(e, Yt(t, m));
      }
      var cb = Ie(function(e, t) {
        return function(l) {
          return Vr(l, e, t);
        };
      }), db = Ie(function(e, t) {
        return function(l) {
          return Vr(e, l, t);
        };
      });
      function Da(e, t, l) {
        var a = ct(t), f = Ml(t, a);
        l == null && !(et(t) && (f.length || !a.length)) && (l = t, t = e, e = this, f = Ml(t, ct(t)));
        var h = !(et(l) && "chain" in l) || !!l.chain, b = Tn(e);
        return Nt(f, function(x) {
          var C = t[x];
          e[x] = C, b && (e.prototype[x] = function() {
            var V = this.__chain__;
            if (h || V) {
              var N = e(this.__wrapped__), j = N.__actions__ = At(this.__actions__);
              return j.push({ func: C, args: arguments, thisArg: e }), N.__chain__ = V, N;
            }
            return C.apply(e, An([this.value()], arguments));
          });
        }), e;
      }
      function fb() {
        return mt._ === this && (mt._ = Ff), this;
      }
      function Pa() {
      }
      function vb(e) {
        return e = xe(e), Ie(function(t) {
          return Ts(t, e);
        });
      }
      var pb = fa(Je), hb = fa(Vo), mb = fa(Mi);
      function Hu(e) {
        return ya(e) ? Fi(fn(e)) : Nv(e);
      }
      function gb(e) {
        return function(t) {
          return e == null ? r : Kn(e, t);
        };
      }
      var bb = Ns(), yb = Ns(!0);
      function Ba() {
        return [];
      }
      function Ma() {
        return !1;
      }
      function _b() {
        return {};
      }
      function wb() {
        return "";
      }
      function xb() {
        return !0;
      }
      function Sb(e, t) {
        if (e = xe(e), e < 1 || e > ke)
          return [];
        var l = we, a = _t(e, we);
        t = he(t), e -= we;
        for (var f = Wi(a, t); ++l < e; )
          t(l);
        return f;
      }
      function Tb(e) {
        return ye(e) ? Je(e, fn) : Wt(e) ? [e] : At(su(Pe(e)));
      }
      function Ib(e) {
        var t = ++Bf;
        return Pe(e) + t;
      }
      var $b = ql(function(e, t) {
        return e + t;
      }, 0), Cb = va("ceil"), kb = ql(function(e, t) {
        return e / t;
      }, 1), Ob = va("floor");
      function Eb(e) {
        return e && e.length ? Bl(e, Dt, Ji) : r;
      }
      function Ab(e, t) {
        return e && e.length ? Bl(e, he(t, 2), Ji) : r;
      }
      function Lb(e) {
        return Ko(e, Dt);
      }
      function Rb(e, t) {
        return Ko(e, he(t, 2));
      }
      function Db(e) {
        return e && e.length ? Bl(e, Dt, na) : r;
      }
      function Pb(e, t) {
        return e && e.length ? Bl(e, he(t, 2), na) : r;
      }
      var Bb = ql(function(e, t) {
        return e * t;
      }, 1), Mb = va("round"), Fb = ql(function(e, t) {
        return e - t;
      }, 0);
      function zb(e) {
        return e && e.length ? Ui(e, Dt) : 0;
      }
      function Ub(e, t) {
        return e && e.length ? Ui(e, he(t, 2)) : 0;
      }
      return p.after = sm, p.ary = yu, p.assign = Ym, p.assignIn = Ru, p.assignInWith = ni, p.assignWith = Zm, p.at = Xm, p.before = _u, p.bind = Ia, p.bindAll = nb, p.bindKey = wu, p.castArray = _m, p.chain = mu, p.chunk = Op, p.compact = Ep, p.concat = Ap, p.cond = rb, p.conforms = lb, p.constant = La, p.countBy = zh, p.create = Jm, p.curry = xu, p.curryRight = Su, p.debounce = Tu, p.defaults = Qm, p.defaultsDeep = eg, p.defer = um, p.delay = cm, p.difference = Lp, p.differenceBy = Rp, p.differenceWith = Dp, p.drop = Pp, p.dropRight = Bp, p.dropRightWhile = Mp, p.dropWhile = Fp, p.fill = zp, p.filter = Wh, p.flatMap = Gh, p.flatMapDeep = Vh, p.flatMapDepth = Nh, p.flatten = fu, p.flattenDeep = Up, p.flattenDepth = Wp, p.flip = dm, p.flow = ab, p.flowRight = ob, p.fromPairs = Hp, p.functions = og, p.functionsIn = sg, p.groupBy = jh, p.initial = Gp, p.intersection = Vp, p.intersectionBy = Np, p.intersectionWith = jp, p.invert = cg, p.invertBy = dg, p.invokeMap = Yh, p.iteratee = Ra, p.keyBy = Zh, p.keys = ct, p.keysIn = Rt, p.map = Zl, p.mapKeys = vg, p.mapValues = pg, p.matches = sb, p.matchesProperty = ub, p.memoize = Jl, p.merge = hg, p.mergeWith = Du, p.method = cb, p.methodOf = db, p.mixin = Da, p.negate = Ql, p.nthArg = vb, p.omit = mg, p.omitBy = gg, p.once = fm, p.orderBy = Xh, p.over = pb, p.overArgs = vm, p.overEvery = hb, p.overSome = mb, p.partial = $a, p.partialRight = Iu, p.partition = Jh, p.pick = bg, p.pickBy = Pu, p.property = Hu, p.propertyOf = gb, p.pull = Xp, p.pullAll = pu, p.pullAllBy = Jp, p.pullAllWith = Qp, p.pullAt = eh, p.range = bb, p.rangeRight = yb, p.rearg = pm, p.reject = tm, p.remove = th, p.rest = hm, p.reverse = Sa, p.sampleSize = rm, p.set = _g, p.setWith = wg, p.shuffle = lm, p.slice = nh, p.sortBy = om, p.sortedUniq = uh, p.sortedUniqBy = ch, p.split = Gg, p.spread = mm, p.tail = dh, p.take = fh, p.takeRight = vh, p.takeRightWhile = ph, p.takeWhile = hh, p.tap = Eh, p.throttle = gm, p.thru = Yl, p.toArray = Eu, p.toPairs = Bu, p.toPairsIn = Mu, p.toPath = Tb, p.toPlainObject = Lu, p.transform = xg, p.unary = bm, p.union = mh, p.unionBy = gh, p.unionWith = bh, p.uniq = yh, p.uniqBy = _h, p.uniqWith = wh, p.unset = Sg, p.unzip = Ta, p.unzipWith = hu, p.update = Tg, p.updateWith = Ig, p.values = xr, p.valuesIn = $g, p.without = xh, p.words = Uu, p.wrap = ym, p.xor = Sh, p.xorBy = Th, p.xorWith = Ih, p.zip = $h, p.zipObject = Ch, p.zipObjectDeep = kh, p.zipWith = Oh, p.entries = Bu, p.entriesIn = Mu, p.extend = Ru, p.extendWith = ni, Da(p, p), p.add = $b, p.attempt = Wu, p.camelCase = Eg, p.capitalize = Fu, p.ceil = Cb, p.clamp = Cg, p.clone = wm, p.cloneDeep = Sm, p.cloneDeepWith = Tm, p.cloneWith = xm, p.conformsTo = Im, p.deburr = zu, p.defaultTo = ib, p.divide = kb, p.endsWith = Ag, p.eq = on, p.escape = Lg, p.escapeRegExp = Rg, p.every = Uh, p.find = Hh, p.findIndex = cu, p.findKey = tg, p.findLast = qh, p.findLastIndex = du, p.findLastKey = ng, p.floor = Ob, p.forEach = gu, p.forEachRight = bu, p.forIn = rg, p.forInRight = lg, p.forOwn = ig, p.forOwnRight = ag, p.get = Oa, p.gt = $m, p.gte = Cm, p.has = ug, p.hasIn = Ea, p.head = vu, p.identity = Dt, p.includes = Kh, p.indexOf = qp, p.inRange = kg, p.invoke = fg, p.isArguments = Xn, p.isArray = ye, p.isArrayBuffer = km, p.isArrayLike = Lt, p.isArrayLikeObject = rt, p.isBoolean = Om, p.isBuffer = Fn, p.isDate = Em, p.isElement = Am, p.isEmpty = Lm, p.isEqual = Rm, p.isEqualWith = Dm, p.isError = Ca, p.isFinite = Pm, p.isFunction = Tn, p.isInteger = $u, p.isLength = ei, p.isMap = Cu, p.isMatch = Bm, p.isMatchWith = Mm, p.isNaN = Fm, p.isNative = zm, p.isNil = Wm, p.isNull = Um, p.isNumber = ku, p.isObject = et, p.isObjectLike = nt, p.isPlainObject = Xr, p.isRegExp = ka, p.isSafeInteger = Hm, p.isSet = Ou, p.isString = ti, p.isSymbol = Wt, p.isTypedArray = wr, p.isUndefined = qm, p.isWeakMap = Gm, p.isWeakSet = Vm, p.join = Kp, p.kebabCase = Dg, p.last = Xt, p.lastIndexOf = Yp, p.lowerCase = Pg, p.lowerFirst = Bg, p.lt = Nm, p.lte = jm, p.max = Eb, p.maxBy = Ab, p.mean = Lb, p.meanBy = Rb, p.min = Db, p.minBy = Pb, p.stubArray = Ba, p.stubFalse = Ma, p.stubObject = _b, p.stubString = wb, p.stubTrue = xb, p.multiply = Bb, p.nth = Zp, p.noConflict = fb, p.noop = Pa, p.now = Xl, p.pad = Mg, p.padEnd = Fg, p.padStart = zg, p.parseInt = Ug, p.random = Og, p.reduce = Qh, p.reduceRight = em, p.repeat = Wg, p.replace = Hg, p.result = yg, p.round = Mb, p.runInContext = I, p.sample = nm, p.size = im, p.snakeCase = qg, p.some = am, p.sortedIndex = rh, p.sortedIndexBy = lh, p.sortedIndexOf = ih, p.sortedLastIndex = ah, p.sortedLastIndexBy = oh, p.sortedLastIndexOf = sh, p.startCase = Vg, p.startsWith = Ng, p.subtract = Fb, p.sum = zb, p.sumBy = Ub, p.template = jg, p.times = Sb, p.toFinite = In, p.toInteger = xe, p.toLength = Au, p.toLower = Kg, p.toNumber = Jt, p.toSafeInteger = Km, p.toString = Pe, p.toUpper = Yg, p.trim = Zg, p.trimEnd = Xg, p.trimStart = Jg, p.truncate = Qg, p.unescape = eb, p.uniqueId = Ib, p.upperCase = tb, p.upperFirst = Aa, p.each = gu, p.eachRight = bu, p.first = vu, Da(p, function() {
        var e = {};
        return cn(p, function(t, l) {
          Me.call(p.prototype, l) || (e[l] = t);
        }), e;
      }(), { chain: !1 }), p.VERSION = u, Nt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
        p[e].placeholder = p;
      }), Nt(["drop", "take"], function(e, t) {
        Oe.prototype[e] = function(l) {
          l = l === r ? 1 : ot(xe(l), 0);
          var a = this.__filtered__ && !t ? new Oe(this) : this.clone();
          return a.__filtered__ ? a.__takeCount__ = _t(l, a.__takeCount__) : a.__views__.push({
            size: _t(l, we),
            type: e + (a.__dir__ < 0 ? "Right" : "")
          }), a;
        }, Oe.prototype[e + "Right"] = function(l) {
          return this.reverse()[e](l).reverse();
        };
      }), Nt(["filter", "map", "takeWhile"], function(e, t) {
        var l = t + 1, a = l == Ce || l == te;
        Oe.prototype[e] = function(f) {
          var h = this.clone();
          return h.__iteratees__.push({
            iteratee: he(f, 3),
            type: l
          }), h.__filtered__ = h.__filtered__ || a, h;
        };
      }), Nt(["head", "last"], function(e, t) {
        var l = "take" + (t ? "Right" : "");
        Oe.prototype[e] = function() {
          return this[l](1).value()[0];
        };
      }), Nt(["initial", "tail"], function(e, t) {
        var l = "drop" + (t ? "" : "Right");
        Oe.prototype[e] = function() {
          return this.__filtered__ ? new Oe(this) : this[l](1);
        };
      }), Oe.prototype.compact = function() {
        return this.filter(Dt);
      }, Oe.prototype.find = function(e) {
        return this.filter(e).head();
      }, Oe.prototype.findLast = function(e) {
        return this.reverse().find(e);
      }, Oe.prototype.invokeMap = Ie(function(e, t) {
        return typeof e == "function" ? new Oe(this) : this.map(function(l) {
          return Vr(l, e, t);
        });
      }), Oe.prototype.reject = function(e) {
        return this.filter(Ql(he(e)));
      }, Oe.prototype.slice = function(e, t) {
        e = xe(e);
        var l = this;
        return l.__filtered__ && (e > 0 || t < 0) ? new Oe(l) : (e < 0 ? l = l.takeRight(-e) : e && (l = l.drop(e)), t !== r && (t = xe(t), l = t < 0 ? l.dropRight(-t) : l.take(t - e)), l);
      }, Oe.prototype.takeRightWhile = function(e) {
        return this.reverse().takeWhile(e).reverse();
      }, Oe.prototype.toArray = function() {
        return this.take(we);
      }, cn(Oe.prototype, function(e, t) {
        var l = /^(?:filter|find|map|reject)|While$/.test(t), a = /^(?:head|last)$/.test(t), f = p[a ? "take" + (t == "last" ? "Right" : "") : t], h = a || /^find/.test(t);
        f && (p.prototype[t] = function() {
          var b = this.__wrapped__, x = a ? [1] : arguments, C = b instanceof Oe, V = x[0], N = C || ye(b), j = function($e) {
            var Ee = f.apply(p, An([$e], x));
            return a && ee ? Ee[0] : Ee;
          };
          N && l && typeof V == "function" && V.length != 1 && (C = N = !1);
          var ee = this.__chain__, ie = !!this.__actions__.length, me = h && !ee, Te = C && !ie;
          if (!h && N) {
            b = Te ? b : new Oe(this);
            var ge = e.apply(b, x);
            return ge.__actions__.push({ func: Yl, args: [j], thisArg: r }), new Kt(ge, ee);
          }
          return me && Te ? e.apply(this, x) : (ge = this.thru(j), me ? a ? ge.value()[0] : ge.value() : ge);
        });
      }), Nt(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
        var t = wl[e], l = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", a = /^(?:pop|shift)$/.test(e);
        p.prototype[e] = function() {
          var f = arguments;
          if (a && !this.__chain__) {
            var h = this.value();
            return t.apply(ye(h) ? h : [], f);
          }
          return this[l](function(b) {
            return t.apply(ye(b) ? b : [], f);
          });
        };
      }), cn(Oe.prototype, function(e, t) {
        var l = p[t];
        if (l) {
          var a = l.name + "";
          Me.call(mr, a) || (mr[a] = []), mr[a].push({ name: t, func: l });
        }
      }), mr[Hl(r, Y).name] = [{
        name: "wrapper",
        func: r
      }], Oe.prototype.clone = ev, Oe.prototype.reverse = tv, Oe.prototype.value = nv, p.prototype.at = Ah, p.prototype.chain = Lh, p.prototype.commit = Rh, p.prototype.next = Dh, p.prototype.plant = Bh, p.prototype.reverse = Mh, p.prototype.toJSON = p.prototype.valueOf = p.prototype.value = Fh, p.prototype.first = p.prototype.head, Fr && (p.prototype[Fr] = Ph), p;
    }, vr = Rf();
    qn ? ((qn.exports = vr)._ = vr, Ri._ = vr) : mt._ = vr;
  }).call(tl);
})(fi, fi.exports);
var bx = fi.exports, ui = /* @__PURE__ */ ((n) => (n.icon = "icon", n.numeric = "numeric", n.default = "default", n))(ui || {});
const yx = (n) => (Kb("data-v-8f86ae33"), n = n(), Yb(), n), _x = { class: "tabs" }, wx = { class: "tabs__wrapper" }, xx = { class: "t-title-lg" }, Sx = { class: "tabs__tab" }, Tx = {
  key: 0,
  class: "t-body-sm text-neutral-50 pt-0.5"
}, Ix = {
  key: 1,
  class: "t-body-sm text-neutral-50 pt-1"
}, $x = {
  key: 0,
  class: "tabs__content"
}, Cx = { class: "compact-tabs" }, kx = { class: "compact-tabs__title" }, Ox = { class: "compact-tabs__wrapper" }, Ex = /* @__PURE__ */ yx(() => /* @__PURE__ */ F("div", { class: "w-full border-solid border-t-1 border-neutral-30" }, null, -1)), Ax = {
  key: 0,
  class: "compact-tabs__content mt-6 md:hidden"
}, Lx = /* @__PURE__ */ Q({
  __name: "Tabs",
  props: {
    title: { default: "Tabs" },
    tabs: { default: () => [] },
    initialSelectedTab: { default: 0 },
    isSticky: { type: Boolean, default: !1 },
    unpinTabsText: { default: "Unpin Tabs" },
    listType: { default: ui.numeric }
  },
  emits: ["changeTab", "toggleSticky"],
  setup(n, { emit: i }) {
    const r = n, u = B(r.initialSelectedTab), o = B(!1), c = B(r.tabs[0]), s = B(r.isSticky), d = B(50), g = B([]), y = B({
      top: "0px",
      height: "0px"
    }), _ = i, m = $(() => r.listType === ui.numeric), S = $(() => r.listType === ui.icon), k = Cr(), A = $(() => r.tabs.some((R) => !!k[R.id])), L = $(() => {
      const R = r.tabs.map((q) => ({
        href: `#${q.id}`,
        label: q.label
      }));
      return {
        variant: "drawer",
        showItems: o.value,
        items: R,
        theme: "light",
        highlight: !0,
        activeState: !0,
        size: "lg"
      };
    }), z = (R) => R + 1 > 9 ? R + 1 : `0${R + 1}`, Y = (R) => {
      u.value = R, M();
      const q = r == null ? void 0 : r.tabs[R];
      _("changeTab", q.id);
    }, D = () => {
      s.value = !s.value, _("toggleSticky");
    }, O = (R) => {
      c.value = R;
    }, E = () => {
      o.value = !o.value;
    }, w = (R) => R.length > d.value ? `${R.slice(0, d.value)}...` : R, M = () => {
      var X;
      const R = u.value, q = (X = g.value[R]) == null ? void 0 : X.el;
      if (!q)
        return;
      const G = q.getBoundingClientRect();
      y.value = {
        top: `${q.offsetTop}px`,
        height: `${G.height}px`
      };
    }, W = bx.debounce(() => {
      M(), window.innerWidth < 375 ? d.value = 20 : window.innerWidth < 640 ? d.value = 30 : d.value = 50;
    }, 300);
    return vt(() => r.initialSelectedTab, (R, q) => {
      R !== q && (u.value = R, M());
    }), Ae(() => {
      M(), window.addEventListener("resize", W);
    }), yt(() => {
      window.removeEventListener("resize", W);
    }), (R, q) => (T(), U(Be, null, [
      F("div", _x, [
        se(v(m_), {
          vertical: "",
          as: "nav",
          selectedIndex: u.value,
          onChange: Y
        }, {
          default: ne(() => [
            F("div", wx, [
              se(v(g_), {
                class: K([
                  "tabs__list",
                  {
                    "col-span-4": A.value,
                    "col-span-12": !A.value,
                    "tabs__list--sticky": s.value
                  }
                ])
              }, {
                default: ne(() => [
                  F("h2", xx, re(R.title), 1),
                  F("div", Sx, [
                    F("div", {
                      class: "tabs__tab__selector",
                      style: kn(y.value)
                    }, null, 4),
                    (T(!0), U(Be, null, Ye(R.tabs, (G, X) => (T(), ce(v(b_), {
                      as: "a",
                      ref_for: !0,
                      ref_key: "refTab",
                      ref: g,
                      class: "tabs__tab__item",
                      id: `headless-${G.id}`,
                      href: G == null ? void 0 : G.href,
                      key: G.id
                    }, {
                      default: ne(({ selected: ve }) => [
                        F("div", {
                          class: K(
                            [
                              "tabs__tab__item__wrapper",
                              { "tabs__tab__item--selected": ve }
                            ]
                          )
                        }, [
                          m.value ? (T(), U("span", Tx, re(z(X)), 1)) : S.value ? (T(), U("span", Ix, [
                            se(v(kt), {
                              size: v(ft).lg,
                              "icon-name": G.iconName
                            }, null, 8, ["size", "icon-name"])
                          ])) : ae("", !0),
                          F("span", {
                            class: K([
                              "tabs__tab__item__label",
                              { "tabs__tab__item__label--selected": ve }
                            ])
                          }, re(G.label), 3)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["id", "href"]))), 128))
                  ]),
                  se(v(Xe), {
                    variant: v(je).tertiary,
                    color: v(We).neutral,
                    size: v(Ue).sm,
                    class: "t-body-sm",
                    "no-icon": !0,
                    onClick: D
                  }, {
                    default: ne(() => [
                      Ke(re(R.unpinTabsText), 1)
                    ]),
                    _: 1
                  }, 8, ["variant", "color", "size"])
                ]),
                _: 1
              }, 8, ["class"]),
              A.value ? (T(), U("div", $x, [
                (T(!0), U(Be, null, Ye(R.tabs, (G) => ue(R.$slots, G.id, {
                  key: G.id
                }, void 0, !0)), 128))
              ])) : ae("", !0)
            ])
          ]),
          _: 3
        }, 8, ["selectedIndex"])
      ]),
      F("nav", Cx, [
        F("h2", kx, re(R.title), 1),
        F("div", Ox, [
          se(v(Xc), {
            class: "compact-tabs__nav-item",
            ref: "tabItem",
            variant: L.value.variant,
            label: w(c.value.label),
            "show-items": L.value.showItems,
            items: L.value.items,
            theme: L.value.theme,
            highlight: L.value.highlight,
            "active-state": L.value.activeState,
            "top-selected": !0,
            size: L.value.size,
            onClick: E,
            onItemSelected: O
          }, null, 8, ["variant", "label", "show-items", "items", "theme", "highlight", "active-state", "size"]),
          Ex
        ])
      ]),
      A.value ? (T(), U("div", Ax, [
        (T(!0), U(Be, null, Ye(R.tabs, (G) => ue(R.$slots, G.id, {
          key: G.id
        }, void 0, !0)), 128))
      ])) : ae("", !0)
    ], 64));
  }
}), sS = /* @__PURE__ */ _e(Lx, [["__scopeId", "data-v-8f86ae33"]]);
var Qc = /* @__PURE__ */ ((n) => (n.dark = "dark", n.mid = "mid", n.light = "light", n))(Qc || {});
const Rx = /* @__PURE__ */ Q({
  __name: "Chip",
  props: {
    variant: {
      type: String,
      required: !0,
      default: "top"
    },
    theme: {
      type: String,
      validator: (n) => Object.values(Qc).includes(n),
      default: "light"
      /* light */
    },
    active: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(n) {
    const i = n, r = $(() => i.variant === "top" && i.active), u = $(() => i.variant === "bottom");
    return (o, c) => (T(), U("button", {
      class: K([
        "chip",
        `chip--${i.theme}`,
        i.variant,
        i.active ? "active" : ""
      ])
    }, [
      r.value ? (T(), ce(v(kt), {
        key: 0,
        size: v(ft).lg,
        "icon-name": v(Z).check
      }, null, 8, ["size", "icon-name"])) : ae("", !0),
      ue(o.$slots, "default", {}, void 0, !0),
      u.value ? (T(), ce(v(kt), {
        key: 1,
        size: v(ft).sm,
        "icon-name": v(Z).close
      }, null, 8, ["size", "icon-name"])) : ae("", !0)
    ], 2));
  }
}), uS = /* @__PURE__ */ _e(Rx, [["__scopeId", "data-v-49f82a0c"]]), Dx = { class: "animated-title" }, Px = { class: "t-title-sm" }, sc = 44, Bx = /* @__PURE__ */ Q({
  __name: "AnimatedCard",
  props: {
    textColor: {
      type: String,
      default: "light"
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    images: {
      type: Object,
      default: null
    },
    cardHref: {
      type: String,
      default: ""
    },
    cardTarget: {
      type: String,
      default: "",
      validator(n) {
        return ["_self", "_blank"].includes(n);
      }
    }
  },
  setup(n) {
    Hn((L) => ({
      "99d1c57e": s.value
    }));
    const i = n, r = {
      dark: "text-neutral-2",
      mid: "text-neutral-80",
      light: "text-neutral-80"
    }, u = B(null), o = B(null), c = i.cardHref ? 18 : -26, s = B("0px"), d = B(!1), g = B(!1), y = B(sc);
    function _() {
      if (o.value) {
        const L = window.getComputedStyle(o.value), z = parseFloat(L.marginTop || "0"), Y = parseFloat(L.marginBottom || "0");
        y.value = sc + z + Y;
      }
    }
    function m() {
      var L;
      _(), s.value = (L = u.value) != null && L.scrollHeight ? `${u.value.scrollHeight + c + y.value}px` : "0px";
    }
    function S() {
      g.value || (d.value = !d.value);
    }
    const k = $(() => ({
      "--b1": `url(${i.images.imageA})`,
      "--b2": `url(${i.images.imageB})`
    })), A = $(
      () => i.cardHref ? {
        is: "a",
        href: i.cardHref,
        role: "link",
        target: i.cardTarget
      } : {
        is: "div",
        role: "article"
      }
    );
    return Ae(() => {
      var L;
      _(), s.value = (L = u.value) != null && L.scrollHeight ? `${u.value.scrollHeight + c + y.value}px` : "0px", window.addEventListener("resize", m);
    }), vi(() => {
      window.removeEventListener("resize", m);
    }), (L, z) => (T(), U("div", {
      class: "animated-container",
      style: kn(k.value)
    }, [
      (T(), ce(en(A.value.is), hn(L.$attrs, {
        tabindex: "0",
        class: [
          "animated-card",
          {
            "animated-card--clickable": n.cardHref
          },
          r[i.textColor]
        ],
        href: A.value.href,
        role: A.value.role,
        target: A.value.target,
        onMouseenter: S,
        onMouseleave: S
      }), {
        default: ne(() => [
          F("div", {
            class: K(["animated-card--content", r[i.textColor]])
          }, [
            F("div", Dx, [
              F("h3", Px, re(i.title), 1),
              se(v(kt), {
                class: "animated-icon",
                size: v(ft).md,
                iconName: d.value ? v(Z).caretDown : v(Z).caretUp
              }, null, 8, ["size", "iconName"])
            ]),
            F("p", {
              class: "t-body-md",
              ref_key: "descRef",
              ref: u
            }, re(i.description), 513),
            n.cardHref ? (T(), U("div", {
              key: 0,
              class: K(`${n.cardHref ? "animated-card__cta" : ""}`),
              ref_key: "ctaRef",
              ref: o
            }, [
              ue(L.$slots, "cta")
            ], 2)) : ae("", !0)
          ], 2)
        ]),
        _: 3
      }, 16, ["class", "href", "role", "target"]))
    ], 4));
  }
}), cS = /* @__PURE__ */ _e(Bx, [["__scopeId", "data-v-63d05273"]]);
var ed = /* @__PURE__ */ ((n) => (n.xl = "xl", n.lg = "lg", n.md = "md", n.sm = "sm", n))(ed || {});
const Mx = {
  key: 0,
  class: "social-share__popover absolute left-1/2 top-full mt-2 w-24 -translate-x-1/2 rounded-lg bg-neutral-80 text-white text-sm p-2 shadow-lg z-50 text-center font-['Intrinsic'] text-body-sm font-light"
}, Qa = B({}), si = B({}), Fx = (n) => {
  window.open(n, "popup", "width=600,height=600,noopener=true");
}, zx = (n, i) => {
  const r = new URL(n);
  r.searchParams.set("utm_medium", "referral"), r.searchParams.set("utm_campaign", "linkshare"), r.searchParams.set("utm_source", "link"), navigator.clipboard.writeText(r.toString()).then(() => {
    Ux(i);
  }).catch((u) => {
    console.error("Failed to copy:", u);
  });
}, Ux = (n) => {
  Qa.value[n] = !0, si.value[n] && clearTimeout(si.value[n]), si.value[n] = window.setTimeout(() => {
    Qa.value[n] = !1, delete si.value[n];
  }, 3e3);
}, Wx = /* @__PURE__ */ Q({
  __name: "SocialShare",
  props: {
    title: {},
    url: {},
    size: { default: "xl" },
    theme: { default: Qt.light }
  },
  setup(n) {
    const i = n, r = $(() => ({
      light: We.neutral,
      mid: We.neutral,
      dark: We.white
    })), u = $(() => [
      {
        name: "x",
        icon: "x",
        url: `https://twitter.com/intent/tweet?text=${i.title}&url=${i.url}`,
        altText: "Twitter"
      },
      {
        name: "facebook",
        icon: "facebook",
        url: `https://www.facebook.com/sharer/sharer.php?u=${i.url}`,
        altText: "Facebook"
      },
      {
        name: "linkedIn",
        icon: "linkedin",
        url: `http://www.linkedin.com/shareArticle?mini=true&url=${i.url}`,
        altText: "LinkedIn"
      },
      {
        name: "link-angle",
        icon: "link",
        altText: "Copy link",
        label: "Link Copied"
      }
    ]);
    return (o, c) => (T(), U("div", {
      class: K([
        "social-share",
        "flex gap-2",
        `social-share--${o.theme}`
      ])
    }, [
      (T(!0), U(Be, null, Ye(u.value, (s) => (T(), U("div", {
        key: s.name,
        class: "relative"
      }, [
        se(v(Xe), {
          class: K([[
            `social-share__button--${v(ed)[o.size]}`
          ], "social-share__button p-0 rounded-full flex justify-center items-center"]),
          variant: v(je).secondary,
          color: r.value[o.theme],
          size: v(Ue)[o.size],
          "icon-only": !0,
          animated: !1,
          title: s.altText,
          "icon-name": v(Z)[s.icon],
          onClick: (d) => s.url ? Fx(s.url) : zx(o.url, s.name)
        }, null, 8, ["class", "variant", "color", "size", "title", "icon-name", "onClick"]),
        !s.url && Qa.value[s.name] ? (T(), U("div", Mx, re(s.label), 1)) : ae("", !0)
      ]))), 128))
    ], 2));
  }
}), dS = /* @__PURE__ */ _e(Wx, [["__scopeId", "data-v-fe65b31d"]]);
import("./300-DyGci-pt.mjs");
import("./600-DQ8T0sHi.mjs");
export {
  Mt as $,
  sS as A,
  Y0 as B,
  Nx as C,
  lS as D,
  uS as E,
  qx as F,
  cS as G,
  dS as H,
  Qw as I,
  Ue as J,
  je as K,
  di as L,
  oS as M,
  Nw as N,
  We as O,
  ey as P,
  iS as Q,
  eo as R,
  Iw as S,
  ay as T,
  ft as U,
  Z as V,
  ju as W,
  il as X,
  Ha as Y,
  ir as Z,
  jx as _,
  Ku as a,
  Pt as a0,
  kr as a1,
  Bt as a2,
  Gt as a3,
  o0 as a4,
  Ne as a5,
  Fe as a6,
  Sr as a7,
  Ry as a8,
  Dy as a9,
  Py as aa,
  to as ab,
  Ja as ac,
  Zc as ad,
  eS as ae,
  Tr as af,
  nl as ag,
  vn as ah,
  ui as ai,
  ed as aj,
  oc as b,
  Aw as c,
  ix as d,
  Xe as e,
  pc as f,
  kt as g,
  St as h,
  al as i,
  nr as j,
  Gx as k,
  pi as l,
  Vx as m,
  Kx as n,
  Yx as o,
  Wy as p,
  Xx as q,
  Jx as r,
  Qx as s,
  tS as t,
  nS as u,
  rS as v,
  Xc as w,
  h0 as x,
  aS as y,
  Or as z
};
